export default {
  languageType: "ur",
  lang: "ur",
  welcome: "خوش آمدید",
  select_your_language: "اپنی زبان کا انتخاب کریں",

  purany_reg_ko_choren: "پرانے رجسٹر کو چھورین",
  ab_saara_hisaab_phone_pei: "اب سارہ حیساب موبائل پے۔",
  lets_get_started_for_free: "آئیے مفت میں شروعات کریں",
  get_started: "شروع کریں",
  login: "لاگ ان",
  coming_soon: "جلد آرہا ہے",

  business_updated_success: "بزنس نام اپڈیٹ ہوگیا",

  phone_number_placeholder: "موبائل نمبر",
  whats_your_phone_number: "آپ کا موبائل نمبر کیا ہے",
  we_will_send_you_verification_code: "ہم آپ کو ایک تصدیقی کوڈ کوڈ بھیجیں گے",
  resend_code_in: "کوڈ دوبارہ بھیجنے میں",
  enter_your_verification_code: "تصدیقی کوڈ درج کریں",
  we_have_sent_a_verification_code_to: "ہم نے تصدیقی کوڈ بھیجا ہے۔",
  timeout_message:
    "آپ کے ڈیٹا کو بحال کرنے میں کچھ مسئلہ ہے ، براہ کرم دوبارہ لاگ ان کریں",
  verification_code: "تصدیقی کوڈ",
  no_internet_please_login_again:
    "انٹرنیٹ نہیں ہے ، براہ کرم دوبارہ لاگ ان کریں",
  i_didnt_get_a_code: "مجھے کوڈ نہیں ملا!",
  invalid_code: "غلط کوڈ",
  resend_code: "کوڈ دوبارہ بھیجیں۔",
  having_trouble: "پریشانی ہو رہی ہے؟ کال ملایں",
  call_us: "کال کریں۔",
  view_report: "رپورٹ دیکھے",

  create_customer_to: "کسٹمر بنائیں اور",
  to_give_udhaar: "اُدھار دیں",
  create_customer: "کسٹمر بنائیں",
  how_to_add_a_new_customer: "نیا کسٹمر کیسے بناءیں؟",
  learn_how_to_use_oscar_udhaar: "آسکر اودھار استعمال کرنے کا طریقہ سیکھیں",
  watch_video: "ویڈیو دیکھئیے",

  customer_name: "کسٹمر کا نام",
  enter_customer_name: "کسٹمر کا نام درج کریں",
  mobile_number: "موبائل نمبر",
  enter_mobile_number_optional: "موبائل نمبر درج کریں (ضروری نہیں ہے)",
  mobile_number_optional: "موبائل نمبر درج کریں (ضروری نہیں ہے)",
  enter_mobile_number: "موبائل نمبر درج کریں۔",
  save_and_exit: "محفوظ کریں اور باہر نکلیں",

  // GIVE UDHAAR
  please_enter_correct_amount: "برائے مہربانی صحیح رقم درج کریں",
  give: "دو",
  udhaar: "اُدھار",
  UDHAAR: "اُدھار",
  udhaar_book: "ادھار بک",
  accept: "واپس لو",
  PAYMENT: "پیسے",
  balance: "بقیہ",
  add_payment: "رقم ڈالیں",
  udhaar_note: " نوٹ یا آئٹم شامل کریں (ضروری نہیں ہے)",
  are_you_sure_you_want_to_delete_image:
    "کیا آپ واقعی تصویر کو حذف کرنا چاہتے ہیں؟",
  are_you_sure_you_want_to_exit: "کیا آپ واقعی یہاں سے باہر نکلنا چاہتے ہیں؟",

  //creatcustomer screen
  create_customertitle: "کسٹمر بنائیں",
  //credithistory screen
  date_and_time: "تاریخ اور وقت",
  payment: "جمع",
  advance: " ایڈوانس",
  balance_amount_credit_screen: "بیلنس",
  sms: "ایس ایم ایس",
  reminder: "ریماءنڈر",
  please_install_watsapp: "براہ کرم واٹس ایپ انسٹال کریں",

  //todaykhata screen
  as_of_today: "اب تک",
  total_customer: "کسٹمرز",
  net_balance: "کل بیلنس",
  total_udhaar_given: "کل اُدھار دیئے گئے",
  total_advance: "کل پیسے",
  total_udhaar: "کل اُدھار",
  share_oscar_udhaar_with:
    " Oscar Udhaar اپنے دوستوں اور رشتے داروں کے ساتھ شئیر کریں۔ ",

  //sharing screen
  share_on_whatsapp: "واٹس ایپ پر شئیر کریں",
  more_options: "مزید اختیار",
  thankyou: "شکریہ",
  //home screen
  search_customers_by_name_or_phone_placeholder:
    "نام یا موبائل کے ذریعے صارفین کو تلاش کریں",

  add_customer_details: "صارفین کی تفصیلات شامل کریں۔",
  name: "نام",
  phone_number: "موبائل نمبر",

  total: "کل",
  select_date: "تاریخ منتخب کریں۔",
  accept_payment: "ادائیگی وصول کریں۔",
  give_udhaar: "اُدھار دو۔",
  balance_amount: "رقم",

  enter_phone_placeholder: "موبائل نمبر",
  dont_have_account: "آپ کا اکاؤنٹ موجود نہیں ہے۔",
  // dont_have_account: "کیا آپکا اکاونٹ موجود نہیں ہے ؟ اپنا اکاونٹ بناءیں۔",

  //Drawer Component
  home: "ہوم",
  language: "زبان",
  logout: "لاگ آوٹ",
  urdu: "اردو",
  english: "انگریزی",
  business: "بزنس",
  business_name: "بزنس کا نام",
  profile: "پروفائل",
  settings: "سیٹنگ",
  business_card: "بزنس کارڈ",

  //filter options text
  sort_by_atoz: "ترتیب دیں A-Z",
  sort_by_ztoa: "ترتیب دیں Z-A",
  balance_due: "بقیہ بیلنس",

  //note modal
  note: "نوٹ",

  promotions: "اسکیم",
  promotions_are_not_available_at_the_moment:
    "اس وقت کوئی اسکیم دستیاب نہیں ہے",
  customers_not_found: "کسٹمر کے لئے کوئی نتائج نہیں ہیں",
  next: "آگے چلیں",
  are_you_sure_you_want_to_logout: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟",
  internet_is_required_for_sign_in: "سائن ان کیلئے انٹرنیٹ درکار ہے",
  internet_is_required_for_sign_up: "  انٹرنیٹ درکار ہے",
  add_your_first_entry: "اپنا پہلا کسٹمر اندراج کریں",
  mobile_no_is_already_registered: "یہ موبائل نمبر پہلے ہی استمال میں ہے",
  customer_updated_successfully: "کسٹمر اپڈیٹ ہو گیا ہے",
  transaction_updated_successfully: "ٹرانزیکشن اپڈیٹ ہو گیا ہے",
  transaction_added_successfully: "ٹرانزیکشن کامیابی سے شامل ہوگئی",
  no_customer_found_by_name: "اس نام کا کوئ کسٹمر نہیں",
  woulud_you_like: "کیا آپ شامل کرنا چاہیں گے",
  add_user: "کسٹمر بناۂیں",
  added_on: "تاریخ اندراج",
  user_not_found_create_an_account:
    "معزرت یہ نمبر رجسٹرڈ نہیں۔ اپنا اکاونٹ بناۂیں",
  verification_code_has_been_sent: "تصدیقی کوڈ بھیج دیا گیا ہے",
  this_number_associate_with_another_customer:
    "یہ موبائل نمبر پہلے ہی استمال میں ہے",
  no_customer_found: "اس نام کا کوئ کسٹمر نہیں, شامل کریں",

  //edit profile
  business_name: "بزنس کا نام",
  business_name_label: "بزنس کا نام",
  business_name_placeholder: "اپنی دکان کا نام لکھیں",
  update: "اپ ڈیٹ",
  free_sms_bheje: "مفت ایس ایم ایس بھیجنے کے لئے کسٹمر فون # درج کریں",
  business_name_cannot_be_empty: "بزنس نام خالی نہیں ہوسکتا ہے",
  update_customer: "اپ ڈیٹ کسٹمر",
  business_category_is_required: "کاروباری قسم کی ضرورت ہے",
  business_category_label: "کاروباری قسم",

  //view_customer_profile
  customerprofileheading: "کسٹمر پروفائل",
  do_you_want_to_delete: "کسٹمر کو ختم کرنا چاہتے ہیں؟",
  cancel: "نہیں",
  yes: "ہاں",
  no: "نہیں",
  delete_customer: "ڈیلیٹ کسٹمر",
  delete_supplier: "سپلائیر ڈیلیٹ کریں",
  customer_number: "فون نمبر",
  transaction_sms: "ٹرانزیکشن ایس ایم ایس",

  //Account Statment Screen
  advance_acc: " ایڈوانس",
  due_acc: "بقیہ",
  customer: "کسٹمر",
  transactions: "ٹرانزیکشن",
  transactions_type: "ٹرانزیکشنز کی قسم",
  account: "اکاؤنٹ",
  account_statement: "اکاؤنٹ اسٹیٹمنٹ",
  transaction_statement: "ٹرانزیکشن اسٹیٹمنٹ",
  manage_your_ledger:
    "وقت کی بچت اورآمدنی میں 3 گناہ اضافہ کرنے کے لئے اپنے ٹرانزیکشن کو اُدھار ایپ کے اندر محفوظ کریں",
  date_select: "تاریخ منتخب کریں",
  today: "آج",
  yesterday: "گزشتہ روز",
  last_seven_days: "پچھلے 7 دن",
  last_thirty_days: "پچھلے 30 دن",
  date_acc: "تاریخ",
  filter_options: [
    "آج",
    "گزشتہ روز",
    "پچھلے 7 دن",
    "پچھلے 30 دن",
    "پچھلے مہینے",
    "ہر وقت",
    "منسوخ کریں",
  ],
  //Edit Transactions Screen
  udhaar_amount: "اُدھار رقم",
  payment_amount: "جمع رقم",
  edit_transaction: "ٹرانزیکشن ایڈیٹ",
  enter_amount_trans: "رقم لکھیں",
  add_note_trans: "نوٹ یا آئٹم کا نام لکھیں",
  do_you_want_to_delete_transaction:
    "کیا آپ ٹرانزیکشن کو ڈیلیٹ کرنا چاہتے ہیں؟",
  customer_will_receive_SMS:
    "کسٹمر کو تبدیل شدہ معلومات کے ساتھ ایس ایم ایس موصول ہوگا",
  transaction_deleted: "ٹرانزیکشن ڈیلیٹ ہو گئی",
  delete_transaction: "ڈیلیٹ ٹرانزیکشن",
  save: "محفوظ",

  //backup screen
  backup: "بیک اپ",

  oscar_udhaar_backs_up_your_data_twice_a_day_automatically:
    "آسکر اُدھار خود بخود آپ کے ڈیٹا کا بیک اپ لیتا ہے ، تا کہ آپ کا ڈیٹا 100فیصد محفوظ رہے۔",

  in_case_app:
    "اگر ایپ ڈیلیٹ ہو جاتی ہے تو آسکر اُدھار کو دوبارہ ڈاؤن لوڈ کریں اور اپنا فون نمبر استعمال کرکے لاگ ان کریں آپ کا سارا ڈیٹا خود بخود واپس آجائے گا۔",
  easy_safe_reliable: "آسان، محفوظ، قابل اعتماد",
  last_backup_time: "پچہلا بیک اپ وقت",
  backup_success: "بیک اپ مکمل",
  backup_now: "ابھی بیک اپ لیں",
  backup_not_successful: "بیک اپ کامیاب نہیں ہے۔ دوبارہ کوشش کریں",
  data_not_backup:
    "آپ کا ڈیٹا پوری طرح سے بیک اپ نہیں ہے۔ براہ کرم اپنے ڈیٹا کا بیک اپ لے",
  uploading_your_backup_please_wait: "اپنے ڈیٹا کا بیک اپ لے رہے ہیں",
  restoring_your_backup_please_wait: "اپنے ڈیٹا کو بحال کرنا",
  uploading: "اپ لوڈنگ",
  restoring: "بحالی",
  name_can_not_be_empty: "نام خالی نہیں ہوسکتا",
  contact_list: "فون بک",
  add_new_customer: "نیا گاہک شامل کریں",

  // Business Card
  business_category: "کاروبار کیٹیگری",
  address: "ایڈریس",
  enter_address_optional: "پتہ درج کریں",
  other_info: "مزید معلومات",
  ohter_info_placeholder: "ای میل ، معلومات ، نام",
  email: "ای میل",
  email_placeholder_optional: "ای میل لکھیں",
  about_us: "معلومات",
  about_us_placeholder_optional: "معلومات لکھیں",
  contact_name: "نام",
  contact_name_placeholder_optional: "نام لکھیں",
  create_and_share_business_card: "اپنا بزنس کارڈ بنائیں اور شیۂر کریں",
  business_name_is_required: "کاروبار کا نام ضروری ہے",
  share_business_card: "شیۂربزنس کارڈ",
  phone_number_is_required: "موبائل نمبر کی ضرورت ہے",
  address_is_required: "ایڈریس ضروری ہے",
  email_is_required: "ای میل ضروری ہے",
  about_us_is_required: "معلومات ضروری ہے",
  contact_name_is_required: "نام ضروری ہے",
  other_info_is_required: "براہ کرم مطلوبہ فیلڈز کو مکمل کریں",
  email_business_card: "ای میل:",
  address_business_card: "ایڈریس:",
  more_options_business_card: "مزید اختیار",
  add_business_name: "کاروباری نام شامل کریں",
  udhaar_due: "بقایا ادھار",
  number_of_customers: "ٹوٹل کسٹمر",
  download: "ڈاؤن لوڈ",
  select_mobile_network_placeholder: "موبائل نیٹ ورک کو منتخب کریں",
  mobile_network: "موبائل نیٹ ورک",
  phone_number_format: "موبائل نمبر اس طرح ہونا چاہئے مثلاً 03001234567",
  phone_number_length:
    "موبائل نمبر 11 ہندسوں کا ہونا چاہئے (مثلاً 03xx1234567)",
  network_required: "موبائل نیٹ ورک کی ضرورت ہے",
  telenor: "ٹیلی نار",
  jazz: "جاز",
  ufone: "یوفون",
  zong: "زونگ",
  scom: " ايس کوم",
  select_business_category: "بزنس کیٹیگری منتخب کریں",
  camera: "کیمرہ",
  gallery: "گیلری",
  delete: "ڈیلیٹ",
  photo_added: "تصویر شامل ہے",
  please_select_your_business_category:
    "براہ کرم اپنے کاروبار کی قسم منتخب کریں",
  upload_from: "سے اپ ڈیٹ کریں",
  take_photo_with: "کے ساتھ فوٹو لیں",
  internet_connection_is_required: "انٹرنیٹ کنکشن کی ضرورت ہے",
  no_internet: "انٹرنیٹ کنکشن کی ضرورت ہے",
  internet_to_view_image: "تصویر دیکھنے کے لئے انٹرنیٹ کنکشن کی ضرورت ہے",
  internet_to_upload_image:
    "تصویر کو اپ لوڈ کرنے کے لئے انٹرنیٹ کنیکشن کی ضرورت ہے",
  transaction_saved: "ٹرانزیکشن محفوظ ہوگئی",
  message_sent: "ایس ایم ایس بھیج دیا گیا ہے",
  udhaar_balance: "اُدھار بیلنس",
  advance_balance: "ایڈوانس بیلنس",
  payment_reminder: "پیمنٹ ریمائنڈر",
  eid_card: "عید کارڈ",
  send_eid_card: "عید کارڈ بھیجیں",
  share_eid_card: "عید کارڈ شئیر کریں",
  create_share_eid_card: "اپنا عید کارڈ بنائیں اور شئیر کریں",
  greeting_salutation: "سلام / آداب عرض",
  greeting_placeholder: "سلام درج کریں",
  greeting_required: "سلام ضروری ہیں",
  eid_message: "عید پیغام",
  eid_message_placeholder: "عید کا پیغام درج کریں",
  message_required: "عید کا پیغام ضروری ہے",
  signature: "دستخط",
  signature_placeholder: "دستخط درج کریں",
  signature_required: "دستخط ضروری ہیں",
  send_card_to_customers: "اپنے صارفین کو مفت عید کارڈ بھیجیں",
  greeting_message_requried: "سلام اور پیغام ضروری ہیں",
  set_collection_date: "جمع کرنے کی تاریخ مقرر کریں",
  collection_date: "جمع کرنے کی تاریخ",
  select_collection_date: "جمع کرنے کی تاریخ منتخب کریں",
  collection_sub_heading:
    "ایس ایم ایس کی یاد دہانی آپ کے صارف کو بھیج دی جائے گی",
  collection_sub_heading_2:
    "ایس ایم ایس کی یاد دہانی آپ کے گاہک کو منتخب تاریخ پر بھیجی جائے گی",
  clear: "صاف",
  collection_due: "جمع کرنے کی وجہ",
  sms_will_be_sent: "آٹومیٹک ایس ایم ایس الرٹ بھیج دیا جائے گا",
  remind: "یاد دلائیں",
  collection: "جمع کرنا",
  payment_due_today: "ادائیگی آج ہونے والی ہے",
  past_due: "ماضی کی ادائیگی",
  five_days: "5 دن",
  ten_days: "10 دن",
  fifteen_days: "15 دن",
  next_month: "اگلے ماہ",
  request_payment: "ادائیگی کی درخواست",
  send_via_whatsapp: "واٹس ایپ کے ذریعے بھیجیں",
  send_via_sms: "ایس ایم ایس کے ذریعے بھیجیں",
  call_customer: "کسٹمر کو کال کریں",
  independence_day_tag:
    "2 ہزار روپے جیتنے کے لئے اپنی 14 اگست کی ویڈیو شئیر کریں",
  independence_day_video: "یوم آزادی کی ویڈیو",
  create_share_independence_video: "یوم آزادی کی ویڈیو بنائیں اور شئیرکریں",
  share_facebook: "فیس بک پر شیئر کریں",
  please_install_facebook: "برائے مہربانی فیس بک انسٹال کریں",
  request_dues: "ادایگئ نوٹس",
  restore_error:
    "آپ کے ڈیٹا کی ریکوری پوری طرح نہیں ہوسکی ، براہ کرم دوبارہ لاگ ان ہوں",
  record_video_message: "ویڈیو پیغام ریکارڈ کریں",
  record_video: "ویڈیو ریکارڈ کریں",
  video_message_1: "آپنے دوستوں کے لیئے آزادی کا پیغام ریکارڈ کریں",
  video_message_2: "میسج ریکارڈ کریں",
  video_sub_message: "20-40 سیکنڈ کی ویڈیو بنائیں اور 2000 روپے جیتیں",
  follow_these_steps: "اس اسٹیپس کوفولو کریں",
  step_1: "ویڈیو اپنی ٹائم لائن پر شیئر کریں",
  step_2: "#AzadiStar #UdhaarApp #Azadi2020 ٹیگس ایڈ کریں",
  step_3: "اپنے دوستوں سی شیئر کریں",
  step_4: "سب سے زیادہ شیئرز کو ملےگا 2،000 روپے کا آزادی پراۂز",
  step_5: "اپنی پوسٹ کمنٹ میں شیۂر کریں",
  download_report: "ڈاؤن لوڈ رپورٹ",
  send_free_sms: "کو مفت ایس ایم ایس بھیجیں ",
  aap_ne: "آپ نے",
  liye_hain: "لئے ہیں",
  info: "معلومات",
  send_sms: "ایس ایم ایس بھیجیں",
  sedf_sms2: "ايس ايم ايس موڪليو",
  not_now: "ابھی نہیں",
  quotes: [
    "مضبوط آپ کا نام ہے",
    "یقین کریں آپ یے کر سکتے ہو",
    "آج کر کے دکھا دو",
    "اپنے آپ پہ فخر کرو",
    "ایسا کچھ نہیں جو نا ہوسکے",
    "تم کرسکتے ہو اور یہ جانتے ہو",
    "وقت کی قدر کرو",
    "ہمت جوتائو اور زور لگاو",
    "صرف کوشش نہیں ، کر دیکھاؤ",
    "آگے بڑھو",
    "سر اوٹھا کے چلو",
  ],
  trusted_by: "پورے پاکستان میں 5.1+ ملین کاروباریوں کا بھروسہ ",
  by_continuing:
    "آگے بڑھتے ہوئے آپ ہمارے خدمات کی شرائط اور حفاظتی سے رضامندی کرتیں ھیں ",
  terms_of_services: "شرائط و ضوابط",
  privacy_policy: "حفاظتی پالیس",
  other_category: "دیگر کیٹیگری",
  enter_other_category: "دیگر کیٹیگری کا نام",
  add_customer: "کسٹمر بناۂیں",
  payments: "جمع",
  udhaars: "ادھار",
  send_via: "کے ذریعے بھیجیں",
  whatsapp: "واٹس ایپ",
  report: "رپورٹ",
  customer_statement: "کسٹمر",
  ledger_ready: "آپ کا کھاتا تیار ہے",
  have_a_wonderful_day: " آپ کا دن اچھا گزرے",
  having_trouble_contact_us: "پریشانی ہو رہی ہے؟ ہم سے رابطہ کریں",
  loading_your_data: "کلاؤڈ بیک اپ سے اپکے ڈیٹا کو لوڈ کیا جارہا ہے",
  data_loaded: "ڈیٹا لوڈیڈ۔ کھاتا سیٹ کیا جا رہا ہے۔",
  awsome_phone_verified: "بہترین آپ کا موبائل نمبر تصدیق شدہ ہے",
  businesss_will_be_displayed:
    "آپ اپنے کاروباری نام کے ساتھ اپنے کسٹمر کو مفت ایس ایم ایس بھیج سکتے ہیں۔",
  logged_in_from_another_device:
    "آپ نے کسی اور ڈیویز سے ادھار ایپ میں لاگ ان کیا ہے۔",
  device_has_been_logged_out:
    'یہ ڈیوٹنرلاگ آؤٹ ہوچکی ہے۔ اس ڈیویز پر ادھار ایپ استعمال کرنے کے لئے "یہاں استعمال کریں" بٹن پرکلک کریں۔',
  use_here: "یہاں استعمال کریں",
  grow_business_with_udhaar: "ادھار ایپ کے ذریعہ اپنا کاروبار بڑھائیں",
  enter_khata_amount: "کھاتا رقم داخل کریں",
  share_details_with_sms: "تفصیلات مفت ایس ایم ایس کے ساتھ شیئر کریں",
  play_and_win_cash: "کوئز کھیلیں اور نقد انعام جیتیں۔",
  play_now: "اب کھیلیں",
  udhaar_quiz: "ادھار کوئز",
  play_and_earn_gifts: "کھیلیں اور تحائف  کمائیں",
  how_to_play: "کھیلیں اور 1000 روپئے جیتیں",
  trivia_instructons_1: "سب سوالوں کے صحیح جواب دیں",
  trivia_instructons_2: "کوئز کا وقت ہوگا 60 سیکنڈ",
  trivia_instructons_3: "1000 روپیہ جیتیں ہر ہفتے",
  start_quiz: "کوئز شروع کریں",
  quiz_timings: "12PM - 4PM کوئز کا ٹاۂم ہر روز ",
  help: "مدد",
  question: "سوال",
  congrats_you_won: "مبارک ہو! آپ جیت گئے",
  sorry_you_didnt_win: "معذرت ، آپ جیت نہیں سکے",
  missed_by_1: "افوہ ، صرف 1 غلط جواب سے  رہ گے",
  lucky_draw_will_be_announced:
    "پر کیا جائے گا 4PM لکی ڈرا میں جیتنے والے کا اعلان جمعہ کو",
  share_on_facebook_to_win:
    "جیتنے کے امکانات بڑھانے کے لئے فیس بک پر شیئر کریں۔",
  IA_next_time: "کل اگلے کوءز میں شامل ہو کر کامیابی حاصل کریں",
  new_quiz_tomorrow: "اگلا کوئز کل شروع ہوگا",
  share: "شۂیر",
  back_to_home: "واپس ہوم پیج پر",
  contact_us: "ہم سے رابطہ کریں",
  terms_and_conditions: "شرائط و ضوابط",
  trivia_term_1: "1. کوئز آسکر کی جینب سی آرگنائز کیا گیا ہے",
  trivia_term_2:
    "2. کوئز میں شامل ہونے کے لیے شرکاء کو تمام شرائط و ضوابط کو  فالو کرنا لزمی ہوگا",
  trivia_term_3: "3. کوئز مائی انٹری کے کوئی چارجز نہیں ہیں",
  trivia_term_4: "4. کوئز دوپہر 12 سے شام 4 بجے تک کھیلا جا سکتا ہے",
  trivia_term_5: "5. جوابات شرائط و ضوابط کے مطابق قبول کیے جاۂیں گے",
  trivia_term_6: "6. نا مکمال یا برے غیر مطلوب اندراجات نہی قبول ہونگے",
  trivia_term_7: "7. کوئز ہمیشہ جمعہ کو شروع ہوگا اور جمعرات کو ختم ہوگا",
  trivia_term_8:
    "8. جیتنے والوں کے نام کا اعلان ہفتہ وار بنیاد پر جمعہ کو کیا جائے گا",
  trivia_term_9: "9. اودھار ایپ کے تمام رجسٹرڈ صارف کوئز میں حصہ لے سکتے ہیں",
  quiz_submit_karnai_ke_baad: "کوئز جمع کرانے کے بعد",
  after_submit_1: "1. جیتنے والی رقم 1000 روپے ہے",
  after_submit_2:
    "2۔ روزانہ کی بنیاد پر 3 سوالوں کا جواب دینا ہوتا ہے اور اس میں 1 اندراج شمار ہوگا۔ جن لوگوں نے ان 3 سوالات کے تمام صحیح جوابات دیئے وہ اگلے مرحلے کے لئے کوالیفائی کرسکیں گے۔",
  after_submit_3:
    "3. ایک ہفتہ میں زیادہ سے زیادہ صحیح جوابات کے جیتنے کے زیادہ امکانات",
  after_submit_4: `"4. جیتنے والے کے نام کے اعلان ہونے کے بعد ، فاتح کو یہ تفصیلات شیئر کرنا ہوں گی:
        a. نام
        b. رابطہ نمبر
        c پتہ
        d. این آئی سی نمبر
        e. تصویر (لاضمی نہیں)`,
  after_submit_5:
    "5. جیتنے والا انعام فاتح کے نام کے اعلان کے 3 سے 4 دن کے اندر دیا جائے گا",
  after_submit_6:
    "6. کسی بھی غیر یقینی صورتحال میں آسکر فیصلہ آخری فیصلہ ہوگا۔ اور اس فیصلے پر مزید بحث نہیں کی جائے گی۔",
  after_submit_7:
    "7. کسی بھی صورت میں ، آسکر کوئز کو منسوخ یا ملتوی کرسکتا ہے۔ جیتنے والی رقم میں بھی تبدیلی آسکتی ہے۔ آسکر کے لئے صارفین کو مطلع کرنا ضروری نہیں ہے",
  after_submit_8:
    "8. آسکر کو جیتنے والی رقم منسوخ کرنے کا حق ہے اگر یہ رقم کسی بھی غیر قانونی سرگرمی یا غیر اخلاقی طریقے سے استعمال کی جائے۔",
  after_submit_9:
    "9. کوئز کھیلنے کے لیے آپ آسکر کو اپنے نام اور شہر کا اشتراک کرنے کی اجازت دے رہے ہیں اگر آپ جیت جاتے ہیں۔",
  after_submit_10:
    "10۔ آسکر پیشگی اطلاع کے بغیر شرائط و ضوابط میں تبدیلی کرسکتا ہے",
  do_you_want_to_exit: "کیا آپ واقعی باہر نکلنا چاہتے ہیں؟",
  you_wont_be_able_to_play:
    "آپ آج دوبارہ کھیل نہیں سکیں گے۔ اگلا کوئز کل سے شروع ہوگا۔",
  enter_pin_to_use_udhaar: "ادھار ایپ کو استعمال کرنے کے لئے پن درج کریں",
  enter_pin_to_remove_pin: "سیکیورٹی کو ختم کرنے کے لئے پن درج کریں",
  set_new_udhaar_app_pin: "ادھار ایپ کا نیا پن سیٹ کریں",
  pin_did_not_match: "پن ٹھیک نہیں ہے",
  pin_lock_has_been_removed: "پن لاک ہٹا دیا گیا ہے",
  confirm_udhaar_app_pin: "ادھار ایپ پن کی تصدیق کریں",
  enter_pin: "پن سیٹ کریں",
  enter_pin_here: "یہاں پن درج کریں",
  udhaar_security: "ادھار سیکیورٹی",
  touch_sensor: "ٹچ سینسر",
  you_must_set_a_pin_first: "آپ کو پہلے ایک پن تیار کرنا چاہئے",
  remove_biometric: "بایومیٹرک کو ہٹا دیں",
  pincode: "پن کوڈ",
  set_a_4_digit_pincode: "4 ہندسوں کا پن کوڈ سیٹ کریں",
  enable: "آن کر دو",
  face_id: "چہرے کی شناخت",
  touch_id: "انگلی کی شناخت",
  biometrics: "بایومیٹرکس",
  app_lock: "ایپ لاک",
  data_not_backedup: "ڈیٹا کا بیک اپ نہیں لیا گیا",
  click_here: "یہاں کلک کریں",
  to_backup_your_data: "بیک اپ کیلئے ",
  backup_successful: "ڈیٹا بیک اپ ہوچکا ہے",
  select_account_statement_filter: "اکاؤنٹ اسٹیٹمنٹ فلٹر منتخب کریں",
  selected_filter: "منتخب فلٹر: ",
  custom: "اپنی مرضی کے مطابق",
  select_upcoming_date: "آنے والی تاریخ منتخب کریں",
  filter_error: "غلط فلٹر",
  dont_know: "پتہ نہیں",
  filter: "فلٹر",
  no_contact_permission_1: "کیا آپ اپنی فون بک سے روابط منتخب کرنا چاہیں گے؟",
  no_contact_permission_2: "ادھار ایپ کو اپنے رابطوں تک رسائی کی اجازت دیں۔",
  no_contact_permission_3: "اجازت دینے کے لئے یہاں کلک کریں.",
  collection_date_heading: "جمع تاریخ",
  pending: "باقی",
  upcoming: "انے والے",
  settled: "برابر",
  sort_by: "ترتیب",
  filter_name_az: "(A-Z) نام",
  filter_amount: "رقم",
  filter_amount_desc: "رقم زیادہ سے کم",
  filter_least_recent: "پرانی ترین",
  filter_most_recent: "سب سے حالیہ",
  filter_due_date: "اخری تاریخ",
  transaction_type: "ٹرانزیکشن کی قسم",
  default: "پہلے سے طے شدہ",
  apply: "ٹھیک ہے",
  all: "تمام",
  loading_your_contacts: "فون نمبرز لوڈ ہو رہے ہیں",
  udhaar_app_secure_lock: "ادھار اپلی کیشن محفوظ لاک",
  please_use_fingerprint_to_unlock_app:
    "براہ کرم ایپ کو غیر مقفل کرنے کیلئے فنگر پرنٹ کا استعمال کریں",
  show_finger: "انگلی دکھائیں",
  touch_the_fingerprint_sensor: "فنگر پرنٹ سینسر کو ٹچ کریں",
  wrong_pin: "غلط پن. آپ کے پاس",
  attempts_remaining: "کوششیں باقی ہیں",
  reset_pin: "پن ری سیٹ کریں",
  forgot_pin: "پن بھول گئے؟",
  your_udhaar_app_account_is_locked: "آپ کا ادھار ایپ اکاؤنٹ بند ہے",
  tap_here_to_use_finger_print_login:
    "فنگر پرنٹ لاگ ان کو استعمال کرنے کے لئے یہاں تھپتھپائیں",
  commission_earned: "حاصل کمیشن",
  customer_n: "صارف  #",
  easyload: "ایزی لوڈ",
  commission: "کمیشن",
  wallet: "والیٹ",
  give_easy_load: "ایزی لوڈ دیں",
  choose_network: "نیٹ ورک کا انتخاب کریں",
  earned: "کمائی",
  add_balance: "بیلنس شامل کریں",
  easy_load_by_udhaar: "ایزی لوڈ بذریعہ ادھار ایپ",
  earn_commission_with_udhaar:
    "ادھار ایپ کے ساتھ ایزی لوڈ پر 2.5 فیصد کمیشن تک کمائیں",
  easy_load_in_3_steps: "ایزی لوڈ 3 آسان طریقے سے",
  add_balance_to_wallet: "والیٹ میں رقم ڈالیں",
  enter_customer_number: "کسٹمر کا فون نمبر درج کریں",
  give_easy_load_earn_commission: "ایزی لوڈ دیں اور کمشن کمائیں",
  addBalance: "بیلنس شامل کریں",
  add_money_to_wallet: "والیٹ میں رقم ڈالیں",
  easy_paisa: "ایزی پیسہ",
  jazz_cash: "جاز کیش",
  ubl: "UBL",
  hbl: "HBL",
  easy_paisa_account: "ایزی پیسہ اکاؤنٹ",
  jazz_cash_account: "جاز کیش اکاؤنٹ",
  ubl_account: "اکاؤنٹ UBL",
  hbl_account: "اکاؤنٹ HBL",
  account: "کھاتہ",
  accounts: "اکاؤنٹس",
  mobile_number_label: "موبائل نمبر",
  number_verification_note:
    "کوڈ بھیجا جائے گا OTP نوٹ: موبائل نمبر کی تصدیق کے لئے",
  amount_required: "رقم کی ضرورت ہے",
  easypaisa_pin_confirmation: "ایزی پیسہ پن کی تصدیق ",
  jazzcash_pin_confirmation: "جاز کیش پن کی تصدیق ",
  ubl_pin_confirmation: "پن کی تصدیق UBL ",
  hbl_pin_confirmation: "پن کی تصدیق HBL ",
  pin_confirmation: "پن کی تصدیق ",
  enter_otp_code: "کوڈ درج کریں OTP",
  submit: "جمع کرائیں",
  has_been_added_to_wallet: "آپ کے والیٹ کی رقم میں اضافہ کردیا گیا ہے۔",
  you_can_use_the_balance:
    "اب آپ ریچارج اور ادائیگیوں کے لئے بیلنس کا استعمال کر سکتے ہیں",
  edit_information: "معلومات میں تبدیلی کریں",
  earn_money: "پیسہ کماؤ",
  b_card: "B.Card",
  play_quiz: "کوئز کھیلیں ",
  easy_load: "ایزی لوڈ",
  prepaid: "پری پیڈ",
  postpaid: "پوسٹ پیڈ",
  device: "ڈیوائس",
  no_packages_available: "پیکجز دستیاب نہیں ",
  recharge_details: "ریچارج تفصیلات دیکھیں",
  network: "نیٹ ورک",
  phone_number_small: "فون نمبر",
  feeAndTax: "فیس اور ٹیکس",
  no_charges: "کوئی چارجزنہیں ",
  total_amount: "کل رقم",
  pay_now: "اب ادا کریں",
  easyload_successful: "ایزی لوڈ کامیاب",
  phoneN: "موبائل  #:",
  sms_has_been_sent: "اوپر نمبر پر بھیج دیا گیا ہے SMS",
  edit_share_whatsapp: "ایڈٹ اور واٹس ایپ پر شیئر کریں",
  edit: "ایڈٹ ",
  marketing_in_easy_steps: "3  آسان مراحل میں مارکیٹنگ",
  choose_your_details: " تفصیلات میں سے انتخاب کریں",
  enter_your_details: "آپ اپنے تفصیلات درج کریں",
  share_details_whatsapp: "واٹس ایپ پر تفصیلات شیئر کریں",
  add_first_banner: "اپنا پہلا بینر لگائیں",
  offer: "50٪  کی چھوٹ کی پیشکش",
  best_quality_products: "مناسب قیمت پر بہترین معیار کی مصنوعات",
  shop_from: "دکان سے ",
  my_shop: "میری دکان",
  enter_heading: "عنوان درج کریں",
  enter_description: "تفصیل درج کریں",
  description_placeholder: "بہترین معیار کی مصنوعات",
  enter_shope_name: "دکان کا نام درج کریں",
  share_store_banner: "شئیر سٹور بینر",
  edit_template: "ڈیزائن میں ترمیم کریں",
  invalid_amount: "غلط رقم",
  get_more_business: "فری مارکیٹنگ سے مزید کاروبار حاصل کریں",
  select_your_marketing_banner: "اپنے مارکیٹنگ کا بینر منتخب کریں",
  add_promotion_or_other_special_message:
    "پروموشنز یا دیگر خاص پیغام شامل کریں",
  share_with_friends_and_customers: "دوستوں اور کسٹمرکے ساتھ شیئر کریں",
  marketing: "مارکیٹنگ",
  more: "مزید",
  new: "نئی",
  to_take: "آپ نے لینے ہیں",
  to_give: "آپ نے دینے ہیں",
  total_taken: "آپ نے لیے ہیں",
  total_given: "آپ نے دیے ہیں",
  entry: "انٹری",
  entries: "انٹریس",
  given: "آپ نے دیے",
  taken: "آپ نے لیے",
  give_: "دیں",
  take: "لیں",
  your_business: "آپ کا کاروبار",
  create_new_business: "نیا کاروبار بناۂیں",
  switching_to_business: "{name} پر سوئچ ہو رہے ہیں",
  add_new_business: "نیا کاروبار بناۂیں",
  select_start_date: "شروع تاریخ",
  select_end_date: "آخری تاریخ",
  transaction: "ٹرانزیکشن",
  add_your_first_traansaction: "اپنا پہلا کھاتا بناۂیں",
  setup_your_invoice_transaction_with_us:
    "ہمارے ساتھ ٹرانزیکشن انوائس سیٹ اپ کریں",
  loading: "لوڈ کر رہا ہے",
  active_filter: "موجودا فلٹر",
  add_business: "کاروبار بناۂیں",
  logout_backup: "بيڪ اپ",
  logout_anyway: "بهرحال لاگ آؤٹ کریں",
  waiting_otp: "او ٹی پی کوڈ کا انتظار کررہے ہیں",
  enter_code: "4 ڈجڑز کا کوڈ لکھیں",
  call_me: "کال کریں",
  verify: "تصدیق کریں",
  have_you_change_mobile_network: "کیا آپ نے اپنا موبائل نیٹ ورک تبدیل کیا ہے؟",
  select_network_to_rec_otp:
    "حاصل کرنے کے لئے اپنا نیا نیٹ ورک منتخب کریں OTP براہ کرم  ",
  waiting_for_code: "کوڈ کا انتظارکررہے ہیں",
  otp_call: "کال پر آپ کو او ٹی پی کوڈ ملے گا۔",
  no_filter_match: "ان فلٹرز سے کوئی نتیجہ نہیں ملا۔ فلٹرز تبدیل کریں یا صاف کریں",
  add_customer_and_maintain_udhaar:
    "کسٹمر بنائیں اور اپنا روزانہ کا کھاتہ محفوظ بنائیں",
  manage_your_business:
    "اپنے کھاتا اور اپنے کاروبار کو چلائیں۔ یاددہانی بھیجیں ، ادائیگی وصول کریں۔ سب مفت۔",
  trusted_b_over: " 5.1+ملین سے زیادہ کاروبار کا بھروسہ",
  trusted_b: " 5.1+ ملین کاروباریوں کا بھروسہ ",
  stat_using_udhaar_app: "ادھار ایپ کا استعمال شروع کریں",
  dont_ask: "دوبارہ نہ پوچھیں",
  manage_daily_cash_transactions:
    "اپنے روزانہ کا کیش ، فروخت اور اخراجات کا نظام رکھیں",
  invoice_descp_1: "ہاتھ میں موجود کیش بیلنس کا سیلز اور اخراجات سے موازنہ کریں",
  invoice_descp_2: "آئٹم کی تفصیلات کے ساتھ کسٹم بل اور رسید بنائیں",
  invoice_descp_3: "ماہانہ اور روزانہ کی رپورٹیں ڈاؤن لوڈ کریں",
  cash_in: "کیش اِن",
  cash_out: "کیش آؤٹ",
  add_item: "آئٹم شامل کریں",
  change_date: "تاریخ تبدیل کریں",
  add_photo: "تصویر لگایں",
  add_note: "نوٹ ڈالیں",
  select_invoice_date: "انوائس کی تاریخ منتخب کریں",
  reset: "ری سیٹ کریں",
  enter_item_name: "آئٹم کا نام لکھیں",
  enter_item_placeholder: "جیسے آم",
  item_name_required: "آئٹم کا نام ضروری ہے",
  add_another_item: "اور آئٹم شامل کریں",
  invalid_quantity: "غلط مقدار",
  customer_list: "کسٹمر لسٹ",
  select_invoice_status: "انوائس اسٹیٹس کو منتخب کریں",
  paid: "ادا کیا",
  not_paid: "ادا نہیں کیا",
  select_payment_method: "ادائیگی کرنے کا طریقہ منتخب کریں",
  cash: "کیش",
  bank: "بینک",
  add_your_own: "اپنا شامل کریں",
  payment_method: "ادائیگی کا طریقہ",
  change_method: "طریقہ بدلیں",
  invoice: "انوائس",
  verified_by: "تصدیق شدہ",
  item_details: "آئٹم کی تفصیلات",
  qty: "مقدار",
  made_with: "کے ساتھ بنایا گیا ",
  in: "اِن",
  out: "آؤٹ",
  cash_out_amount: "کیش آؤٹ رقم",
  cash_in_amount: "آنے والی رقم",
  cash_in_placeholder: "آنے والی رقم ڈالیں",
  cash_out_placeholder: "کیش آؤٹ رقم ڈالیں",
  take_a_picture: "تصویر لو",
  upload_from_gallery: "گیلری سے اپ لوڈ کریں",
  take_photo_with_camera: "کیمرے سے فوٹو لے لو",
  more_items: "مزید آئٹم",
  transaction_successful: "ٹرانزیکشن کامیاب",
  cash_on_hand: "ہاتھ میں کیش",
  cashbook: "کیش بک",
  sales: "فروخت",
  expense: "اخراجات",
  bill: "بل",
  add_bill_to_contact: "کانٹیکٹ میں بل شامل کریں",
  automatically_add_credit_to_contact:
    "کیا آپ اس کانکٹ کے اکاونٹ میں یہ انٹری شامل کرنا چاہتے ہیں؟",
  quick_entry: "فوری انٹری",
  itemized_entry: "آئٹمائزڈ انٹری",
  invoice_can_be_edited_cashbook:
    "انوائسز صرف کیش بک سے ایڈیٹ / ڈیلیٹ کی جاسکتی ہیں",
  delete_associated_invoices: "متعلقہ رسیدیں ڈیلیٹ کریں",
  do_you_want_to_delete_invoice:
    "کیا آپ اس کانٹیکٹ سے وابستہ رسیدیں ڈیلیٹ کرنا چاہتے ہیں؟",
  upload_photo: "تصویر اپ لوڈ کریں",
  todays_balance: "آج کا بیلنس",
  delete_entry: "انٹری کو ڈیلیٹ کریں",
  credit_added_to_contact: "اس رابطے میں رقم شامل کردی گئی ہے",
  contact_via_whatsapp: "واٹس ایپ کے ذریعے رابطہ کریں",
  credit: "کریڈٹ",
  add_contact: "نمبر شامل کریں",
  share_your_promotions: "اپنی پروموشنز شیئر کریں",
  edit_sales: "ایڈٹ سیلز",
  edit_expense: "ایڈٹ خرچ",
  play_tutorial: "ویڈیو دیکھیں",
  see_help_tutorial: "ویڈیو دیکھیں",
  manage_cash_sale: "انتظام کریں، کیش، سیلز اور اخراجات",
  send_free_invoices: "مفت رسید بھیجیں۔",
  send_free_promotions: "مفت پروموشنز بھیجیں",
  send_free_promotions_to_customer:
    "کسٹمر کو مفت پروموشن بھیجیں اور فروخت بڑھائیں",
  share_udhaar_app: "ادھار ایپ اپنے دوستوں کے ساتھ شیئر کریں",
  earn_upto: "45،000 روپے تک مہینہ کمائیں۔",
  you_will_get:
    "روپے ملیں گے جو 2 الگ دن پر 2 ٹرانزیکشن کرتے ہیں Rs. 20 آپ کو ہر دوست کے",
  contact_customer: "کسٹمر سے رابطہ کریں",
  sell_online: "آن لائن فروخت کریں",
  latest_transaction: "موجودہ",
  reminder1: "یاد دہانی",
  collect_today: "آج لیں",
  pending_collection: "باقی ادائیگی",
  collect_on: "لینا ہے",
  send_reminder: "یاد دہانی بھیجیں",
  set_new_date: "نئی تاریخ طے کریں",
  active_filter2: "موجودہ فلٹر",
  collection_set_successfully: "جمع کرنے کی تاریخ طے کردی گئی ہے",
  total_earning: "کل آمدنی",
  not_earned_money:
    "آپ نے کوئی رقم نہیں کمائی ، اب کمانے کے لئے دوستوں کے ساتھ شئیر کریں۔",
  app_installed: "ایپ انسٹال ہوگئی",
  two_entries_done: "2 اینٹری ہو چکی ہے",
  rs10_earned: "10 روپے کمائے",
  add_phone_number: "فون نمبر لکھیں",
  add_phone_to_set_date:
    "رقم جمع کرنے کی تاریخ مقرر کرنے کے لئے موبائل نمبر لکھیں",
  remind_with_whatsapp: "واٹس ایپ کے ذریعہ یاد دلائیں",
  remind_with_sms: "ایس ایم ایس کے ذریعہ یاد دلائیں",
  no_pending_collections: "مبارک ہو۔ مزید ادائیگی باقی نہیں ہے",
  no_collection_for_today:
    "آج جمع کرنے کے لیے کوئی ادائیگی نہیں ، زیر التوا پر جائیں اور جلد ادائیگی کے لیے تاریخ مقرر کریں۔",
  remove_colletion_from_selected:
    "منتخب رابطوں سے جمع کرنے کی تاریخیں ختم کریں؟",
  collection_removed_successfully:
    "جمع کرنے کی تاریخ کامیابی کے ساتھ ہٹا دی گئی",
  no_collection_today_line_1: "آج کوئی پیسہ نہیں ملا۔",
  no_collection_today_line_2: "میں جائیں اور جمع کرنے کی تاریخ طے کریں۔",
  no_collection_upcoming_line_1: "آنے والی کوئی رقم نہیں ہے۔ کے پاس جاؤ",
  turn_off_invoice_for_all:
    "کیا آپ مستقبل کے سارے لین دین کی اپنے آپ جانے والی رسیدیں بند کرنا چاہتے ہیں؟",
  billbook: "بل بک",
  search_item: "آئٹم تلاش کریں",
  items_list: "اشیا کی فہرست",
  item_name: "آئٹم کا نام",
  item_stock: "آئٹم اسٹاک",
  enter_item_stock: "آئٹم اسٹاک داخل کریں",
  selling_price: "قیمت فروخت",
  enter_selling_price: "فروخت کی قیمت درج کریں",
  cost_price: "قیمت خریدنا",
  enter_cost_price: "لاگت درج کریں",
  add_price: "قیمت شامل کریں",
  edit_item: "آئٹم میں ترمیم کریں",
  low_stock: "کم اسٹاک",
  bill_details: "بل کی تفصیلات",
  item: "آئٹم ",
  items: "آئٹم ",
  cash_added_to_contact: "کیش بک میں کیش شامل کیا گیا ہے",
  net_profit: "خالص منافع",
  all_time: "تمام وقت",
  this_week: "اس ہفتے",
  this_month: "اس مہینے",
  bill_can_be_edited_cashbook:
    "بلوں کو صرف بل بک میں ترمیم / حذف کیا جاسکتا ہے",
  add_items: "اشیا شامل کریں",
  select_items: "اشیا منتخب کریں",
  no_items_added_recently: "حال ہی میں کوئی آئٹم شامل نہیں کیا گیا",
  current_bill: "موجودہ بل",
  press_the_mark_to_add: "موجود نہیں ہے یا پہلے ہی منتخب ہے",
  item_already_in_bill: "آئٹم پہلے ہی بل میں شامل کردیا گیا ہے",
  item_with_this_name_exists:
    "اس نام والی آئٹم پہلے ہی موجود ہے ، براہ کرم نیا نام درج کریں",
  sales_amount: "فروخت کی رقم",
  sales_amount_placeholder: "فروخت کی رقم درج کریں",
  cost_amount: "لاگت کی رقم",
  cost_amount_label: "لاگت کی رقم (ضروری نہیں)",
  cost_amount_placeholder: "لاگت کی رقم درج کریں",
  optional_information: "اضافی معلومات",
  your_loss: "آپ کا نقصان",
  your_profit: "آپ کا منافع",
  items_added: "اشیا شامل کی گئیں",
  remove: " ہٹا دیں",
  enter_note_terms: "نوٹ / شرائط درج کریں",
  select_payment_information_optional:
    "ادائیگی کی معلومات منتخب کریں (ضروری نہیں)",
  has_the_bill_paid: "کیا بل ادا ہوا ہے؟",
  select_bank: "بینک منتخب کریں",
  select_wallet: "والیٹ کو منتخب کریں",
  total_Entries: "کل 7 اندراجات",
  start_date: "شروع کرنے کی تاریخ",
  end_date: "آخری تاریخ",
  save_items: "اشیا محفوظ کریں",
  add_an_item: "آئٹم شامل کریں",
  bill_items: "بل اشیا",
  share_bill: "بل بھیجیں",
  do_not_share_bill: "بل مت بھیجیں",
  add_details: "تفصیلات شامل کریں",
  optional: "(ضروری نہیں)",
  waiting_for_code_2: "کوڈ کا انتظارکررہے ہیں",
  net_udhaar: "نیٹ اُدھار",
  net_advance: "نیٹ ایڈوانس",
  advance_payment: "ایڈوانس رقم",
  advance_amount: "ایڈوانس امونٹ",
  contacts: "رابطے",
  select_mobile_network_placeholder2:
    "پورٹڈ نمبر کے لئے ، صحیح نیٹ ورک منتخب کریں",
  take_photo: "تصویر لو",
  with_camera: "کیمرہ کے ساتھ",
  ledger_secured: "لیجر محفوظ اور توثیق شدہ",
  friends_at_udhaar: "- ادھار پر آپ کے دوست",
  new_transaction: "نئی ٹرانزیکشن",
  buy: "خریدئے",
  sell: "بیچے",
  going_back_will_discard_transaction:
    "واپس جانے سے آپ کا لکھا ہوا ختم ہو جاۓ گا",
  go_back: "واپس جاو",
  cashbook_report: "کیش بک رپورٹ",
  profit: "منافع",
  total_sales: "کل فروخت",
  total_expense: "کل اخراجات",
  select_report_type: "رپورٹ کی قسم منتخب کریں",
  download_pdf: "پی ڈی ایف ڈاؤن لوڈ کریں",
  bill_pdf_processing: "بل کی PDF تیار ہو رہی ہے...",
  bill_pdf_unavailable: "بل کی PDF ابھی دستیاب نہیں ہے",
  detailed_report: "تمام اندراجات کے ساتھ تفصیلی رپورٹ",
  summary_report: "دن کی سمری رپورٹ",
  other_category_label: "دوسری قسم",
  recharge: "ریچارج",
  connect_your_account: "اپنا اکاؤنٹ جوڑیں",
  earn_upto_3_commission: "تک کمائیں",
  on_easy_load: "ایزی لوڈ پر",
  add_balance_for_easyload: "ایزی لوڈ کے لیے بیلنس ڈالیں",
  invoice_book: "انوائس بک",
  purchase_invoice: "خریداری کا انوائس",
  purchase_bill: "خریداری کا بل",
  purchase_report: "خریداری کی رپورٹ",
  now_you_can_collect_payment_digitally_with_udhaar_app:
    "اب آپ ادھار ایپ کے ذریعہ ڈیجیٹل طور پر ادائیگی جمع کرسکتے ہیں",
  congratulations: "مبارک ہو!",
  did_not_receive_deposit_try_again: "جمع نہیں کیا؟ دوبارہ کوشش کریں",
  verify_account: "اکاؤنٹ کی تصدیق کریں",
  video: "ویڈیو",
  camera_permission: "سیٹنگز سے کیمرا استعمال کرنے کی اجازت دیں",
  invite_sent: "انوائٹ بھیج دی",
  user_already_user_udhaar: "یہ صارف پہلے سے ادھار ایپ استعمال کر رہا ہے",
  rs_20_earned: "۲۰ روپے جیت لئے",
  invite: "انویٹ",
  remark: "تفصیل",
  remark_is_required: "تفصیل لکھنا ضروری ہے",
  total_cash_in: "ٹوٹل کیش اِن",
  total_cash_out: "ٹوٹل کیش آؤٹ",
  save_invoice: "انوائس محفوظ کریں",
  add_item_list: "آئٹم لسٹ شامل کریں",
  enter_invoice_total: "انوائس کا ٹوٹل لکھیں",
  has_this_invoice_been_paid: "کیا اس انوائس کی ادائیگی ہو چکی ہے؟",
  add_customer_2: "کسٹمر بنائیں",
  add_items_to_invoice: "آئٹمز انوائس میں لکھیں",
  stock: "اسٹاک",
  pcs: "پیسس",
  create_new_stock_item: "نیا اسٹاک آئٹم بنائیں",
  import_items: "آئٹمز امپورٹ کریں",
  selling_price_optional: "فروخت قیمت (ضروری نہیں)",
  cost_price_optional: "خریداری کی قیمت (ضرورت نہیں)",
  current_stock_optional: "موجودہ اسٹاک (ضرورت نہیں)",
  qty_for_low_stock_alert: "کم اسٹاک الرٹ کے لئے مقدار باتیں",
  items_total: "فائنل بیلنس",
  confirm_invoice_amount: "انوائس کی رقم کی تصدیق کریں",
  your_invoice_amount_is: "آپ کی انوائس کی رقم ہے",
  invoice_successfully_saved: "انوائس محفوظ ہو گی ہے",
  send_invoice: "انوائس بھیجیں",
  create_new_invoice: "نیا انوائس بنائیں",
  share_invoice: "انوائس شیئر کریں",
  do_not_share: "شیئر نہیں کرنا",
  invoice_book_report: "انوائس بک رپورٹ",
  final_balance: "فائنل بیلنس",
  mobile_phone_number: "موبائل فون نمبر",
  item_list_tafseel: "آئٹم لسٹ / تفصیل (ضرورت نہیں)",
  send_free_sms_to: " کو فری ایس ایم ایس سینڈ کریں",
  only_you_and: "صرف آپ اور",
  can_see_these_entries: "یہ انٹریز دیکھ سکتے ہیں",
  add_first_transaction_of: "کا پہلا حساب لکھیں",
  cashbook_description:
    ".اپنے فروخت اور اخراجات کا حساب لکہیں. اور کسٹمرز کو فری بل اور انوائس بھیجیں",
  invoicebook_description:
    ".اپنی فروخت اور خریداری کی انوائس بنائیں جٹ پٹ, با-آسانی. شیئر کریں کسٹمرز کے ساتھ اور ادھار وصولی بنائیں ٣ گنا تیز",
  udhaarbook: "ادھار بک",
  cash_in_caps: "آنے والی رقم",
  cash_out_caps: "کیش آؤٹ رقم",
  stock_book: "اسٽاڪ بک",
  all_items: "تمام آئٹمز",
  out_of_stock: "اسٹاک ختم",
  stock_of_goods: "سامان کا اسٹاک",
  manually_added: "دستی طور پر شامل کیا گیا",
  manually_reduced: "دستی طور پر کم کیا گیا",
  manage_stock_items: "اسٹاک آئٹم انتظام کریں",
  add_new_item: "نئی چیز شامل کریں",
  select_unit: "یونٹ منتخب کریں",
  no_item_found: "کوئی شے نہیں ملی",
  delete_item: "آئٹم کو ڈیلیٹ کریں",
  all_data_of_this_item_will_be_deleted: "اس آئٹم کا سارا ڈیٹا ڈیلیٹ ہوجائے گا",
  manage_stock: "اسٹاک انتظام کریں",
  collect_payment: "ادائیگی جمع کریں",
  share_promotions: "پروموشنز شیئر کریں",
  win_daily_cash_prizes: "روزانہ انعامات جیتیں",
  unlock_cash_prize: "انعامات انلاک کریں",
  switch_on_quiz_in_3_steps: "کوئز آن کرنے کے 2 آسان اقدامات",
  start_using_udhaar_book: "ادھار بک کا استعمال کرنا شروع کریں",
  pakistans_biggest_cash_reward_app: "پاکستان کا سب سے بڑا نقد انعام ایپ",
  play_quiz_and_win_cash_prizes_worth_10k:
    "روزانہ 10،000 انعام کوئز کھیلیں اور پیسے جیتیں",
  item_will_be_added_to_stock: "آئٹم اسٹاک میں شامل کیا جائے گا",
  customer_added_successfully: "کسٹمر کامیابی کے ساتھ شامل ہو گیا",
  customer_deleted_successfully: "کسٹمر کامیابی کے ساتھ ڈیلیٹ ہو گیا",
  invitation_successfull: "دعوت کامیابی کے ساتھ بھیج دی گئی",
  landmark: "مشہور جگہ",
  enter_landmark: "مشہور جگہ درج کریں(لازمی نھیں ھے)",
  landmark_required_to_access_recharge:
    "لینڈ مارک لازمی ہے ری چارج تک پھنچنے کے لیے",
  send_money: "پیسے بھیجیں",
  collect_money: "پیسے جمع کریں",
  balance_settled: "حساب کلیئر",
  create_new_item: "نیا آئٹم بنائیں",
  view_item: "آئٹم دیکھیں",
  save_items_to_invoice: "آئٹمز کو انوائس میں محفوظ کریں",
  infoAdded: "معلومات کامیابی کے ساتھ شامل کردی گئیں",
  added: "شامل کیا",
  Request_Send: "درخواست بھیج دی گئی",
  are_you_sure_you_want_to_delete_business:
    "کیا آپ واقعی اس کاروبار کو ڈیلیٹ کرنا چاہتے ہیں؟",
  u_paisa: "یوپیسا",
  going_back_will_discard_changes: "واپس جانے سے آپ کی تبدیلیاں ختم ہو جائینگی",
  invoice_successfull: "انوائس کامیاب",
  amount_due: "واجب الادا رقم",
  payment_due: "ببقايا ادائیگی",
  invoice_to: "کو انوائس",
  purchase_order_to: "کو پرچیز آرڈر",
  amount_should_be_a_numbers: "رقم نمبروں میں ھونی چاہئے",
  select_invoice_method: "انوائس کا طریقہ منتخب کریں",
  info_updates: "معلومات کامیابی کے ساتھ اپ ڈیٹ ہو گئیں",
  info_added: "معلومات کامیابی کے ساتھ شامل ہو گئیں",
  info_deleted: "معلومات کامیابی کے ساتھ ڈیلیٹ ہو گئیں",
  unpaid: "ادا نہیں کیا",
  close: "بند کریں",
  user_exist: "صارف پہلے سے موجود ہے",
  ucash: "یو کیش",
  ucash_balance: "یو کیش بیلینس",
  view_details: "تفصیلات دیکھیں",
  sell_easyload: "ایزی لوڈ بیچیں",
  earn_commission_upto_3: "2.5٪ تک کمیشن کمائیں",
  best_in: "میں بہترین",
  ucash_descp:
    "تیزی سے جمع کریں۔ 1٪ تک کیش بیک کے ساتھ اضافی رقم کمائیں 3x ادائیگی",
  get_early_access: "جلد رسائی حاصل کریں",
  we_have_added_you_to_wait_list: "آپ کو انتظار کی فہرست میں شامل کیا گیا",
  there_are: "وہاں ہے",
  people_ahead_of_you_to_earn_upto_1_cashback:
    "لوگ آپ سے آگے ھیں 1 فیصد تک کیش بیک جیتنے کے لیے",
  want_fast_access: "تیز رسائی چاہتے ہیں",
  rp_50_recharge_ready: "کا ریچارج تیار ہے! RS آپ کا 50",
  avail_recharge_share_now:
    "اس ریچارج سے فائدہ اٹھانے کے لئے ، اب اپنے دوستوں کے ساتھ شئیر کریں اور ان ہیش ٹیگز کو کیپشن میں رکھیں:",
  share_with_friends: "دوستوں کے ساتھ بانٹیں",
  add_cash: "کیش شامل کریں",
  promotion: "اسکیم",
  play_one_rupee: "1 روپے گیم کھیلیں",
  bill_payment: "بل کی ادائیگی",
  bill_payment_to_name: "{name} کو بل کی ادائیگی",
  get_bill_discount: "تک حاصل کریں Rs.12.25 ہر بل پر",
  leaderboard: "لیڈر بورڈ",
  leaderboard_descp: "مزید ریچارج بچیں اور بائیک جیتیں",
  sale_invoice: "سیل انوائس",
  expense_bill: "اخراجات کا بل",
  business_Added_success: "کاروبار شامل کر دیا گیا ہے",
  maximun_limit_10000: "زیادہ سے زیادہ ادائیگی کی حد 10،000 ہے", //need to update
  transaction_paid_successfully: "ٹرانزیکشن کامیابی سے ادا کی گئی ہے",
  do_you_want_to_delete_image: "کیا آپ تصویر کو ڈیلیٹ کرنا چاہتے ہیں؟",
  items_added_success: "آئٹمز کو کامیابی کے ساتھ شامل ہو گیا ہے",
  no_item_found_add: "کوئی آئٹم نہیں ملا، ابھی شامل کریں",
  stock_updated_success: "اسٹاک کامیابی کے ساتھ اپ ڈیٹ ہوگیا ہے",
  stock_deleted_success: "اسٹاک کو کامیابی کے ساتھ ڈیلیٹ کر دیا گیا ہے",
  business_deleted_success: "کاروبار کو کامیابی کے ساتھ ڈیلیٹ کر دیا گیا",
  update_amount_with_item_total: "آئٹم ٹوٹل  کے ساتھ رقم اپ ڈیٹ کریں",
  date_time: "تاریخ/وقت",
  description: "تفصیل",
  failed: "ناکام",
  deposit: "جمع کی رقم",
  ucash_report: "یوکیش رپورٹ",
  total_easyload_given: "کل دیا گیا ایسی لوڈ",
  unable_to_get_wallet_balance: "والٹ بیلینس حاصل ھونے میں نا ممکن",
  ucash_list: "کی فہرست uCash",
  couldnt_request_early_access: "جلدی رسائی کی درخواست نہیں کرسکا",
  easypaisa_account_number: "ایزی پیسہ اکاؤنٹ نمبر",
  jazzcash_account_number: "جاز کیش اکاؤنٹ نمبر",
  enter_easypaisa_account_number: "اکاؤنٹ نمبر درج کریں EasyPaisa",
  enter_jazzcash_account_number: "جاز کیش اکاؤنٹ نمبر درج کریں ",
  your_account_number_is_easy_paisa_number:
    "آپ کا اکاؤنٹ نمبرآپ کا ایزی پیسہ فون نمبر ہوتا ہے",
  your_account_number_is_jazzcash_number:
    "آپ کا اکاؤنٹ نمبر آپ کا جاز کیش فون نمبر ہے",
  two_steps_away_from_percent: "2.5٪ کمانے سے 2 قدم دور",
  enter_deposit_amount: "جمع کی ھوی رقم درج کریں",
  deposit_for_easyload: "ایزی لوڈ کیلئے جمع کروائیں",
  enter_the_amount_you_want_to_deposit:
    "اپنے ایزی لوڈ اکاؤنٹ کے لئے جو رقم جمع کروانا چاہتے ہو اسے درج کریں",
  one_steps_away_from_percent: "2.5٪ کمانے سے 1 قدم دور",
  confirm_transfer: "ٹرانسفر کنفرم کریں",
  easypaisa_will_send_you_a_pin: "ایزی پیسہ آپ کو ایک پن بھیجے گا",
  jazzcash_will_send_you_a_pin: "جازکیش آپ کو ایک پن بھیجے گا",
  enter_pin_easypaisa: "براہ کرم ایزی پیسہ ایپ میں اپنا پن درج کریں",
  enter_pin_jazzcash: "براہ کرم جاز کیش ایپ میں اپنا پن درج کریں",
  amount: "رقم",
  from: "کس سے",
  to: "کس کو",
  your_easyload_account: "آپ کا ایزی لوڈ اکاؤنٹ",
  get_pin: "پن حاصل ڪريو",
  easyload_deposit_MPIN_confirm: "ایزی لوڈ ڈپازٹ کی لئے، ایم پن کی تصدیق کریں",
  request_mpin: "کی درخواست کریں MPIN",
  verify_mpin: "کی تصدیق کریں MPIN",
  did_not_recieve_mpin: "نھیں پھنچی MPIN",
  try_again: "پھر سے کوشش کریں",
  open_easypaisa_and_enter_pin: "ایزی پیسہ ایپ کھولیں اور پن درج کریں",
  open_jazzcash_and_enter_pin: "جاز کیش ایپ کھولیں اور پن درج کریں",
  waiting_for_you_to_verify_easyload_easypaisa:
    "ایزی پیسہ ایپ پر ایزی لوڈ ڈپازٹ کی رقم کی تصدیق کے لیے آپ کا انتظار ہے۔",
  waiting_for_you_to_verify_easyload_jazzcash:
    "جاز کیش ایپ پر ایزی لوڈ ڈپازٹ کی رقم کی تصدیق کے لیے آپ کا انتظار ہے۔",
  deposit_failed_mpin_not_verified:
    "کی توثیق نہیں ہوئی۔ MPIN جمع کروانے میں ناکام۔ ",
  to_earn_35_on_easyload_verify_mpin:
    "کی توثیق کریں۔ MPIN ایزی لوڈ پر 2.5٪ کمانے کے لئے ، اپنے",
  amount_deposited: "رقم جمع کردی گئی",
  ucash_deposit: "یوکیش ڈپازٹ",
  done: "ھو گیا",
  setup_for: "کے لئے سیٹ اپ",
  finish_hbl_payment: "ادائیگی کا سیٹ اپ مکمل کریں۔ HBL 5 آسان مراحل میں",
  earn_commission_upto_2: "2.5% کمیشن کمائیں",
  login_into_hbl: "ایپ میں لاگ ان کریں HBL اپنے",
  tap_on_more_btn: '"مزید" کے بٹن پر ٹیپ کریں',
  select_corporate_payment: "کارپوریٹ ادائیگی کا انتخاب کریں",
  select_udhaar_app_from_dropdown: "ڈراپ ڈاؤن سے اُدھار ایپ کا انتخاب کریں",
  add_details_and_done: "تفصیلات شامل کریں اور آپ کا کام ہوجاۓ گا",
  waiting_for_mpin: "کا انتظار MPIN",
  add_ucash_balance: "یو کیش بیلنس شامل کریں",
  takeout_cash: "ٹیک آؤٹ کیش",
  add_your_bank_account: "اپنا بینک اکاؤنٹ شامل کریں",
  to_change_bank_click_edit:
    "اپنا اکاؤنٹ شامل یا تبدیل کرنے کے لیے اپ ڈیٹ کے آئیکن پر کلک کریں",
  account_number: "اکاونٹ نمبر",
  enter_account_number: "اکاؤنٹ نمبر درج کریں (فون نمبر)",
  number: "نمبر",
  insufficient_balance: "ناکافی بیلینس",
  unable_to_withdraw: "انخلاء ناکام ہوگیا",
  cash_take_out_successful: "کیش ٹیک آؤٹ کامیاب",
  cash_taken_out: "کیش ٹیک آؤٹ",
  cash_will_be_deposited_in_24_hours:
    "رقم 24 گھنٹے میں آپ کے اکاؤنٹ میں جمع ہوجائے گی",
  easyload_details: "ایزی لوڈ کی تفصیلات",
  search_customer_by_phone: "کسڈمرس کو موبائل نمبر سے ڈھونڈیں #",
  contact_not_found: "کانکیکٹ نہیں ملا",
  setup_easyload_and_earn_up_to_35: "سیٹ اپ ایزی لوڈ اور %2.5 تک کمیشن کمائیں",
  finish_easyload_setup_2_steps: "3 مراحل میں ایزی لوڈ سیٹ اپ ختم کریں",
  earn_upto_35_commission: "2.5٪ تک کمیشن حاصل کریں",
  step_one: "اسٹیپ  1",
  step_two: "اسٹیپ  2",
  step_three: "اسٹیپ  3",
  tap_here: "یہاں کلک کریں",
  setup_screenlock: "اسکرین لاک سیٹ اپ کریں",
  enter_location: "مقام درج کریں",
  location_is_mandatory: "مقام لازمی ہے",
  location_permission: "سیٹنگز سے لوکیشن کی اجازت دیں",
  location_permission: "سیٹنگز سے لوکیشن کی اجازت دیں",
  add_balance_with_easypaisa_hbl_ubl:
    "کے ذریعے JazzCash یا HBL یا EasyPaisa بیلینس ڈالیں",
  easyload_and_earn_upto_35: "ایزی لوڈ کریں اور ٪2.5 تک جیتیں",
  cash_back: "کیش بیک ",
  recharge_report: "ریچارج رپورٹ",
  udhaar_bonus: "ادھار اضافی انعامات",
  load: "ریچارج",
  package: "پیکجز",
  packages: "پیکجز",
  select_a_package: "پیکیج منتخب کریں",
  view_package_details: "پیکیج کی تفصیلات دیکھیں",
  unable_to_get_networks: "نیٹ ورکس نہیں مل سکے",
  enter_phone_number: "موبائل نمبردرج کریں",
  easyload_amount: "ایسی لوڈ کی رقم",
  enter_easyload_amount: "ایزی لوڈ کی رقم درج کریں",
  minimum_recharge_amount_limit_50: "کم سے کم ریچارج کی رقم 50 ھونی چاھئیں",
  package_summary: "پیکج کا خلاصہ",
  commission_details: "کمیشن کی تفصیلات",
  udhaar_book_cashback: "ادھار بک کیش بیک",
  confirm_package: "پیکج کنفرم کریں",
  confirm_easyload: "ایزی لوڈ کنفرم کریں",
  sms_reciept_has_been_sent_to: "ایس ایم ایس کی رسید بھیجی گئی ہے",
  easyload_dispute_descp:
    "کیا غلط نمبر پر ٹرانزیکشن ہو گئی ہے؟ صحیح کروانا چاہتے ہیں؟",
  select_entry_to_file_dispute:
    "اُس ایزی لوڈ کو منتخب کریں جس پرایزی لوڈ نہیں ہوا",
  active_disputes: "جو ایزی لوڈ نہیں ہوا",
  pending_disputes: "جو ایزی لوڈ ہوگیا",
  would_you_like_to_file_a_dispute:
    "کیا غلط نمبر پر ٹرانزیکشن ہو گئی ہے؟ صحیح کروانا چاہتے ہیں؟",
  easyload_dispute_report: "جو ایزی لوڈ نہیں ہوا اس کی رپورٹ",
  wallet_is_currently_not_available:
    "والٽ هن وقت موجود ناهي. مهرباني ڪري ريفريش بٽڻ دٻايو۔",
  refresh: "ریفریش",
  choose_category: "تفصیلی فہر ست سے منتخب کریں",
  catalog_builder: "آئٹم کی تفصیلی فہر ست",
  catalog_descp:
    "ہماری پہلے سے موجودہ آئٹم کی تفصیلی فہر ست سے اپنا آئٹم منتخب کریں اور اپنی فہر ست بنائیں",
  select_products: "آئٹم منتخب کریں",
  cnic_placeholder: "نمبر درج کریں CNIC 13 ہندسوں کا",
  cnic_number_length: "شناختی کارڈ نمبر 11 ہندسوں کا ہونا چاہیے",
  sync: "سینک",
  Request_Send_success: "آپ کی پیمنٹ کی درخواست ایس ایم ایس پر بھیج دی گئی ہے",
  only_edit_from: "سے آپ اس ٹرانزیکشن کو ایڈٹ کر سکتے ہیں",
  account_locked_description:
    " آپ کا اکاؤنٹ بند ہوگیا ہے, مزید معلومات کے لیے ہم سے رابطہ کریں",
  wallet_not_available: "والیٹ دستیاب نہیں ہے",
  not_editable: "آپ اس ٹرانزیکشن کو ایڈٹ نہیں کرسکتے۔",
  dispute_active: "موجودہ",
  dispute_completed: "مکمل",
  data_sync_karein: "ڈیٹا سینک کریں",
  syncing: "سینکنگ",
  items_updated_success: "آئٹمز کامیابی کے ساتھ اپ ڈیٹ ہوگیا ہے",

  // salarybook
  paybook: "تنخوابک",
  add_staff_and_maintain_your_daily_attendance:
    "اسٹاف شامل کریں اورروزانہ کی حاضری کو برقرار رکہیں",
  add_staff: "اسٹاف شامل کریں",
  total_present: "کُل حاضر",
  total_absent: "کُل غیر حاضر",
  staff_search_placeholder: "اسٹاف (نام یا فون کے ذریعہ تلاش کریں)",
  add_staff_lowercase: "اسٹاف شامل کریں",
  this_number_associate_with_another_staff: "یہ نمبر دوسرے اسٹاف سے وابستہ ہے۔",
  staff_name: "اسٹاف کا نام",
  enter_staff_name: "اسٹاف کا نام درج کریں",
  select_salary_type: "تنخواہ کی قسم منتخب کریں",
  monthly: "ماہانہ",
  monthly_description:
    "مقررہ تنخواہ, ہر ماہ تنخواہ کی ادائیگی ، ماہانہ ادائیگی",
  weekly: "ہفتہ وار",
  weekly_description: "ہفتہ وار ادائیگی ، 7 دن کام کا چکر",
  daily: "روزانہ",
  daily_description:
    "روزانہ کی ادائیگی ، کام کرنے والے دن کی بنیاد پر ادائیگی ",
  hourly: "فی گھنٹہ",
  hourly_description: "پنچ ان - پنچ آؤٹ اوقات ، گھنٹہ ادائیگی کا نظام",
  salary_type_is_required: "تنخواہ کی قسم ضروری ہے",
  enter_salary_amount: "تنخواہ کی رقم ڈالیں",
  enter_staff_salary: "اسٹاف کی تنخواہ داخل کریں ",
  staff_salary: "اسٹاف کی تنخواہ",
  salary_is_required: "تنخواہ ضروری ہے",
  regular_working_hours: "نوکری کے عام اوقات",
  select_your_hours: "گھنٹے منتخب کریں",
  working_hours_req: "کام کے اوقات درکار ہیں",
  select_working_days: "کاروباری دن منتخب کریں",
  working_days_staff_can_be_marked:
    "کاروباری دن: اسٹاف کو  'حاضر' یا 'غیرحاضر' کے طور پر نشان زد کیا جا سکتا ہے۔",
  non_working_days_staff_can_be_marked:
    "یر کاروباری دن:اسٹاف کو 'موجودہ' یا 'چھٹی والا دن' کے طور پر نشان زد کیا جا سکتا ہے۔",
  select_working_days_and_hours: "کام کے دن اور اوقات منتخب کریں",
  select_working_days_small: "کام کے دنوں کا انتخاب کریں",
  save_staff: " اسٹاف محفوظ کریں",
  joining_date: "شامل ہوئے کی تاریخ ",
  select_joining_date: "شامل ہوئے کی تاریخ داخل کریں",
  staff_joining_date: "اسٹاف کے شامل ہونے کی تاریخ",
  staff_success_add: "اسٹاف کامیابی سے شامل ہوگیا",
  all_staff: "کُل اسٹاف",
  present: "حاضر",
  set_date_filter: "تاریخ کا فلٹر مقرر کریں",
  showing_staff_list_for: " اس اسٹاف کی فہرست دکھا رہیں ہیں",
  attendance: "حاضري",
  attendance_report: "حاضری کی رپورٹس",
  staff_lowercase: "اسٹاف",
  presents: "حاضر",
  absents: "غیر حاضری",
  days_lowercase: "دن",
  paid_holiday: "ادا ڪيل چھٹي",
  not_marked: "نشان زدہ نہیں",
  advance_from_staff: "اسٹاف سے ایڈوانس",
  pending_to_staff: "اسٹاف سے بقایا",
  closing_balance_small: "اختتامی بیلنس",
  balance_forward_from_last_month: "پچھلے مہینے سے آگے کا بیلنس",
  rs: "روپیہ.",
  payments_small: " ادائيگي",
  net_payments_given_and_taken_from_staff:
    "اسٹاف سے دی گئی اور لی گئی پوری ادائیگی",
  salary: "تنخواہ",
  total_salary_if_no_presents:
    "کل تنخواہ- اگر کوئی حاضری نہیں لگائی گی , تو تنخواہ صفر ہو جائے گی",
  pay_staff: "اسٹاف کو پے کریں",
  salary_slip: "تنخواہ کی پرچی ",
  salary_must_be_in_numbers: "تنخواہ نمبرمیں ہونی چاہئے",
  salary_cannot_be_0: "تنخواہ 0 نہیں ہوسکتی",
  all_days: "تمام دن",
  mark_attendance_in_bulk: "سب کی حاضری لگائیں۔",
  add_salary: "پيمنٽ  شامل ڪريو",
  enter_salary_and_advance_payments_to_staff:
    "اسٹاف کی تنخواہ اور ایڈوانس پیمنٹ انٹر کریں",
  total_salary: "کُل تنخواہ ",
  select_dates_for_salary_slip: "تنخواہ سلپ کے لیے تاریخیں منتخب کریں ،",
  staff_name_is_required: "اسٹاف کا نام داخل کرنا لازمی ہے",
  working_hours_are_required: "کام کے اوقات ضروری ہیں",
  working_hours_must_be_a_valid_number: "کام کے اوقات درست نمبر میں ہونا چاہئے",
  working_hours_cannot_be_a_0: "کام کے اوقات 0 نہیں ہوسکتے ہیں",
  profile_details: "پروفائل کی تفصیلات",
  staff_information: "اسٹاف کی معلومات",
  staff_name_lowercase: "اسٹاف کا نام",
  name: "نام",
  job_title: "نوکری کا عنوان",
  salary_details: "تنخواہ کی تفصیلات",
  salary_type_lowercase: "تنخواہ کی قسم",
  working_hours: "کام کے اوقات",
  working_days: "کاروباری دن",
  other: "دیگر",
  auto_present: "خودبخد حاضری ",
  delete_staff: " اسٹاف ڈیلیٹ",
  are_you_sure_you_want_to_delete_staff:
    "کیا آپ واقعی میں ڈیلیٹ کرنا چاہتے ہیں؟",
  staff_deleetd_success: "اسٹاف کامیابی سے ڈیلیٹ ہوگیا",
  staff_updated_successfully: "اسٹاف اپ ڈیٹ کامیاب ھوا ",
  no_data_for_date_range_was_found: "تاريخ جي حد تائين ، ڪوبه ڊيٽا نه مليو.!",
  are_you_sure_you_want_to_delete_this_payment:
    "کیا آپ واقعی یہ ادائیگی ڈیلیٹ کرنا چاہتے ہیں؟",
  payment_deleted_successfully: "ادائیگی کامیابی سے ڈیلیٹ ہو گئی",
  you_cant_schedule_a_payment_in_past:
    "آپ ماضی کی ادائیگی کا شیڈول نہیں بنا سکتے ہیں ",
  you_paid: "آپ نے ادا کیے",
  you_took: "آپ نے لیے",
  payment_date: "ادائیگی کی تاریخ",
  pay_online: "آن لائن ادائیگی کریں",
  confirm: "تصدیق کریں",
  youre_about_to_transfer_salary_of: "آپ تنخواہ منتقل کرنے والے ہیں ",
  add_staff_account: "اسٹاف کا اکاؤنٹ شامل کریں",
  payment_success: "پیمنٹ کامیابی سے محفوظ ہوگئی",
  edit_payment: "پیمنٹ میں ترمیم کریں",
  daily_statement: "روزانہ اسٹیٹمنٹ",
  grand_total: "ڪل تعداد",
  total_number_of_customers: "کسٹمرز کی تعداد:",
  payment_details: "ادائيگي جي تفصيلات",
  date_setted_success: "تاریخ کامیابی سے سیٹ ہوگئی",
  inventory_value: "انوینٹری کی قیمت",
  inventory_cost: "انوینٹری کی لاگت",
  stock_items: "اسٽاڪ شيءِ",
  inventory_item: "انوینٹری آئٹمز",
  sale_report: "سیل رپورٹ",
  item_sold: "فروخت شدہ آئٹم",
  total_profit: " کل منافع",

  // changes
  give_salary: "تنخواہ دیں",
  give_advance: "ایڈوانس دیں",
  pay_cash: "کیش ادا کریں",
  pay_salary: "تنخواہ ادا کریں",
  pay_advance: "ایڈوانس ادا کریں",
  inventory_report: "انوینٹری رپورٹ",
  verify_cashout: "کیش آؤٹ کی تصدیق کریں",
  send_and_receive_payment: "آن لائن پیمنٹس بھیجیں اور وصول کریں",
  connect_wallet: "والیٹ کنیکٹ کریں",
  setup_screen_lock: "اسکرین لاک سیٹ اپ کریں",
  lock_is_mandatory: "لاک لازمی ہے",
  easypaisa: "EasyPaisa",
  jazzcash: "JazzCash",
  popular: "مقبول",
  please_enter_registered_number:
    "براہ کرم اس اکاؤنٹ کے ساتھ رجسٹرڈ موبائل نمبر درج کریں",
  connect_you_wallet: "اپنا والیٹ کنیکٹ کریں",
  enter_password: "پاس ورڈ درج کریں",
  create_new_password: "نیا پاس ورڈ بنائیں",
  re_confirm_password: "پاس ورڈ دوبارہ کنفرم کریں",
  reenter_password: "پاس ورڈ دوبارہ درج کریں",
  password_setted: "پاس ورڈ کامیابی سے بن گیا",
  one_steps_away_from_completion: "آپ تکمیل سے صرف 1 قدم دور ہیں ",
  wallet_successful: "والیٹ کامیابی سے کنیکٹ ہوگیا",
  whats_your_password: "آپ کا پاس ورڈ کیا ہے؟",
  enter_password_to_proceed: "اسکرین پر جانے کے لیے پاس ورڈ درج کریں OTP",
  incorrect_password: "غلط پاس ورڈ",
  please_enter_password: "براہ کرم پاس ورڈ درج کریں",
  fee: "فیس",
  password: "پاس ورڈ",
  please_enter_your_pass: "براہ کرم اپنا پاس ورڈ درج کریں",
  please_confirm_your_pass: "براہ کرم اپنے پاس ورڈ کی تصدیق کریں",
  password_mismatch: "پاس ورڈز مماثل نہیں ہیں۔ براہ کرم دوبارہ پاس ورڈ درج کریں",
  verify_cashout_details: "کیش آؤٹ کی تفصیلات کی تصدیق کریں",

  staff_book: "اسٹاف بک",
  working_hours_can_not_less_24: "کام کے اوقات 24 گھنٹے سے زیادہ نہیں ہوسکتے",
  date: "تاریخ",
  unit: "یونٹ",
  cnic_number: "نمبر CNIC",
  suppliers_descp:
    "سپلائر شامل کریں اور خریداری کا حساب رکھیں۔ مفت ادائیگی یاد دہانی۔ وصولی 3 گنا تیز",
  add_supplier: "سپلائر شامل کریں",
  this_number_associate_with_another_supplier:
    "یہ نمبر پہلے سے کسی اور سپلائیر کے ساتھ منسلک ہے",
  supplier_added_successfully: "سپلائیر کامیابی سے شامل ہوگیا",
  supplier_deleted_successfully: "سپلائیر کامیابی سے ڈیلیٹ ہوگیا",
  create_suppliertitle: "سپلائیر بنائیں",
  total_supplier: "سپلائرز",
  supplier_name: "سپلائیر کا نام",
  total_number_of_supplier: "سپلائیرز کی تعداد:",
  supplierprofileheading: "سپلائیر پروفائل",
  do_you_want_to_delete_supplier: "کیا آپ سپلائیر کو ڈیلیٹ کرنا چاہتے ہیں؟",
  supplier_statement: "سپلائیر اسٹیٹمنٹ",
  no_supplier_found: "کوئی سپلائیر نہیں ملا، شامل کریں ",
  no_filter_match_supplier: "آپ کے فلٹر سے کوئی سپلائیر مماثل نہیں ملا",

  customer_to_supplier: "کسٹمر کامیابی سے سپلائیر میں تبدیل ہوگیا",
  supplier_to_customer: "سپلائیر کامیابی سے کسٹمر میں تبدیل ہوگیا",
  convert_to_customer: "کسٹمر میں تبدیل کریں",
  convert_to_supplier: "سپلائیر میں تبدیل کریں",
  convert_all_supplier_entries_to_customer:
    "اس سپلائیر کی تمام انٹریز کسٹمر سیکشن میں منتقل کردی جائیں گی",
  convert_all_customer_entries_to_supplier:
    "اس کسٹمر کی تمام انٹریز سپلائیر سیکشن میں منتقل کردی جائیں گی",
  stock_description:
    "آئٹمز شامل کریں اور اسٹاک مینٹین کریں۔ تیار شدہ آئٹم کیٹلاگ۔ منافع کی رپورٹ۔",
  supplier_updated_successfully: "سپلائیر کامیابی سے اپ ڈیٹ ہوگیا",
  quantity: "مقدار",
  customer_depposit_success:
    "آپ کے کسٹمر کے اکاؤنٹ میں پیسے جمع ہوگئے ہیں",
  cnic_required: "درکار ہے CNIC",
  easypaisa_transaction_details: "ٹرانزیکشن کی تفصیلات EasyPaisa",
  enter_transfer_amount: "ٹرانسفر کی رقم درج کریں",
  easypaisa_in_out: "پیسے آنا/جانا EasyPaisa",
  business_type: "بزنس کی قسم",

  selling_price_label: "قیمت فروخت درج کریں (اختیاری)",
  cost_price_label: " قیمت خرید درج کریں (اختیاری)",
  category: "کیٹیگری",
  pay_bill: "بل ادا کریں",
  pay_remaining: "بقیہ ادائیگی کریں",
  open_free_account: "مفت اکاؤنٹ بنائیں",
  remaining_payment: "بقیہ رقم",
  you_have_received_cashback: "آپ کو Rs. {amount} کیش بیک ملا ہے!",
  create_account_claim_rewards_note: "انعامات حاصل کرنے اور بل کی ادائیگیوں پر کمانے کے لیے روپن اکاؤنٹ بنائیں۔",
  activate_your_wallet: "اپنا والیٹ ایکٹیویٹ کریں",
  activate_wallet_note: "فوری طور پر ادائیگیاں بھیجنے، وصول کرنے اور منظم کرنے تک رسائی حاصل کریں",
  activate_wallet: "والیٹ ایکٹیویٹ کریں",
  no_customer_founds: "کوئی کسٹمر نہیں ملا",
  lets_setup_your_udhaar_account: "آئیں اپنا Udhaar اکاؤنٹ سیٹ اپ کریں",
  pakistans_1_trusted_business_app: "پاکستان کا #1 بزنس پلیٹ فارم",
  you_will_receive_OTP_code: "مجھے OTP کوڈ موصول ہوگا",
  notes_optional: "نوٹس / تفسیر (اختیاری)",
  barcode_label: "بارکوڈ (اختیاری)",
  enter_category: "کیٹیگری درج کریں",
  Apna_insurance_plan_select_karein: "اپنا انشورنس پلان منتخب کریں",
  Insurance_summary: "انشورنس کا خلاصہ",
  View_insurance_plans: "انشورنس پلانز دیکھیں",
  Request_submitted: "درخواست جمع ہوگئی",
  Humne_aapki_insurance_request_record_karli_hai_Humara_numainda_jald_aapse_rabta_karayga:
    "ہم نے آپ کی انشورنس کی درخواست ریکارڈ کرلی ہے۔ ہمارا نمائندہ جلد آپ سے رابطہ کرے گا۔",
  Aap_ka_plan_already_subscribed_hai: "آپ کا پلان پہلے سے سبسکرائب شدہ ہے",
  Already_subscribed: "پہلے سے سبسکرائب شدہ",
  order_management: "آرڈر مینجمنٹ",
  order_management_capital: "آرڈر مینجمنٹ",
  stock_management: "اسٹاک مینجمنٹ",
  stock_management_small: "اسٹاک مینجمنٹ",

  orders: "آرڈرز",
  returns: "ریٹرنز",
  order_accepted: "آرڈر قبول کرلیا گیا",
  order_pending: "آرڈر زیر التوا",
  order_returned: "آرڈر واپس کردیا گیا",
  order_id: "آرڈر آئی ڈی #",
  order_status: "آرڈر کی صورتحال",
  total_price: "کل قیمت",
  reject: "مسترد کریں",
  accept_small: "قبول کریں",
  product_id: "ID پروڈکٹ",
  order_qty: "آرڈر کی گئی مقدار",
  calculation: "حساب کتاب",
  sub_total: "سب ٹوٹل",
  total_tax: "کل ٹیکس",
  discount: "ڈسکاؤنٹ",
  customer_details: "کسٹمر کی تفصیلات",
  email_address: "ای میل ایڈریس",
  delivery_address: "ڈیلیوری ایڈریس",
  are_you_sure: "کیا آپ کو یقین ہے،",
  you_want_to_reject_this_order: "آپ یہ آرڈر مسترد کرنا چاہتے ہیں؟",
  order_reject: "آرڈر مسترد",
  please_share_ur_reason: "براہ کرم اپنی وجہ بتائیں",
  add_note_to_the_order: "آرڈر میں نوٹ شامل کریں",
  order_confirmation: "آرڈر کی تصدیق",
  you_want_to_confirm_order: "آپ اس آرڈر کی تصدیق کرنا چاہتے ہیں؟",
  order_delivered: "آرڈر ڈیلیور کردیا گیا",
  select_reason: "وجہ منتخب کریں",
  available_quantity: "دستیاب مقدار",
  edit_item_quantity: "آئٹم کی مقدار میں ترمیم کریں",
  per_item: "فی آئٹم",
  ready_to_ship: "شپ کرنے کے لیے تیار",
  enter_reason_here: "یہاں وجہ درج کریں",
  order_payment_method: "پیمنٹ کا طریقہ",
  You_havent_placed_any_order_yet:
    "ابھی تک آپ کا کوئی آرڈر نہیں ہے۔ جب آپ کو کوئی آرڈر ملے گا، وہ یہاں ظاہر ہوگا۔",
  select_dispatch_date: "ترسیل کی تاریخ منتخب کریں",
  dispatch_date: "ترسیل کی تاریخ",
  date_of_purchase: "خریداری کی تاریخ",
  tracking_id: "ID ٹریکنگ",
  return: "ریٹرن",
  total_return_value: "کل ریٹرن ویلیو",
  evidance_of_return: "ریٹرن کا ثبوت",
  evidence: "ثبوت",
  total_order_value: "کل آرڈر ویلیو",
  pending_on_customer: "کسٹمر کی طرف زیر التوا",
  ready_to_ship: "شپ کرنے کے لیے تیار",
  returned: "واپس کردیا گیا",
  delivered: "ڈیلیور کردیا گیا",
  delivered: "ڈیلیور کردیا گیا",
  rejected: "مسترد کردیا گیا",
  shipped: "شپ کردیا گیا",
  cancelled: "منسوخ کردیا گیا",
  cod: "COD",
  return_management: "ریٹرن مینجمنٹ",
  you_have_not_received_any_return:
    "آپ کو ابھی تک کوئی ریٹرن آرڈر موصول نہیں ہوا، جب ریٹرن ہوگا تو اس کی صورتحال یہاں ظاہر ہوگی۔",
  received_customer_return: "کسٹمر کا ریٹرن موصول ہوگیا",
  awaiting_customer_return: "کسٹمر کے ریٹرن کا انتظار",
  add_new_stock: "نیا اسٹاک شامل کریں",
  upload_bulk_items: "بلک آئٹمز اپ لوڈ کریں",
  upload_or_create_stock: "بلک اپ لوڈ کریں یا نیا اسٹاک بنائیں",
  save_for_later: "بعد کے لیے محفوظ کریں",
  save_and_publich: "محفوظ کریں اور پبلش کریں",
  create_stock: "اسٹاک بنائیں",
  sub_category: "سب کیٹیگری",
  brand: "برانڈ",
  wholesale_price: "ہول سیل قیمت",
  msrp: "MSRP",
  minimum_order_qty_optional: "کم از کم آرڈر مقدار",
  warranty_period_optional: "وارنٹی کی مدت (اختیاری)",
  specification: "اسپیسیفیکیشن",
  enter_specification: "اسپیسیفیکیشن درج کریں",
  delivery_date: "ڈیلیوری کی تاریخ",
  accepted: "قبول شدہ",
  sku: "SKU",
  in_stock: "اسٹاک میں موجود",
  price: "قیمت",
  publish: "پبلش کریں",
  add_item_details: "آئٹم کی تفصیلات شامل کریں",
  pricing: "پرائسنگ",
  inventory: "انوینٹری",
  addtional_information: "اضافی معلومات",
  discount_optional: "ڈسکاؤنٹ",
  page_not_found: "صفحہ نہیں ملا",
  we_re_sorry_the_page_you_requested:
    "معذرت، آپ کا درخواست کردہ صفحہ نہیں مل سکا۔",
  stock_image: "اسٹاک تصویر",
  upload_image: "تصویر اپ لوڈ کریں",
  date_of_creation: "تخلیق کی تاریخ",
  customer_tracking_id: "کسٹمر ٹریکنگ آئی ڈی",
  order_details: "آرڈر کی تفصیلات",
  seller_tracking_id: "سیلر ٹریکنگ آئی ڈی",
  creation_date: "تخلیق کی تاریخ",
  purchase_date: "خریداری کی تاریخ",
  evidence_image: "ثبوت کی تصویر",
  evidence_video: "ثبوت کی ویڈیو",
  publish_all: "سب شائع کریں",
  edit_stock: "اسٹاک میں ترمیم کریں",
  qty_available: "دستیاب مقدار",
  item_specification: "آئٹم کی خصوصیات",
  warranty_period: "وارنٹی کی مدت",
  minimum_order_quantity: "کم از کم آرڈر مقدار",
  unpublished: "غیر شائع شدہ",
  waiting_approval: "منظوری کا انتظار",
  delivery_add: "پتہ",
  managing_your_inventory_has_never:
    "اُدھار بک کے ساتھ اپنی انوینٹری کا انتظام کبھی اتنا آسان نہیں تھا",
  start: "شروع کریں",
  wasooli_tez_safe: "3 گنا تیز وصولی۔ 100% محفوظ۔",
  print_label: "لیبل پرنٹ کریں",
  publish_item: "آئٹم شائع کریں",
  would_you_like_to_publish_this: "کیا آپ یہ آئٹم شائع کرنا چاہتے ہیں",
  would_you_like_to_publish: "کیا آپ شائع کرنا چاہتے ہیں",
  on_your_catalog: "اپنے کیٹلاگ میں؟",
  would_you_like_to_delete: "کیا آپ حذف کرنا چاہتے ہیں",
  this_item: "یہ آئٹم",
  all_selected_item: "تمام منتخب آئٹمز",
  upload_photo: "تصویر اپ لوڈ کریں",
  msrp_optional: "(اختیاری) MSRP",
  terms_and_conditions_optional: "شرائط و ضوابط (اختیاری)",
  search_stock_by_name: "نام سے اسٹاک تلاش کریں",
  delivery_charges: "ڈیلیوری چارجز",
  partner_markup: "پارٹنر مارک اپ",
  return_policy_and_warranty_details: "واپسی کی پالیسی اور وارنٹی کی تفصیلات",
  order_filter: "آرڈر فلٹر",
  pdf_option: "کا آپشن PDF",
  search_by_order_number_customer_product:
    "آرڈر نمبر، کسٹمر یا پروڈکٹ سے تلاش کریں",
  mark_as: "نشان زد کریں",
  you_want_to_ship_this_order: "آپ اس آرڈر کو شپ کرنا چاہتے ہیں؟",
  print_bill: "بل پرنٹ کریں",
  print_loadsheet: "لوڈ شیٹ پرنٹ کریں",
  courier: "کوریئر",
  accounts: "اکاؤنٹس",
  in_out: "اندر / باہر",
  saddar_orders: "آرڈرز Saddar",
  saddar_inventory: "انوینٹری Saddar",
  saddar: "Saddar",
  saddar_managenet: "انتظام Saddar",
  saddar_seller_central: "سیلر سینٹرل Saddar",
  veiw_orders: "آرڈرز دیکھیں",
  download_template: "ٹیمپلیٹ ڈاؤن لوڈ کریں",
  in_the_file: "فائل میں؟",
  file_zip: "File.zip",
  uploading_with_dot: "اپ لوڈ ہو رہا ہے",
  download_invoice: "انوائس ڈاؤن لوڈ کریں",
  weight_gm: "وزن (گرام)",
  select_weight_type: "وزن کی قسم منتخب کریں",
  please_select_order_weight: "براہ کرم آرڈر کا وزن منتخب کریں",
  select_parcel_type: "پارسل کی قسم منتخب کریں",
  please_select_parcel_type: "براہ کرم پارسل کی قسم منتخب کریں",
  ship_order: "آرڈر شپ کریں",
  un_publish: "غیر شائع کریں",
  add_variants: "ویریئنٹس شامل کریں",
  stock_variants: "ویریئنٹس",
  placeholder_item_name: "مثلاً پاور بینک",
  placeholder_item_category: "کیٹیگری منتخب کریں",
  placeholder_item_subcat: "سب کیٹیگری منتخب کریں",
  placeholder_item_brand: "برانڈ منتخب کریں",
  placeholder_item_price: "Rs. 1000 مثلاً",
  placeholder_item_discount: "Rs. 100 مثلاً",
  placeholder_item_quantity: "مثلاً 25",
  placeholder_item_moq: "مثلاً 5",
  placeholder_item_weight: "مثلاً 550 گرام",
  placeholder_item_warranty: "وارنٹی کی مدت منتخب کریں",
  placeholder_item_detail: "فاسٹ چارجنگ mAh مثلاً 20,000",
  placeholder_item_return_policy: "یہاں وارنٹی اور واپسی کی تفصیلات لکھیں",
  discount_more_than_price: "ڈسکاؤنٹ کی رقم قیمت سے زیادہ نہیں ہو سکتی!",
  view_ledger: "لیجر دیکھیں",
  ledger: "لیجر",
  search_by_desc_amount_balance: "تفصیل، رقم یا بیلنس سے تلاش کریں",
  ledger_entries: "لیجر اندراجات",
  actions: "کارروائیاں",
  time: "وقت",
  ledger_management: "لیجر کا انتظام",
  ledger_non_ideal_desc:
    "اس وقت لیجر میں کوئی اندراج موجود نہیں ہے، جیسے ہی کوئی ٹرانزیکشن ہوگی، یہ یہاں دکھائی دے گی۔",
  search_by_desc: "تفصیل سے تلاش کریں",
  search_by_item_name: "آئٹم کے نام سے تلاش کریں",

  // Sale Book
  open_item: "کھلا آئٹم",
  stock_item: "اسٹاک آئٹم",
  sale_pos: "سیل پوس",
  draft_sale: "ڈرافٹ سیلز",
  sale_items: "سیل آئٹمز",
  item_non_ideal_desc: "براہ کرم فہرست میں آئٹمز شامل کریں",
  enter_open_amount: "کھلے آئٹم کی رقم درج کریں",
  current_sale: "موجودہ سیل",
  clear_item: "آئٹمز صاف کریں",
  pos_clear_all_items_title: "تمام آئٹمز صاف کریں؟",
  pos_clear_all_items_body:
    "کیا آپ واقعی فہرست سے تمام آئٹمز صاف کرنا چاہتے ہیں؟",
  new_sale: "نئی سیل",
  checkout: "چیک آؤٹ",
  order_summary: "آرڈر کا خلاصہ",
  item_name: "آئٹم کا نام",
  qty: "مقدار",
  amount: "رقم",
  tax: "ٹیکس",
  payment_successfully: "ادائیگی کامیاب",
  amount_paid: "ادا شدہ رقم بذریعہ",
  change: "بقایا رقم",
  print_recipt: "رسید پرنٹ کریں",
  online_payment_checkout: "اپنی سیل کو آن لائن ادائیگی کے طور پر ریکارڈ کریں",
  udhaar_checkout: "اپنی سیل کو اُدھار کے طور پر ریکارڈ کریں",
  bill_amount: "بل کی رقم",
  online_payment: "آن لائن ادائیگی",
  start_selling: "آئٹمز فروخت کرنا شروع کریں",
  create_stock_book_item: "انوینٹری میں آئٹمز بنائیں یا کھلے آئٹمز فروخت کرنا شروع کریں",
  sell_open_item: "کھلے آئٹمز فروخت کریں",
  start_creating_item: "آئٹمز بنانا شروع کریں",
  error_message_more_than_10digits: "ایرر: 10 ہندسوں سے زیادہ شامل نہیں کیے جا سکتے",
  order_history: "آرڈر ہسٹری",
  max_limit_reached: "زیادہ سے زیادہ حد مکمل ہو گئی",
  draft_message: "کیا آپ اس آرڈر کو ڈرافٹ سیلز میں محفوظ کرنا چاہتے ہیں؟",
  discard: "مسترد کریں",
  no_draft_sale: "دکھانے کے لیے کوئی ڈرافٹ سیل موجود نہیں",
  no_draft_sale_desc: "ابھی تک آپ کی کوئی ڈرافٹ سیل نہیں ہوئی۔",
  on_going_sale: "جاری سیل",
  on_going_sale_desc:
    "کیا آپ دوسری سیل جاری رکھنے سے پہلے اس سیل کو محفوظ کرنا چاہتے ہیں؟",
  sale_history: "سیلز ہسٹری",
  no_order_history: "دکھانے کے لیے کوئی آرڈر ہسٹری موجود نہیں",
  no_order_history_desc: "ابھی تک آپ کی کوئی آرڈر ہسٹری نہیں ہے۔",
  order_history_detail_desc:
    "سیل کی تفصیلات دیکھنے کے لیے فہرست میں سے سیل پر کلک کریں۔",
  order_no: "آرڈر نمبر",
  pos_order_no: "آرڈر نمبر",
  sale_details: "سیل کی تفصیلات",
  download_recipt: "رسید ڈاؤن لوڈ کریں",
  print_receipt: "رسید پرنٹ کریں",
  sales_history: "سیلز ہسٹری",
  sale_book: "سیل بک",
  print_invoice: "انوائس پرنٹ کریں",
  print_invoice: "انوائس پرنٹ کریں",
  reports: "رپورٹس",
  low_stock_report: "کم اسٹاک رپورٹ",
  low_stock_item: "کم اسٹاک آئٹمز",
  low_stock_item_value: "کم اسٹاک آئٹمز کی قیمت",
  stock_in: "اسٹاک ان",
  stock_out: "اسٹاک آؤٹ",
  stock_value: "Stock value",
  stock_report: "اسٹاک رپورٹ",
  total_items: "کل آئٹمز",
  sales_report: "سیلز رپورٹ",
  pos_sales: "پوس (فروخت)",
  inout: "آمد / اخراج",
  no_result_found: "کوئی نتیجہ نہیں ملا",
  to_adjust_your_filter:
    "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے اپنا فلٹر تبدیل کر کے دیکھیں۔",
  this_product_has_options_like_size_or_color:
    "اس پروڈکٹ میں سائز یا رنگ جیسے آپشنز موجود ہیں",
  stock_book: "اسٹاک بک",
  stock_in_out: "اسٹاک ان / آؤٹ",
  bulk_upload: "بلک اپ لوڈ",
  create_item: "آئٹم بنائیں",
  search_items: "آئٹمز تلاش کریں",
  low_stock: "کم اسٹاک والے آئٹمز",
  total_stock_items: "کل اسٹاک آئٹمز",
  stock_value: "اسٹاک کی قیمت",
  low_stock_items: "کم اسٹاک آئٹمز",
  low_stock_value: "کم اسٹاک کی قیمت",
  add_quick_item: "فوری آئٹم شامل کریں",
  create_stock_item: "اسٹاک آئٹم بنائیں",
  change_image: "تصویر تبدیل کریں",
  secondary_unit: "ثانوی یونٹ",
  sell_rs: "(Rs.) فروخت",
  cost_rs: "لاگت (روپے)",
  barcode_number: "بار کوڈ نمبر",
  expiry_date: "میعاد ختم ہونے کی تاریخ",
  expiry_alert: "میعاد ختم ہونے کا الرٹ",
  batch_number: "بیچ نمبر",
  manufacturing_date: "تیاری کی تاریخ",
  sale_history: "سیلز ہسٹری",
  sale_book: "سیل بک",
  filter_sort: "فلٹر اور ترتیب",
  view_invoice: "انوائس دیکھیں",
  tax_added: "ٹیکس شامل کیا گیا",
  add_tax: "ٹیکس شامل کریں",
  disount_added: "ڈسکاؤنٹ شامل کیا گیا",
  add_dicount: "ڈسکاؤنٹ شامل کریں",
  subtotal: "سب ٹوٹل",
  enter_cash_amount: "نقد رقم درج کریں",
  charge_rs: "(Rs.) چارج",
  charge_amount_shortcut: "چارج {amount} روپے (شفٹ + انٹر)",
  enter: "درج کریں",
  shift: "شفٹ",
  stock_list_desc: "کیا آپ اسٹاک لسٹ میں بھی آئٹم کی قیمت اپ ڈیٹ کرنا چاہتے ہیں؟",
  note_placeholder: "یہاں تفصیلی نوٹ شامل کریں",
  online: "آن لائن",
  paid_via: "ادائیگی بذریعہ",
  search_order: "کسٹمر کا نام، رقم، یا سیل نمبر سے تلاش کریں",
  saleID: "سیل آئی ڈی",
  search_items: "آئٹمز تلاش کریں",
  no_result: "کوئی نتائج نہیں ملے",
  create: "بنائیں",
  as_new_item: "نئے آئٹم کے طور پر",
  date_range: "تاریخوں کی حد",
  additional_details: "اضافی تفصیلات",
  order_history_not_found: "آرڈر ہسٹری نہیں ملی",
  this_product_has_options_like_size_or_color:
    "اس پروڈکٹ میں سائز یا رنگ جیسے آپشنز موجود ہیں",
  account_overview: "اکاؤنٹس کا جائزہ",
  stock_overview: "اسٹاک کا جائزہ",
  dat_set_karein: "تاریخ منتخب کریں",
  as_supplier: "بطور سپلائر",
  as_customer: "بطور کسٹمر",
  supplier: "سپلائر",
  enter_phone_number: "فون نمبر درج کریں",
  enter_supplier_name: "سپلائر کا نام درج کریں",
  save_changes: "تبدیلیاں محفوظ کریں",
  discard_changes: "تبدیلیاں مسترد کریں",
  upload_stock_items:
    "اپنی فائل اپ لوڈ کریں یا آئٹمز فارمیٹ کرنے میں مدد کے لیے ٹیمپلیٹ ڈاؤن لوڈ کریں",
  upload_file: "فائل اپ لوڈ کریں",
  select_file_or_drag: "فائل منتخب کریں یا یہاں ڈریگ اینڈ ڈراپ کریں",
  min_validation_message: "سے کم نہیں ہو سکتا",
  file_size_validation: "فائل کا سائز اس سے زیادہ نہیں",
  image_format_valid: "براہ کرم درست تصویری فائل منتخب کریں (JPEG, PNG, یا JPG)",
  type_name: "نام لکھیں",
  udhaar_payment_success: "یہ ٹرانزیکشن اکاؤنٹس میں بھی شامل کر دی گئی ہے",
  order: "آرڈر",
  max_validation_message: "سے زیادہ نہیں ہو سکتا",
  cant_be: "نہیں ہو سکتا",
  yearly: "سالانہ",
  weekly: "ہفتہ وار",
  daily: "روزانہ",
  monthly: "ماہانہ",
  overview: "جائزہ",
  purchases: "خریداریاں",
  non_ideal_graph_udhaar_title: "اُدھار کا حساب نظر نہیں آ رہا؟",
  non_ideal_graph_udhaar_subtitle:
    "ابھی ریکارڈ کریں اور منتخب مدت کے لیے اُدھار کا حساب کتاب دیکھیں",
  graph_udhaar_btn_title: "اُدھار ریکارڈ کریں",
  non_ideal_acc_udhaar_title: "کیا اس نے آپ کا اُدھار دینا ہے؟",
  non_ideal_acc_udhaar_subtitle:
    "ابھی کسٹمر شامل کریں اور ان کے ساتھ ادھار کا حساب ریکارڈ کریں",
  pending_accounts: "بقایا اکاؤنٹس",
  amount_in_rs: "میں Rs. رقم",
  low_stock_item: "کم اسٹاک آئٹمز",
  non_ideal_dash_stock_title: "ہر آئٹم پر نظر رکھیں",
  non_ideal_dash_stock_subtitle:
    "آئٹم کم ہو یا زیادہ، اب ہر پل نظر رکھیں",
  non_ideal_graph_sale_title: "اپنی سیلز کی ترقی دیکھیں",
  non_ideal_graph_sale_subtitle: "بروقت سیلز کی ترقی دیکھتے جائیں",
  add_sale: "سیل شامل کریں",
  non_ideal_dash_sale_title: "اپنے ٹاپ آئٹمز سے باخبر رہیں",
  non_ideal_dash_sale_subtitle: "آپ کا کونسا آئٹم سب سے زیادہ ڈیمانڈ میں ہے؟",
  add_top_item: "ٹاپ آئٹم شامل کریں",
  top_sale_item: "زیادہ فروخت ہونے والے آئٹمز",
  non_ideal_dash_purchase_title: "اپنی تمام خریداری ایک نظر میں دیکھیں",
  non_ideal_dash_purchase_subtitle:
    "کتنے میں لے رہے ہیں، کتنے میں بیچ رہے ہیں اور کتنا منافع کما رہے ہیں، سب ایک ہی جگہ دیکھیں",
  add_purchase: "خریداری شامل کریں",
  sale_rs: "فروخت روپے",
  profilt_rs: "منافع روپے",
  sale_invoice: "سیل انوائس",
  create_sale_invoice: "سیل انوائس بنائیں",
  contact_no: "رابطہ نمبر",
  due_date: "آخری تاریخ",
  customer_created: "کسٹمر کامیابی سے شامل ہو گیا",
  supplier_created: "سپلائر کامیابی سے شامل ہو گیا",
  enter_total_amount_error: "براہ کرم آئٹمز یا کل رقم درج کریں",
  quantity_error: "قیمت یا مقدار 0 نہیں ہو سکتی",
  not_available: "دستیاب نہیں",
  item_discount_error: "ڈسکاؤنٹ آئٹم کی قیمت سے زیادہ نہیں ہو سکتا۔",
  enter_tax: "ٹیکس درج کریں",
  cash_small: "نقد",
  write_name: "نام لکھیں",
  enter_paid_amount: "ادا کی گئی رقم درج کریں",
  enter_recieved_amount: "وصول کی گئی رقم درج کریں",
  summary: "خلاصہ",
  balance_amount_error:
    "وصول کی گئی رقم کل رقم سے زیادہ نہیں ہو سکتی",
  expense_balance_amount_error:
    "ادا کی گئی رقم اخراجات کی رقم سے زیادہ نہیں ہو سکتی",
  sale_balance_amount_error:
    "ادا کی گئی رقم فروخت کی رقم سے زیادہ نہیں ہو سکتی",
  sort: "ترتیب دیں",
  delivery_challan: "ڈیلیوری چالان",
  record_payment: "ادائیگی ریکارڈ کریں",
  send_payment: "ادائیگی بھیجیں",
  print: "پرنٹ کریں",
  enter_received_amount: "وصول کی گئی رقم درج کریں",
  discard_invoice_desc:
    "کیا آپ واقعی اس انوائس کو حذف کرنا چاہتے ہیں؟ یہ عمل واپس نہیں کیا جا سکتا۔",
  discard_invoice_title: "انوائس حذف کریں",
  discard_bill_title: "بل حذف کریں",
  discard_invoice_btn: "جی ہاں، یہ انوائس حذف کریں",
  discard_bill_btn: "جی ہاں، یہ بل حذف کریں",
  discard_transaction_btn: "جی ہاں، یہ ٹرانزیکشن حذف کریں",
  discard_transaction_title: "ٹرانزیکشن حذف کریں",
  discard_contact_btn: "جی ہاں، یہ رابطہ حذف کریں",
  discard_contact_title: "رابطہ حذف کریں",
  max_length_6digit: "زیادہ سے زیادہ لمبائی: 6 ہندسے",
  pos_sales: "پوس (فروخت)",
  inout: "آمد / اخراج",
  already_exist_item:
    "یہ آئٹم پہلے سے موجود ہے۔ ایک جیسے آئٹمز کی اجازت نہیں ہے",
  enter_quantity: "مقدار درج کریں",
  enter_price: "قیمت درج کریں",
  go_back_invoice_listing: "انوائس لسٹنگ پر واپس جائیں",
  go_back_bill_listing: "بل لسٹنگ پر واپس جائیں",
  go_back_invoice_report: "رپورٹ پر واپس جائیں",
  non_ideal_invoice_book:
    "جو آپ تلاش کر رہے ہیں اسے ڈھونڈنے کے لیے انوائس کو کسی دوسرے نام سے تلاش کریں۔",
  non_ideal_bill_book:
    "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے کسی اور نام سے بل تلاش کریں۔",
  sales_report: "سیلز رپورٹ",
  create_invoice: "انوائس بنائیں",
  create_bill: "بل بنائیں",
  preview: "پریویو",
  create_purchase_bill: "خریداری کا بل بنائیں",
  edit_purchase_bill: "خریداری کے بل میں ترمیم کریں",
  edit_sale_invoice: "سیل انوائس میں ترمیم کریں",
  edit_invoice: "انوائس میں ترمیم کریں",
  edit_bill: "بل میں ترمیم کریں",
  max_20_character: "زیادہ سے زیادہ: 20 حروف",
  type_signature_name: "دستخط کا نام ٹائپ کریں",
  invoice_date: "انوائس کی تاریخ",
  po_date: "کی تاریخ PO",
  invoice_items: "انوائس آئٹمز",
  purchased_items: "خریدے گئے آئٹمز",
  amount_received: "وصول شدہ رقم",
  partial_paid: "جزوی ادائیگی",
  units: "یونٹس",
  farokht: "فروخت",
  no_items_have_been_added_to_this_invoice_yet:
    "ابھی تک اس انوائس میں کوئی آئٹم شامل نہیں کیا گیا",
  no_items_have_been_added_to_this_bill_yet:
    "ابھی تک اس بل میں کوئی آئٹم شامل نہیں کیا گیا",
  click_edit_invoice_to_include_the_items_you_billing_for:
    "جن آئٹمز کا بل بنانا ہے انہیں شامل کرنے کے لیے 'انوائس میں ترمیم کریں' پر کلک کریں۔",
  click_edit_bill_to_include_the_items_you_billing_for:
    "جن آئٹمز کا بل بنانا ہے انہیں شامل کرنے کے لیے 'بل میں ترمیم کریں' پر کلک کریں۔",
  no_products_were_added_to_this_invoice:
    "اس انوائس میں کوئی پروڈکٹ شامل نہیں کیا گیا",
  you_can_only_add_items_to_an_invoice_while_its_unpaid:
    "آپ صرف اس وقت انوائس میں آئٹمز شامل کر سکتے ہیں جب وہ ادا نہ کی گئی ہو۔",
  report_download: "رپورٹ کامیابی سے ڈاؤن لوڈ ہو گئی",
  backup_in_progress_shortly: "بیک اپ جاری ہے۔ براہ کرم تھوڑی دیر بعد دوبارہ کوشش کریں",
  error_downloading_report: "رپورٹ ڈاؤن لوڈ کرنے میں خرابی",
  successfully_download_invoice: "انوائس کامیابی سے ڈاؤن لوڈ ہو گئی",
  create_sale_invoice: "سیل انوائس بنائیں",
  want_to_create_purchase_bill:
    "اس کے بجائے خریداری کا بل بنانا چاہتے ہیں؟ یہاں کلک کریں",
  want_to_create_sale_invoice:
    "اس کے بجائے سیل انوائس بنانا چاہتے ہیں؟ یہاں کلک کریں",
  create_my_first_invoice: "اپنی پہلی انوائس بنائیں",
  create_my_first_bill: "اپنا پہلا بل بنائیں",
  start_by_creating_invoice:
    "انوائس بنا کر شروع کریں اور اپنی ادائیگیوں اور منافع کو ایک ہی جگہ ٹریک کریں",
  are_you_sure_you_want_to_delete_item:
    "کیا آپ واقعی اس آئٹم کو حذف کرنا چاہتے ہیں؟",
  this_action_cannot_be_undone: "یہ عمل واپس نہیں کیا جا سکتا۔",
  contact_number: "رابطہ نمبر",
  address_business: "پتہ",
  edit_customer: "کسٹمر میں ترمیم کریں",
  update_record_sucessfully: "ریکارڈ کامیابی سے اپ ڈیٹ ہو گیا",
  amount_rs: "رقم روپے",
  please_enter_item_name_first: "براہ کرم پہلے آئٹم کا نام درج کریں!",
  only_one_unit_for_the_selected_item: "منتخب آئٹم کے لیے صرف ایک یونٹ",
  reset_discount_message: "آئٹم ڈسکاؤنٹ ری سیٹ کریں",
  close_without_saving: "بغیر محفوظ کیے بند کریں؟",
  invoice_no: "انوائس نمبر",
  item_report: "آئٹم رپورٹ",
  available_stock: "دستیاب اسٹاک",
  low_stock_alert: "کم اسٹاک الرٹ",
  profile_tracker: "منافع ٹریکر",
  total_item_sold: "کل فروخت شدہ آئٹمز",
  total_item_purchases: "کل خریداری کی قیمت",
  total_sale_price: "کل فروخت کی قیمت",
  stock_history: "اسٹاک ہسٹری",
  custom_date: "مخصوص تاریخ",
  stock_list: "اسٹاک لسٹ",
  create_stock_item_details: "اسٹاک آئٹم کی تفصیلات بنائیں",
  edit_stock_item_details: "اسٹاک آئٹم کی تفصیلات میں ترمیم کریں",
  stock_book_reports: "اسٹاک بک رپورٹس",
  unsaved_changes: "آپ کی کچھ تبدیلیاں محفوظ نہیں ہوئیں",
  unsaved_changes_go_back_message: "آپ کی تبدیلیاں محفوظ نہیں ہوئیں۔ کیا آپ واقعی واپس جانا چاہتے ہیں؟",
  discard_stock: "جی ہاں، یہ اسٹاک حذف کریں",
  go_back_item: "آئٹم لسٹنگ پر واپس جائیں",
  create_as_item: "اسے نئے آئٹم کے طور پر بنائیں",
  costs_rs: "(Rs.) لاگت",
  add_more_item_detail: "مزید آئٹم تفصیلات شامل کریں",
  add_more_item_detail_desc:
    "نیا کالم شامل کرنے اور اپنے آئٹم کی مزید تفصیلات شامل کرنے کے لیے + آئیکن پر کلک کریں۔",
  please_select_primary_unit_first: "براہ کرم پہلے پرائمری یونٹ منتخب کریں",
  secondary_unit_cannot_be_same_to_primary_unit:
    "سیکنڈری یونٹ پرائمری یونٹ جیسا نہیں ہو سکتا",
  primary_unit_cannot_be_same_to_secondary_unit:
    "پرائمری یونٹ سیکنڈری یونٹ جیسا نہیں ہو سکتا",
  You_can_add_your_custom_unit: "آپ اپنا مخصوص یونٹ شامل کر سکتے ہیں",
  item_not_found: "آئٹم نہیں ملا",
  sorry_could_not_find: "معذرت، ہمیں نہیں ملا",
  you_can_add_stock: "آپ نیچے کلک کر کے اسے اپنی اسٹاک بک میں شامل کر سکتے ہیں!",
  stock_filter_non_ideal_screen:
    "تمام آپشنز دیکھنے کے لیے اپنے فلٹرز تبدیل کریں یا انہیں ہٹا دیں۔",
  no_report_found: "کوئی رپورٹ نہیں ملی",
  stock_report_non_ideal_decs:
    "کوئی اسٹاک ڈیٹا دستیاب نہیں۔ براہ کرم اپنی انوینٹری میں آئٹمز شامل کریں",
  add_items_now: "ابھی آئٹمز شامل کریں",
  sale_report_non_ideal_decs:
    "کوئی فروخت کا ڈیٹا نہیں ملا۔ رپورٹس بنانے کے لیے فروخت شروع کریں",
  no_low_stock_found: "کم اسٹاک نہیں ملا",
  low_stock_report_non_ideal_decs:
    "کم اسٹاک والے آئٹمز نہیں ملے۔ آپ کے تمام پروڈکٹس مناسب مقدار میں موجود ہیں",
  add_unit: "یونٹ شامل کریں",
  unit_modal_desc:
    "اگر یہ آئٹم کسی اور یونٹ میں بھی دستیاب ہے تو آپ اسے یہاں شامل کر سکتے ہیں۔",
  unit_conversion_error: "یونٹ کنورژن صفر نہیں ہو سکتا",
  manufactor_lower_expiry_validation_msg:
    "تیاری کی تاریخ ختم ہونے کی تاریخ سے پہلے ہونی چاہیے",
  expiry_greater_manufactor_validation_msg:
    "ختم ہونے کی تاریخ تیاری کی تاریخ کے برابر یا اس کے بعد ہونی چاہیے",
  expiry_alert_lower_expiry_validation_msg:
    "ختم ہونے کا الرٹ ختم ہونے کی تاریخ کے برابر یا اس سے پہلے ہونا چاہیے",
  are_you_sure_you_want_to_leave_this_screen:
    "کیا آپ واقعی یہ اسکرین چھوڑ کر اپنی تبدیلیاں ضائع کرنا چاہتے ہیں؟",
  item_deleted_successfully: "آئٹم کامیابی سے حذف ہو گیا",
  loss_profit: "نقصان/ منافع",
  action: "ایکشن",
  create_your_pin: "اپنا پن بنائیں",
  confirm_your_pin: "اپنے پن کی تصدیق کریں",
  setup_pin_security: "اپنی سیکیورٹی کے لیے پن سیٹ اپ کریں",
  create_pin: "پن بنائیں",
  setup_pin: "پن سیٹ اپ کریں",
  pin_code: "پن کوڈ",
  activated: "فعال",
  turn_off: "بند کریں",
  change_pin: "پن تبدیل کریں",
  start_by_creating_purchase_invoice:
    "خریداری کا بل بنا کر شروع کریں اور اپنی ادائیگیوں اور منافع کو ایک ہی جگہ ٹریک کریں",
  sales_report: "سیلز رپورٹ",
  sales_invoice: "سیلز انوائس",
  package_details: "پیکج کی تفصیلات",
  package_done: "پیکج مکمل",
  package_successfully: "پیکج کامیابی سے مکمل ہو گیا",
  delete_single_item: "کیا آپ واقعی اس آئٹم کو حذف کرنا چاہتے ہیں؟",
  delete_multiple_items: "کیا آپ واقعی ان آئٹمز کو حذف کرنا چاہتے ہیں؟",
  mobile_recharge: "موبائل ریچارج",
  continue: "جاری رکھیں",
  business_trust: "5.3M+ کاروباروں کا اعتماد",
  Verify_OTP: "کی تصدیق کریں OTP",
  otp_code_sent: "بھیج دیا ہے OTP ہم نے آپ کے",
  enter_4_digit_otp_code: "کوڈ درج کریں OTP یہاں 4 ہندسوں کا",
  wait_time: "انتظار کا وقت",
  money_khaata_is_updated: "رقم آ گئی — آپ کا کھاتہ اپ ڈیٹ ہو گیا",
  payment_received_successfully: "ادائیگی کامیابی سے وصول ہو گئی!",
  inventory_updated_with_received_items:
    "وصول شدہ آئٹمز کے ساتھ انوینٹری اپ ڈیٹ ہو گئی",
  whatsapp_number: "نمبر WhatsApp",
  your_data_is_being_restored: "آپ کا ڈیٹا بحال کیا جا رہا ہے",
  secured_data_transmission_in_progress:
    "آپ کے نمبرز تیار کیے جا رہے ہیں!",
  please_confirm_4_digit_pin: "براہ کرم اپنے 4 ہندسوں کے ادھار بک پن کی تصدیق کریں",
  forget_pin: "پن بھول گئے؟",
  back_to_login: "لاگ ان پر واپس جائیں",
  call_support: "سپورٹ کو کال کریں",
  verify_your_account: "اپنے اکاؤنٹ کی تصدیق کریں",
  verify_your_account_decs:
    "اپنا پن ری سیٹ کرنے کے لیے ادھار بک ایپ کے ذریعے اپنی تصدیق مکمل کریں۔ اس سے ہمیں آپ کے اکاؤنٹ کی سیکیورٹی اور صداقت یقینی بنانے میں مدد ملتی ہے۔",
  scan_to_open: "کھولنے کے لیے اسکین کریں",
  search_udhaar_book_on_play_store: "تلاش کریں Udhaar Book پر Play Store",
  or_download: "یا ڈاؤن لوڈ کریں",
  just_need_few_detail_to_get_started:
    "شروع کرنے کے لیے بس چند تفصیلات درکار ہیں",
  kareen_store: "Kareen Store",
  otp_verified_successfully: "کامیابی سے تصدیق ہو گیا ہے OTP آپ کا",
  verify_PIN: "پن کی تصدیق کریں",
  Please_verify_your_4_digits_Udhaar_book_PIN:
    "براہ کرم اپنے 4 ہندسوں کے روپن پن کی تصدیق کریں",
  tries_left: "کوششیں باقی",
  call: "کال کریں",
  Select_the_options_below_to_receive_a_new_OTP:
    "حاصل کرنے کے لیے نیچے دیے گئے آپشنز میں سے منتخب کریں OTP نیا",
  phone_sms: "SMS فون",
  we_will_call_for_OTP_to_your: "کے لیے کال کریں گے OTP ہم آپ کے نمبر پر",
  hang_tight_ledgers: "تھوڑا انتظار کریں – آپ کے کھاتے تقریباً تیار ہیں!",
  sale: "فروخت",
  keyboard_shortcuts: "کی بورڈ شارٹ کٹس",
  keyboard_shortcut_tooltip: "کی بورڈ شارٹ کٹ",
  shortcut_switch_tabs: "ٹیبز کے درمیان تبدیل کریں",
  shortcut_add_items_to_cart: "آئٹمز کارٹ میں شامل کریں",
  shortcut_start_new_sale: "نئی سیل شروع کریں",
  shortcut_go_to_checkout: "چیک آؤٹ پر جائیں",
  shortcut_search_items: "آئٹمز تلاش کریں",
  shortcut_scroll_up_items: "آئٹمز کی لسٹ اوپر اسکرول کریں",
  shortcut_scroll_down_items: "آئٹمز کی لسٹ نیچے اسکرول کریں",
  shortcut_scroll_up: "اوپر اسکرول کریں",
  shortcut_scroll_down: "نیچے اسکرول کریں",
  shortcut_add_customer: "کسٹمر شامل کریں",
  shortcut_charge: "چارج",
  available: "دستیاب",
  delete_bill: "بل حذف کریں",
  delete_invoice: "انوائس حذف کریں",
  retry: "دوبارہ کوشش کریں",
  suppliers_descp_new:
    "سپلائرز شامل کریں اور خریداری کا حساب رکھیں۔ مفت ادائیگی یاد دہانی۔ وصولی 3 گنا تیز۔",
  add_customer_descp_new:
    "کسٹمرز شامل کریں اور کھاتہ رکھیں۔ مفت ادائیگی یاد دہانی۔ وصولی 3 گنا تیز۔",
  i_will_give: "میں نے دینے ہیں",
  i_will_receive: "میں نے لینے ہیں",
  welcome_to_accounts: "اکاؤنٹس میں خوش آمدید",
  add_customer_supplier_collection:
    "اپنی وصولیوں کو آسان اور ادھار کو پریشانی سے پاک رکھنے کے لیے اپنے کسٹمرز اور سپلائرز شامل کریں۔",
  customers: "کسٹمرز",
  suppliers: "سپلائرز",
  contact_type: "رابطے کی قسم",
  status: "اسٹیٹس",
  download_files: "فائلیں ڈاؤن لوڈ کریں",
  payment_pdf: "PDF ادائیگی کی",
  payment_detail: "ادائیگی کی تفصیل",
  outstanding_orders: "زیر التواء آرڈرز",
  return_orders: "واپس شدہ آرڈرز",
  enter_weight: "وزن درج کریں",
  weight_type: "وزن کی قسم",
  select_dimensions: "طول و عرض منتخب کریں",
  dimension_type: "طول و عرض کی قسم",
  length: "لمبائی",
  width: "چوڑائی",
  height: "اونچائی",
  customers_statement: "کسٹمرز کا اسٹیٹمنٹ",
  suppliers_statement: "سپلائرز کا اسٹیٹمنٹ",
  itook: "میں نے لیے",
  igave: "میں نے دیے",
  received: "وصول شدہ",
  details: "تفصیلات",
  invoice_terms_label: "شرائط",
  You_are_all_set: "آپ تیار ہیں!",
  txns_non_ideal_desc:
    "کامیابی سے شامل ہو گیا ہے۔ اب اپنے کسٹمر کے ساتھ ٹرانزیکشنز ٹریک کرنا شروع کریں۔",
  transaction_for: "ٹرانزیکشن برائے",
  note_placeholder: "یہاں تفصیلی نوٹ شامل کریں",
  add_image: "تصویر شامل کریں",
  upload_new_file: "نئی فائل اپ لوڈ کریں",
  transaction_detail: "ٹرانزیکشن کی تفصیلات",
  expense_date_time: "اخراجات کی تاریخ اور وقت",
  notes: "نوٹس",
  type: "قسم",
  contact_list_non_ideal_title: "فون سے کانٹیکٹس کی اجازت دیں",
  contact_list_non_ideal_description:
    "ایپ کو اجازت دیں Udhaar Book ایک ہی بار میں تمام کانٹیکٹس شامل کرنے کے لیے",
  sync_contacts: "کانٹیکٹس سنک کریں",
  hang_on: "ذرا ٹھہریں!",
  your_contacts_are_being_synced: "آپ کے کانٹیکٹس سنک ہو رہے ہیں",
  edit_contact: "کانٹیکٹ میں ترمیم کریں",
  send: "بھیجیں",
  message: "پیغام",
  message_description:
    "واجب الادا ہیں۔ براہ کرم جلد از جلد اپنی رقم ادا کریں۔ شکریہ! Rs. 855 کے Book Ocean السلام علیکم! آپ پر",
  reminder_type: "یاد دہانی کی قسم",
  phone: "فون",
  due_date_set: "آخری تاریخ مقرر کر دی گئی ہے",
  due_date_remove: "آخری تاریخ ہٹا دی گئی ہے",
  collection_date_set: "وصولی کی تاریخ مقرر کر دی گئی ہے",
  collection_date_remove: "وصولی کی تاریخ ہٹا دی گئی ہے",
  we_could_not_find_match: "ہمیں اس کے لیے کوئی نتیجہ نہیں ملا",
  are_you_sure_delete_customer:
    "کیا آپ واقعی اس کسٹمر کو حذف کرنا چاہتے ہیں؟",
  are_you_sure_delete_suppier: "کیا آپ واقعی اس سپلائر کو حذف کرنا چاہتے ہیں؟",
  this_action_cannot_be_undone: "یہ عمل واپس نہیں کیا جا سکتا۔",
  supplier_with_this_number_already_exists:
    "اس نمبر کے ساتھ سپلائر پہلے سے موجود ہے",
  customer_with_this_number_already_exists:
    "اس نمبر کے ساتھ کسٹمر پہلے سے موجود ہے",
  you_can_either_view_supplier_details_or_move_to_customer_tab:
    "آپ سپلائر کی تفصیلات دیکھ سکتے ہیں یا کسٹمر ٹیب پر جا سکتے ہیں",
  you_can_either_view_customer_details_or_move_to_supplier_tab:
    "آپ کسٹمر کی تفصیلات دیکھ سکتے ہیں یا سپلائر ٹیب پر جا سکتے ہیں",
  move_to_customer: "کسٹمر میں منتقل کریں",
  move_to_supplier: "سپلائر میں منتقل کریں",
  view_supplier: "سپلائر دیکھیں",
  view_customer: "کسٹمر دیکھیں",
  i_will_recieve: "مجھے وصول کرنا ہے",
  no_more_notebooks_or_spreadsheets: "نہ رجسٹر، نہ اسپریڈ شیٹ",
  your_customers_forget_to_pay: "کیا آپ کے کسٹمر ادائیگی بھول جاتے ہیں؟",
  never_again: "اب ایسا نہیں ہوگا!",
  watch_tutorial: "ٹیوٹوریل دیکھیں",
  five_million_strong: "55 لاکھ سے زائد صارفین",
  and_growing_every_day: "- اور روز بروز بڑھتی ہوئی",
  no_more_notebooks_spreadsheets: "نہ رجسٹر، نہ اسپریڈ شیٹ",
  no_more_notebooks_spreadsheets_description:
    "اپنی وصولیوں اور ادائیگیوں کو منظم رکھیں۔ یاد دہانیاں بھیجیں، ادائیگیاں ریکارڈ کریں، اور اپنے کھاتے سے باخبر رہیں۔",
  easy_payment_tracking: "آسان ادائیگی ٹریکنگ",
  easy_payment_tracking_description:
    "آنے اور جانے والی ادائیگیوں کو کیٹیگریز کے ساتھ جلدی شامل کریں تاکہ آپ کا ریکارڈ منظم اور تازہ رہے۔",
  real_time_account_balances: "ریئل ٹائم اکاؤنٹ بیلنس",
  real_time_account_balances_description:
    "ایک ہی آسان اسکرین پر دیکھیں کہ کسٹمرز پر آپ کا کتنا واجب الادا ہے اور آپ کو سپلائرز کو کتنا دینا ہے!",
  a_community_full_of_stories: "کہانیوں سے بھری ایک کمیونٹی",
  testimonial_one:
    "پہلے مجھے یاد نہیں رہتا تھا کہ کس نے ابھی رقم دینی ہے، اور حساب رکھنا مشکل تھا۔ اب میں اپنی تمام وصولیاں ایک ہی جگہ دیکھ سکتا ہوں اور یاد دہانیاں بھی بھیج سکتا ہوں۔ اس نے ادائیگیاں وصول کرنا بہت آسان بنا دیا ہے!",
  testimonial_two:
    "پہلے مجھے یاد نہیں رہتا تھا کہ کس نے ابھی رقم دینی ہے، اور حساب رکھنا مشکل تھا۔ اب میں اپنی تمام وصولیاں ایک ہی جگہ دیکھ سکتا ہوں اور یاد دہانیاں بھی بھیج سکتا ہوں۔ اس نے ادائیگیاں وصول کرنا بہت آسان بنا دیا ہے!",
  testimonial_three:
    "اب مجھے کسٹمرز کے پیچھے بھاگنا نہیں پڑتا۔ میں یاد دہانی سیٹ کرتا ہوں اور باقی کام ایپ خود کر لیتی ہے۔ میں نے تو وہ ادائیگیاں بھی وصول کر لیں جو میں بھول چکا تھا۔",
  testimonial_four:
    "ادائیگیوں کا حساب رکھنا سر درد بن گیا تھا۔ اب مجھے پتا چل جاتا ہے کہ کس نے ادائیگی نہیں کی، اور میں بس 'یاد دہانی بھیجیں' پر کلک کرتا ہوں۔ بس اتنا آسان ہے۔",
  create_your_inventory: "اپنی انوینٹری بنائیں",
  low_stocks: "کم اسٹاک",
  forgot_to_update_them: "اور انہیں اپ ڈیٹ کرنا بھول گئے؟",
  add_new_products_easily: "نئے پراڈکٹس آسانی سے شامل کریں",
  add_new_products_easily_description:
    "چند کلکس میں آئٹمز بنائیں۔ پراڈکٹ کا نام، یونٹ، قیمت اور اسٹاک کی تفصیلات جلدی درج کریں—کوئی پیچیدگی نہیں۔",
  low_stock_reports: "کم اسٹاک رپورٹس",
  low_stock_reports_description:
    "ایک نظر میں دیکھیں کہ کس چیز کو دوبارہ اسٹاک کرنے کی ضرورت ہے۔ خریداری کی منصوبہ بندی کرنے اور فروخت میں کمی سے بچنے کے لیے کم اسٹاک رپورٹس بنائیں۔",
  quick_stock_adjustment: "فوری اسٹاک ایڈجسٹمنٹ",
  quick_stock_adjustment_description:
    "کسی بھی وقت آسانی سے اسٹاک کی مقدار اپ ڈیٹ کریں۔ خراب، گم شدہ یا واپس شدہ آئٹمز کے لیے چند کلکس میں اسٹاک کاؤنٹ کو دستی طور پر درست کریں۔",
  testimonial_five:
    "پہلے مجھے دستی طور پر ادائیگیاں اور اسٹاک ٹریک کرنے میں مشکل ہوتی تھی۔ اب سب کچھ ایک ہی جگہ ہے—یہ ایپ میرے لیے بہت مددگار ثابت ہوئی ہے۔",
  testimonial_six:
    "پہلے میں اسٹاک کاغذ پر لکھتا تھا۔ مجھے ہمیشہ بھول جاتا تھا کہ کیا بیچا ہے۔ اب سب کچھ ریکارڈ ہو جاتا ہے اور مجھے فوراً پتا چل جاتا ہے کہ کون سا اسٹاک کم ہے۔",
  testimonial_seven:
    "مجھے کوئیک آئٹم فیچر بہت پسند ہے۔ جب میں کوئی نئی چیز بیچتا ہوں تو مجھے سب کچھ بھرنے کی ضرورت نہیں—بس بیچیں اور آگے بڑھیں!",
  testimonial_eight:
    "اسٹاک شامل کرنے میں پہلے وقت لگتا تھا۔ اب میں بس 'اسٹاک ان' پر کلک کرتا ہوں اور سب کچھ اپ ڈیٹ ہو جاتا ہے۔ اب اندازوں کی ضرورت نہیں۔",
  add_sale: "سیل شامل کریں",
  mixing_up_your_sales: "اپنی سیلز میں الجھن کا شکار ہیں؟",
  let_simplify_that: "آئیں اسے آسان بناتے ہیں",
  make_sales_second: "سیکنڈوں میں سیل کریں",
  make_sales_second_description:
    "واک اِن سیلز کو تیزی سے ہینڈل کریں—آئٹمز منتخب کریں، ادائیگی کی قسم درج کریں، اور فوری طور پر رسید پرنٹ یا شیئر کریں۔ کاؤنٹر اور نقد سیلز کے لیے بہترین۔",
  send_invoices_get_paid_faster: "انوائسز بھیجیں اور تیزی سے ادائیگی وصول کریں",
  send_invoices_get_paid_faster_description:
    "اپنے کسٹمرز کے لیے پروفیشنل انوائسز بنائیں۔ واجب الادا رقم ٹریک کریں، ٹیکس یا ڈسکاؤنٹ لگائیں، اور تفصیلی انوائسز کے ساتھ کریڈٹ سیلز آسانی سے منظم کریں۔",
  track_every_rupee_coming: "ہر آنے والے روپے کو ٹریک کریں",
  track_every_rupee_coming_description:
    "کسٹمرز سے موصول ہونے والی ادائیگیاں ریکارڈ کریں۔ سیل انوائسز کے مقابلے میں جزوی یا مکمل ادائیگیاں آسانی سے ٹریک کریں اور ہر کسٹمر کی واضح ادائیگی تاریخ برقرار رکھیں۔",
  testimonial_nine:
    "کسٹمرز کے ساتھ انوائسز بنانا اور شیئر کرنا صرف چند سیکنڈز کا کام ہے۔ اب مجھے کچھ بھی ہاتھ سے لکھنے کی ضرورت نہیں—ایپ فوری اور صاف ستھرے انداز میں سب کچھ کر دیتی ہے۔",
  testimonial_ten:
    "اس ایپ کے ساتھ روزانہ سیل کی انٹریز کرنا بہت آسان ہو گیا ہے۔ یہ میرے کام کے انداز میں بالکل فٹ بیٹھتی ہے—میں چلتے پھرتے ہر سیل بغیر کسی رکاوٹ کے شامل کر سکتا ہوں۔",
  testimonial_eleven:
    "یہ ایپ میری تمام سیلز کا واضح خلاصہ دیتی ہے۔ میں سیکنڈوں میں روزانہ، ہفتہ وار یا ماہانہ پیش رفت دیکھ سکتا ہوں، جو بہتر فیصلے کرنے میں کافی مددگار ہے۔",
  testimonial_twelve:
    "ہر سیل پر مجھے کتنا نقد ملا، اسے ٹریک کرنا آسان ہے۔ ایپ تمام آنے والی ادائیگیوں کو منظم رکھتی ہے اور میرے ریکارڈ پر اعتماد بڑھاتی ہے۔",
  no_transactions_to_show_yet: "ابھی دکھانے کے لیے کوئی ٹرانزیکشن نہیں",
  no_transactions_to_show_yet_subtitle:
    "جیسے ہی آپ ادائیگیاں ریکارڈ کرنا شروع کریں گے، آپ کی تمام سرگرمی یہاں نظر آئے گی",
  go_to_accounts: "اکاؤنٹس پر جائیں",
  no_customer_records_yet: "ابھی تک کوئی کسٹمر ریکارڈ نہیں",
  no_customer_records_yet_subtitle:
    "کسٹمرز پر واجب الادا رقم ٹریک کرنے اور یاد دہانیاں آسانی سے منظم کرنے کے لیے انہیں اکاؤنٹس سیکشن میں شامل کریں۔",
  no_supplier_records_yet: "ابھی تک کوئی سپلائر ریکارڈ نہیں",
  no_supplier_records_yet_subtitle:
    "اپنے سپلائرز کو اکاؤنٹس سیکشن میں شامل کریں تاکہ آپ اپنی واجبات ٹریک کر سکیں اور کوئی ادائیگی مس نہ ہو۔",
  add_purchase: "خریداری شامل کریں",
  expenses_piling_up: "اخراجات بڑھتے جا رہے ہیں؟",
  organize_and_optimize: "منظم کریں اور بہتر بنائیں۔",
  record_all_your_purchases_one_place: "اپنی تمام خریداریاں ایک ہی جگہ ریکارڈ کریں",
  record_all_your_purchases_one_place_description:
    "بلز، سپلائر کی ادائیگیاں اور اخراجات آسانی سے ٹریک کریں۔ اب اندازوں کی ضرورت نہیں—ہر جانے والی ٹرانزیکشن سیکنڈوں میں ریکارڈ کریں۔",
  smart_stock_easy_purchasing: "اسمارٹ اسٹاک، آسان خریداری",
  smart_stock_easy_purchasing_description:
    "سپلائرز سے خریداریاں ریکارڈ کریں اور اسٹاک خودکار طور پر اپ ڈیٹ کریں۔ آئٹم کے حساب سے خریداریاں درج کریں، واجبات ٹریک کریں، اور اپنی انوینٹری کو ایک ہی وقت میں درست رکھیں۔",
  stay_top_of_business_spending: "اپنے کاروباری اخراجات پر نظر رکھیں",
  stay_top_of_business_spending_description:
    "اسٹاک سے غیر متعلقہ کاروباری اخراجات ٹریک کریں۔ چاہے کرایہ ہو، تنخواہیں ہوں یا یوٹیلیٹی بلز—اپنے کیش فلو پر نظر رکھنے کے لیے ہر جانے والی ادائیگی ریکارڈ کریں۔",
  testimonial_thirteen:
    "میں اپنی تمام خریداریاں اور ادائیگیاں ریکارڈ کرنے کے لیے یہ ایپ استعمال کرتا ہوں۔ اسٹاک کی خریداری سے لے کر کرائے تک، اب سب کچھ درج ہوتا ہے—اور اس نے میرے اخراجات کو پہلے سے کہیں بہتر طریقے سے منظم کرنے میں مدد کی ہے۔",
  testimonial_fourteen:
    "مجھے سب سے زیادہ یہ فیچر پسند ہے کہ یہ تمام خریداریوں کی رپورٹس بنا دیتی ہے۔ میں جب چاہوں مکمل اخراجات کی تاریخ دیکھ سکتا ہوں، جس سے سب کچھ کافی شفاف ہو جاتا ہے۔",
  testimonial_fifteen:
    "ایپ سے براہ راست پرچیز آرڈرز بنانے اور بھیجنے کی صلاحیت نے میرے کاروبار کو کہیں زیادہ پروفیشنل بنا دیا ہے۔ اب مجھے انہیں ہاتھ سے لکھنے یا بکھرے ہوئے پیغامات بھیجنے کی ضرورت نہیں۔",
  testimonial_sixteen:
    "یہ ایپ مجھے مکمل آزادی دیتی ہے کہ میں بتا سکوں کہ میں نے کیسے ادائیگی کی—مکمل، جزوی یا کریڈٹ پر۔ اس سے میرا ریکارڈ درست رہتا ہے اور مجھے اپنے کیش فلو کی صحیح تصویر ملتی ہے۔",
  view_reports: "رپورٹس دیکھیں",
  over_due_accounts: "میعاد گزشتہ اکاؤنٹس",
  customer_supplier: "کسٹمر / سپلائر",
  cta: "CTA",
  item_list: "آئٹم لسٹ",
  value_Rs_dot: "ویلیو-Rs.",
  stock_value_report: "اسٹاک ویلیو رپورٹ",
  top_selling_items: "زیادہ بکنے والے آئٹمز",
  dashboard: "ڈیش بورڈ",
  customers: "کسٹمرز",
  suppliers: "سپلائرز",
  purchase: "خریداری",
  request_reports: "رپورٹس کی درخواست کریں",
  report_name: "رپورٹ کا نام",
  enter_report_name: "رپورٹ کا نام درج کریں",
  report_details: "رپورٹ کی تفصیلات",
  enter_report_details: "رپورٹ کی تفصیلات درج کریں",
  quantity_sold: "فروخت شدہ مقدار",
  length_width_height: "اونچائی انچ x چوڑائی x لمبائی",
  items_type: "آئٹمز کی قسم",
  unit_type: "یونٹ کی قسم",
  barcode: "بار کوڈ",
  jpg_png_file_size_no_more_than: "سے زیادہ نہ ہو 3MB یا PNG، فائل سائز JPG",
  value: "ویلیو",
  date_filter: "تاریخ فلٹر",
  current_quantity: "موجودہ مقدار",
  stock_in_quantity: "اسٹاک اِن مقدار",
  stock_out_quantity: "اسٹاک آؤٹ مقدار",
  please_select_start_end_date: "براہ کرم آغاز اور اختتام کی تاریخ منتخب کریں",
  barcode_error: "بار کوڈ میں خرابی",
  updated_stock_inventory: "اسٹاک انوینٹری اپ ڈیٹ ہو گئی",
  record: "ریکارڈ",
  pos: "پوس",
  pos_sale: "سیل پوس",
  create_pos: "پوس بنائیں",
  pos_report: "پوس رپورٹ",
  number_of_transctions: "ٹرانزیکشنز کی تعداد",
  expence: "اخراجات",
  purchase_bill_report: "خریداری بل رپورٹ",
  expence_report: "اخراجات کی رپورٹ",
  search_customers_by_name_or_posId_placeholder: "نام یا پوس نمبر سے تلاش کریں",
  invoice_report: "انوائس رپورٹ",
  too_many_walk_ins: "بہت زیادہ واک اِن کسٹمرز؟",
  keep_them_smooth_with_pos: "پوس کے ساتھ سب کچھ آسان بنائیں",
  create_pos_sale: "سیل پوس بنائیں",
  stock_item_in_pos: "پوس میں اسٹاک آئٹم",
  stock_item_in_pos_description:
    "سیل کرتے وقت براہ راست اپنے اسٹاک سے آئٹمز شامل کریں۔ اس طرح ہر بل کے ساتھ آپ کی انوینٹری خود بخود اپ ڈیٹ ہو جاتی ہے—تاکہ آپ کو ہمیشہ پتا رہے کہ کیا بک رہا ہے اور کیا کم ہو رہا ہے۔",
  open_item_description:
    "کھلے آئٹمز وہ سیلز ہیں جو بن چکی ہیں مگر ابھی مکمل ادا نہیں ہوئیں۔ زیر التوا ادائیگیوں کو آسانی سے ٹریک کریں، یاد دہانیاں بھیجیں، اور کسٹمر کے ادائیگی کرنے پر اپ ڈیٹ کریں، تاکہ آپ کو ہمیشہ معلوم رہے کہ کون سی سیلز اوپن ہیں اور کتنی رقم ابھی باقی ہے۔",
  draft_sales: "ڈرافٹ سیلز",
  draft_sales_description:
    "ڈرافٹ سیلز کی مدد سے آپ ایسے آرڈرز محفوظ کر سکتے ہیں جو ابھی حتمی نہیں ہوئے، چاہے کسٹمر ابھی فیصلہ کر رہا ہو یا آپ سیل بعد میں مکمل کرنا چاہتے ہوں۔ جب کسٹمر تیار ہو تو آسانی سے واپس آ کر ترمیم یا تصدیق کریں۔",
  forgot_invoices: "انوائسز بھول جاتے ہیں؟",
  we_help_you_stay_on_track: "ہم آپ کو ٹریک پر رکھنے میں مدد کریں گے۔",
  sale_invoice_desc:
    "سیل انوائس میں آئٹمز، مقدار، قیمتیں، ٹیکس اور کل رقم جیسی تمام تفصیلات شامل ہوتی ہیں—تاکہ آپ اور آپ کے کسٹمر دونوں کے پاس ٹرانزیکشن کا واضح ریکارڈ ہو",
  share_instantly: "فوری شیئر کریں",
  share_instantly_desc:
    "انوائسز براہ راست اپنے کسٹمرز کو WhatsApp، ای میل یا پرنٹ کے ذریعے بھیجیں۔ نہ ہاتھ سے لکھنا، نہ تاخیر—آپ کے کسٹمر کو فوراً بل مل جاتا ہے",
  track_payments: "ادائیگیاں ٹریک کریں",
  track_payments_desc:
    "آسانی سے دیکھیں کہ کون سی انوائسز مکمل ادا ہو چکی ہیں، جزوی ادا ہوئی ہیں، یا ابھی زیر التوا ہیں۔ اس سے آپ کو وصولیوں پر نظر رکھنے اور واجب الادا رقوم کی پیروی کرنے میں مدد ملتی ہے، بغیر کچھ چھوڑے۔",
  frustrated_with_unpacked_purchases: "غیر منظم خریداریوں سے پریشان ہیں؟",
  let_bring_order: "آئیں ترتیب لاتے ہیں",
  keep_records_organized: "ریکارڈ منظم رکھیں",
  keep_records_organized_desc:
    "تمام پرچیز آرڈرز ایک ہی جگہ محفوظ ہوتے ہیں، تاکہ آپ فوری طور پر پرانے آرڈرز چیک کر سکیں، سپلائر کی قیمتوں کا موازنہ کر سکیں، اور خریداری کی مکمل تاریخ برقرار رکھ سکیں",
  send_suppliers_easily: "سپلائرز کو آسانی سے بھیجیں",
  send_suppliers_easily_desc:
    "چند کلکس میں اپنے سپلائرز کے ساتھ پرچیز آرڈرز بنائیں اور شیئر کریں—WhatsApp، ای میل یا پرنٹ کے ذریعے۔ اس سے سب کچھ واضح اور پروفیشنل رہتا ہے۔",
  track_pending_orders: "زیر التوا آرڈرز ٹریک کریں",
  track_pending_orders_desc:
    "دیکھیں کہ کون سے آرڈرز ابھی اوپن ہیں، کون سے ڈیلیور ہو چکے ہیں، اور کتنی رقم واجب الادا ہے۔ اس سے آپ اپنے اسٹاک اور کیش فلو کو زیادہ مؤثر طریقے سے منظم کر سکتے ہیں۔",
  please_select_start_end_date: "براہ کرم آغاز اور اختتام کی تاریخ منتخب کریں",
  purchase_expense: "خریداری اور اخراجات",
  send_invoices: "انوائسز بھیجیں",
  sale_pos_desc:
    "پوس کے ساتھ، آپ فوری طور پر رسید بنا سکتے ہیں، ادائیگی ریکارڈ کر سکتے ہیں، اور فوراً کسٹمر کے حوالے کر سکتے ہیں۔ یہ تیز، آسان، اور واک اِن کسٹمرز کے لیے بہترین ہے۔",
  sale_invoices: "سیل انوائسز",
  purchase_bill_desc:
    "سپلائرز کو فون کالز یا میسجز کے ذریعے پیچھا کرنا بند کریں۔ پرچیز بل کے ساتھ، آپ سامان کے لیے واضح اور پروفیشنل درخواستیں بھیج سکتے ہیں—آئٹمز، قیمتیں اور مقدار سب ایک ہی جگہ۔",
  expenses: "اخراجات",
  expenses_description:
    "اخراجات کا فیچر آپ کے کاروبار چلانے پر خرچ ہونے والی رقم ریکارڈ کرنے میں مدد کرتا ہے—جیسے کرایہ، یوٹیلیٹیز، تنخواہیں یا سامان۔ اس سے آپ کے تمام کاروباری اخراجات درست طریقے سے درج رہتے ہیں۔",
  create_purchase: "خریداری بنائیں",
  lost_in_your_expenses: "اپنے اخراجات میں الجھے ہوئے ہیں؟",
  stay_organized: "منظم رہیں",
  create_expense: "اخراجات بنائیں",
  avoid_missed_entries: "چھوٹی ہوئی انٹریز سے بچیں",
  avoid_missed_entries_desc:
    "اخراجات ہوتے ہی انہیں ریکارڈ کریں تاکہ کچھ بھی بھول نہ ہو اور آپ کے اکاؤنٹس درست رہیں۔",
  track_all_business_costs: "تمام کاروباری اخراجات ٹریک کریں",
  track_all_business_costs_desc:
    "چھوٹا ہو یا بڑا، ہر خرچ آسانی سے درج اور محفوظ کریں، تاکہ آپ کو ہمیشہ پتا رہے کہ آپ کی رقم کہاں جا رہی ہے۔",
  summary_of_your_cash_out: "آپ کے کیش آؤٹ کا خلاصہ",
  summary_of_your_cash_out_desc:
    "ایک نظر میں دیکھیں کہ آپ کے کاروبار سے کتنی رقم خرچ ہوئی ہے۔ مناسب اخراجات کے خلاصے کے ساتھ، آپ کو ہمیشہ پتا رہتا ہے کہ آپ کا کیش کہاں جا رہا ہے اور آپ بہتر منصوبہ بندی کر سکتے ہیں۔",
  record_expense: "اخراجات ریکارڈ کریں",
  expense_amount: "اخراجات کی رقم",
  select_category: "کیٹیگری منتخب کریں",
  paid_amount: "ادا شدہ رقم",
  company: "کمپنی",
  company_supplier: "کمپنی / سپلائر",
  total_paid_expenses: "کل ادا شدہ اخراجات",
  total_unpaid_expenses: "کل غیر ادا شدہ اخراجات",
  expense_id: "ID اخراجات",
  options: "آپشنز",
  expense_report: "اخراجات کی رپورٹ",
  delete_expense: "اخراجات حذف کریں",
  are_you_sure_you_want_to_delete_this_expense:
    "کیا آپ واقعی اس اخراجات کا ریکارڈ حذف کرنا چاہتے ہیں؟",
  expense_has_been_successfully_recorded:
    "اخراجات کامیابی سے ریکارڈ ہو گئے",
  expense_has_been_successfully_updated:
    "اخراجات کامیابی سے اپ ڈیٹ ہو گئے",
  companies: "کمپنیاں",
  search_by_expense_id: "اخراجات # سے تلاش کریں",
  additional_details_subtitle: "(نوٹس، تصویر اپ لوڈ اور تاریخ)",
  additional_details_subtitle_stock:
    "(بار کوڈ، ایکسپائری، بیچ نمبر، ہول سیل قیمت، تیاری کی تاریخ)",
  discard_expense_btn: "جی ہاں، یہ اخراجات حذف کریں",
  this_action_cannot_be_undone: "یہ عمل واپس نہیں کیا جا سکتا۔",
  Are_you_sure_you_want_to_change_the_customer_to_supplier:
    "کیا آپ واقعی کسٹمر کو سپلائر میں تبدیل کرنا چاہتے ہیں؟",
  Are_you_sure_you_want_to_change_the_supplier_to_customer:
    "کیا آپ واقعی سپلائر کو کسٹمر میں تبدیل کرنا چاہتے ہیں؟",
  Are_you_sure_you_want_to_delete_this_customer:
    "کیا آپ واقعی اس کسٹمر کو ڈیلیٹ کرنا چاہتے ہیں؟",
  are_you_sure_delete_suppier: "کیا آپ واقعی اس سپلائر کو حذف کرنا چاہتے ہیں؟",
  are_you_sure_delete_customer:
    "کیا آپ واقعی اس کسٹمر کو حذف کرنا چاہتے ہیں؟",
  save_to_draft_sales: "ڈرافٹ سیلز میں محفوظ کریں",
  delete_draft: "ڈرافٹ حذف کریں",
  delete_draft_desc: "کیا آپ واقعی یہ ڈرافٹ سیل حذف کرنا چاہتے ہیں؟",
  are_you_sure_you_want_to_delete_transaction:
    "کیا آپ واقعی اس ٹرانزیکشن کو حذف کرنا چاہتے ہیں؟",
  search_by_order: "آرڈر تلاش کریں",
  no_filter_match:
    "ان فلٹرز سے کوئی نتیجہ نہیں ملا۔ فلٹرز تبدیل کریں یا صاف کریں",
  item_name_placeholder: "مثلاً چینی",
  select_to_type_or_add: "ٹائپ کرنے یا شامل کرنے کے لیے منتخب کریں",
  primary_unit: "بنیادی یونٹ",
  enter_number_to_send_reminder: "یاد دہانی بھیجنے کے لیے نمبر درج کریں",
  quantity_placeholder: "50",
  unit_placeholder: "مثلاً کلو، پیس، باکس",
  secondary_unit_placeholder: "مثلاً درجن، کارٹن",
  sell_rs_placeholder: "مثلاً 120",
  cost_rs_placeholder: "مثلاً 100",
  low_stock_alert_placeholder: "مثلاً 10",
  enter_batch_number: "بیچ نمبر درج کریں",
  clear_filters: "فلٹرز صاف کریں",
  stock_in_updated: "اسٹاک اِن اپ ڈیٹ ہو گیا",
  stock_out_updated: "اسٹاک آؤٹ اپ ڈیٹ ہو گیا",
  enter_or_create: "درج کریں یا نیا بنائیں",
  edit_expenses: "اخراجات میں ترمیم کریں",
  id: "ID",
  try_another_filter_to_find_what_youre_looking_for:
    "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے دوسرا فلٹر آزمائیں۔",
  select_company_or_supplier: "کمپنی یا سپلائر منتخب کریں",
  avb_stock: "دستیاب اسٹاک",
  delete_pos: "پوس ڈیلیٹ کریں",
  are_you_sure_you_want_to_delete_this_pos:
    "کیا آپ واقعی اس پوس کو ڈیلیٹ کرنا چاہتے ہیں",
  create_stock_book: "اسٹاک بک بنائیں",
  low_stock_report_non_ideal_decs_half: "کم اسٹاک والی کوئی آئٹمز نہیں ملیں۔",
  back_to_report: "رپورٹ پر واپس جائیں",
  no_sales_data_found: "سیلز کا کوئی ڈیٹا نہیں ملا",
  create_a_sale_to_generate_report: "رپورٹ بنانے کے لیے سیل بنائیں۔",
  create_sale: "سیل بنائیں",
  start_making_sales_to_generate_reports:
    "رپورٹس بنانے کے لیے سیلز کرنا شروع کریں",
  expense_search_description:
    "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے دوسرا نام یا نمبر آزمائیں",
  create_search_term_as_new_customer: "'{name}' کو نئے کسٹمر کے طور پر بنائیں",
  create_search_term_as_new_supplier: "'{name}' کو نئے سپلائر کے طور پر بنائیں",
  go_back_to_expense_listing: "اخراجات کی فہرست پر واپس جائیں",
  go_back_to_quick_sale_listing: "کوئیک سیل کی فہرست پر واپس جائیں",
  remind_with_whatsapp_add_contact:
    "کے ذریعے یاد دہانی فعال کرنے کے لیے براہ کرم رابطہ نمبر شامل کریں۔ WhatsApp",
  add_customer_to_sale: "رسیدیں تیزی سے شیئر کرنے کے لیے کسٹمر لنک کریں",
  create_your_own_item: "اپنی آئٹم خود بنائیں",
  catalog_items: "کیٹلاگ آئٹمز",
  preview_image: "تصویر کا پیش منظر",
  go_back_to_POS: "پوس کی فہرست پر واپس جائیں",
  non_ideal_pos_book:
    "جو آپ تلاش کر رہے ہیں اسے تلاش کرنے کے لیے پوس کو دوسرے نام سے تلاش کریں۔",
  backup_data: "ڈیٹا بیک اپ کریں",
  available_balance: "دستیاب بیلنس",
  add_money: "رقم شامل کریں",
  request: "درخواست",
  easyload_packages: "ایزی لوڈ اور پیکجز",
  bill_payments: "بل ادائیگیاں",
  vouchers: "واؤچرز",
  shop: "شاپ",
  sms_bundles: "بنڈلز SMS",
  see_more_bills: "مزید بلز دیکھیں",
  sell_vouchers: "واؤچرز فروخت کریں",
  search_transactions: "ٹرانزیکشنز تلاش کریں",
  transaction_id: "ID ٹرانزیکشن",
  scan_and_add_money_to_your_wallet: "اسکین کریں اور اپنے RUPIN اکاؤنٹ میں رقم شامل کریں",
  account_title: "اکاؤنٹ ٹائٹل",
  IBAN: "آئی بین",
  copy: "کاپی کریں",
  easy_QR_code_payments: "کوڈ ادائیگیاں QR آسان",
  share_details: "تفصیلات شیئر کریں",
  download_qr_code: "کوڈ ڈاؤن لوڈ کریں QR",
  print_qr_code: "کوڈ پرنٹ کریں QR",
  trusted_by_million_users: "5.3+ ملین سے زائد صارفین کا اعتماد",
  licensed_by_State_Bank_of_Pakistan: "اسٹیٹ بینک آف پاکستان سے لائسنس یافتہ",
  auto_reconciliation: "خودکار ریکنسیلی ایشن",
  send_anywhere: "کہیں بھی بھیجیں",
  receive_anywhere: "کہیں بھی وصول کریں",
  free_and_instant: "مفت اور فوری",
  your_account_just_got_an_upgrade: "آپ کے اکاؤنٹ کو ابھی اپ گریڈ کیا گیا ہے۔",
  it_only_takes_a_minute: "اس میں صرف ایک منٹ لگتا ہے",
  unlock_benefits_by_upgrading_your_account:
    "اپنا اکاؤنٹ اپ گریڈ کر کے فوائد حاصل کریں",
  licensed_by_sbp_in_principle: "Licensed by SBP (in principle)",
  upgrade_account: "اکاؤنٹ اپ گریڈ کریں",
  scan_qr_or_share_download_link: "اسکین کریں یا ڈاؤن لوڈ لنک شیئر کریں QR",
  copy_link: "لنک کاپی کریں",
  share_link: "لنک شیئر کریں",
  upgrade_account_download_desc:
    "کوڈ اسکین کریں، یا ڈاؤن لوڈ لنک کاپی کر کے شیئر کریں۔ QR ایپ ڈاؤن لوڈ کریں، RUPIN اپنا اکاؤنٹ اپ گریڈ کرنے کے لیے",
  wallet_onboarding_b_slide1_title: "ہر پیمنٹ کے لیے ایک ہی اکاؤنٹ",
  wallet_onboarding_b_slide1_subtitle: "آسانی سے ٹریک اور مینج کریں",
  wallet_onboarding_b_slide2_title: "کہیں بھی، کبھی بھی ادائیگی کریں",
  wallet_onboarding_b_slide2_subtitle: "تیز، مفت اور لامحدود ٹرانسفر",
  wallet_onboarding_b_slide3_title: "فوری پیسے حاصل کریں۔ 100% مفت",
  wallet_onboarding_b_slide3_subtitle: "نہ کوئی فیس، نہ کوئی حد",
  pending_collections_payments: "زیر التوا وصولیاں اور ادائیگیاں",
  search_contact: "رابطہ تلاش کریں",
  contact: "رابطہ",
  total_money_in: "کل موصولہ رقم",
  total_money_out: "کل ارسال کردہ رقم",
  money_in: "موصولہ رقم",
  money_out: "ارسال کردہ رقم",
  new_entry_in: "نئی انٹری (آمد)",
  new_entry_out: "نئی انٹری (اخراج)",
  view_all: "تمام دیکھیں",
  choose_mobile_network: "نیٹ ورک منتخب کریں",
  recharge_type: "ریچارج کی قسم",
  network_service_currently_unavailable: "یہ سروس فی الحال {network} کے لیے دستیاب نہیں ہے",
  enter_amount_rs: "Rs. رقم درج کریں",
  enter_amount_here: "یہاں رقم درج کریں",
  bank_name: "بینک کا نام",
  account_details: "اکاؤنٹ کی تفصیلات",
  enter_account_number_IBAN: "درج کریں IBAN اکاؤنٹ نمبر /",
  enter_amount_rs: "Rs. رقم درج کریں",
  enter_amount_here: "یہاں رقم درج کریں",
  raast_id: "راست آئی ڈی", linked: "لنک ہے",
  unlinked: "لنک نہیں ہے",
  link: "لنک کریں",
  linking: "لنک ہو رہا ہے...",
  unlink: "لنک ختم کریں",
  raast_id_unlink: "راست آئی ڈی کا لنک ختم کریں",
  raast_id_unlink_desc: "کیا آپ واقعی اپنی راست آئی ڈی کا لنک ختم کرنا چاہتے ہیں؟ آپ اسے کسی بھی وقت دوبارہ لنک کر سکتے ہیں۔",
  raast_id_linked_successfully: "راست آئی ڈی کامیابی سے لنک ہو گئی",
  raast_id_unlinked_successfully: "راست آئی ڈی کا لنک کامیابی سے ختم ہو گیا",
  insufficient_balance_please_try_different_amount:
    "بیلنس ناکافی ہے، براہ کرم دوسری رقم آزمائیں",
  go_to_wallet: "ہوم پر جائیں",
  share_receipt: "رسید شیئر کریں",
  review: "جائزہ",
  mobile_network_new: "موبائل نیٹ ورک",
  select_customer: "کسٹمر منتخب کریں",
  send_request: "درخواست بھیجیں",
  pending_amount: "زیر التوا رقم",
  phone_number_already_exist:
    "فون نمبر پہلے سے موجود ہے، براہ کرم دوسرا نمبر آزمائیں",
  tired_of_payment_chaos: "ادائیگیوں کی الجھن سے تنگ آ گئے؟",
  simplify_with_one_smart_wallet: "ایک اسمارٹ والٹ سے سب کچھ آسان بنائیں۔",
  let_get_started: "آئیے شروع کرتے ہیں",
  earn_money_on_every_transaction: "ہر ٹرانزیکشن پر کمائیں",
  turn_every_recharge_the_more_you_earn:
    "ہر ریچارج، بل ادائیگی، اور واؤچر سیل کو اضافی آمدنی میں بدلیں جتنا زیادہ بیچیں گے، اتنا زیادہ کمائیں گے۔",
  track_every_transaction_effortlessly: "ہر ٹرانزیکشن آسانی سے ٹریک کریں",
  view_all_your_payments_stay_on_top_of_every_transaction:
    "اپنی تمام ادائیگیاں، رقم شامل کرنا، اور رقم بھیجنا ایک ہی جگہ دیکھیں۔ اپنے بزنس کا ریکارڈ منظم رکھیں اور ہر ٹرانزیکشن پر نظر رکھیں۔",
  send_money_anytime_anywhere: "کسی بھی وقت، کہیں بھی رقم بھیجیں",
  make_instant_payments_straight_without_delays_or_extra_steps:
    "اپنے والٹ سے کسی بھی بینک یا والٹ صارف کو براہ راست فوری ادائیگی کریں۔ تیز، محفوظ اور قابل اعتماد، بغیر کسی تاخیر یا اضافی مراحل کے۔",
  first_activate_your_wallet_in_3_easy_steps:
    "پہلے اپنا والٹ 3 آسان مراحل میں فعال کریں",
  open_camera: "کیمرہ کھولیں",
  and_scan_barcode: "اور بارکوڈ اسکین کریں",
  from_your_phone: "اپنے فون سے",
  udhaar_book_app_from: "اُدھار بک ایپ از ",
  play_store: "پلے اسٹور",
  tap_on_wallet_icon: "والٹ آئیکن پر ٹیپ کریں",
  and_verify_KYC: "تصدیق کریں KYC اور",
  download_app: "ایپ ڈاؤن لوڈ کریں",
  application_completed: "درخواست مکمل ہو گئی",
  account_activation: "اکاؤنٹ ایکٹیویشن",
  your_account_will_be_activated_in: "آپ کا اکاؤنٹ فعال ہونے میں",
  minutes: "منٹ",
  select_package: "پیکج منتخب کریں",
  choose_package: "پیکج چنیں",
  hybrid: "ہائبرڈ",
  data: "ڈیٹا",
  social: "سوشل",
  mini: "منی",
  search_package: "پیکج تلاش کریں",
  select: "منتخب کریں",
  validity: "میعاد",
  electricity: "بجلی",
  gas: "گیس",
  govt_fees: "سرکاری فیس",
  internet: "انٹرنیٹ",
  water: "پانی",
  choose_bill_category: "بل کیٹیگری چنیں",
  bill_organization_company: "بل ادارہ/کمپنی",
  eg_wapda: "WAPDA مثلاً",
  type_scan_account_number: "اکاؤنٹ نمبر ٹائپ کریں یا اسکین کریں",
  enter_customer: "کسٹمر درج کریں",
  billing_organization: "بلنگ ادارہ",
  consumer_num: "کنزیومر نمبر",
  billing_month: "بلنگ مہینہ",
  bill_amount_after_due_date: "مقررہ تاریخ کے بعد بل کی رقم",
  select_voucher: "واؤچر منتخب کریں",
  voucher: "واؤچر",
  voucher_to: "{name} کو واؤچر",
  easyload_to_name: "{name} کو {item}",
  bills: "بلز",
  mobile_packages: "موبائل پیکجز",
  total_easyload: "کل ایزی لوڈ",
  total_commission: "کل کمیشن",
  total_bills_paid: "کل ادا شدہ بلز",
  total_vouchers_bought: "کل خریدے گئے واؤچرز",
  all_transactions: "تمام ٹرانزیکشنز",
  nonIdealPendingCollectionSubtitle:
    "دوستوں اور رابطوں سے یہیں آسانی سے رقم وصول کریں۔ درخواست بھیجنے کے بعد، یہ اس فہرست میں ظاہر ہوگی۔",
  account_not_found_please_enter_valid_account_number_or_IBAN:
    "اکاؤنٹ نہیں ملا، براہ کرم درست اکاؤنٹ نمبر یا آئی بین درج کریں",
  copied: "کاپی ہو گیا",
  package_not_found: "پیکج نہیں ملا",
  no_data_found: "کوئی ڈیٹا نہیں ملا!",
  view_transactions: "ٹرانزیکشنز دیکھیں",
  amount_range: "رقم کی حد",
  no_transactions_found: "کوئی ٹرانزیکشن نہیں ملی",
  balance_insufficient: "بیلنس ناکافی ہے",
  your_sales_your_expenses_your_profit_crystal_clear:
    "آپ کی سیلز، آپ کے اخراجات، آپ کا منافع۔ بالکل واضح۔",
  send_invoices_collect_payments_easy_free:
    "انوائسز بھیجیں۔ ادائیگیاں وصول کریں۔ آسان اور مفت",
  know_who_owes_remind_automatically_get_paid_3x_faster:
    "جانیں کس پر واجب الادا ہے۔ خودکار یاد دہانی بھیجیں۔ 3 گنا تیزی سے ادائیگی حاصل کریں۔",
  keep_stock_updated_never_miss_a_sale_sell_smarter:
    "اسٹاک اپ ڈیٹ رکھیں۔ کوئی سیل مِس نہ کریں۔ سمارٹ طریقے سے بیچیں",
  let_get_you_started: "آئیے شروع کرتے ہیں",
  verify_your_otp: "تصدیق کریں OTP اپنا",
  select_contact: "رابطہ منتخب کریں",
  choose_voucher_type: "واؤچر کی قسم چنیں",
  sell_voucher: "واؤچر فروخت کریں",
  voucher_details: "واؤچر کی تفصیلات",
  no_transactions_yet: "ابھی تک کوئی ٹرانزیکشن نہیں",
  Youll_see_your_all:
    "یہاں آپ کو اپنی تمام موصولہ اور ارسال کردہ رقم کی ٹرانزیکشن ہسٹری نظر آئے گی",
  quicksale: "کوئیک سیل",
  quick_sale_report: "کوئیک سیل رپورٹ",
  create_quick_sale: "کوئیک سیل بنائیں",
  sale_amount: "سیل کی رقم",
  edit_quicksale: "کوئیک سیل میں ترمیم کریں",
  quickSale_has_been_successfully_updated:
    "کوئیک سیل کامیابی سے اپ ڈیٹ ہو گئی",
  quickSale_has_been_successfully_recorded:
    "کوئیک سیل کامیابی سے ریکارڈ ہو گئی",
  are_you_sure_you_want_to_delete_this_sale:
    "کیا آپ واقعی اس سیل ریکارڈ کو ڈیلیٹ کرنا چاہتے ہیں؟",
  discard_quick_sale_btn: "جی ہاں، اس کوئیک سیل کو حذف کریں",
  total_paid_sales: "کل ادا شدہ سیلز",
  total_unpaid_sales: "کل غیر ادا شدہ سیلز",
  search_by_sale_id: "سیل نمبر سے تلاش کریں",
  sale_id: "ID سیل",
  delete_sale: "سیل ڈیلیٹ کریں",
  lost_in_your_quickSales: "اپنی سیلز میں الجھن کا شکار ہیں؟",
  OTP_verification_required: "تصدیق درکار ہے OTP",
  You_cant_leave_otp_verify_message:
    "کی تصدیق کیے بغیر آپ یہ صفحہ نہیں چھوڑ سکتے۔ OTP",
  sale_date_time: "سیل کی تاریخ اور وقت",
  select_company_or_customer: "کمپنی یا کسٹمر منتخب کریں",
  customer_company: "کمپنی / کسٹمر ",
  recieved_amount: "موصولہ رقم",
  recieved: "موصول شدہ",
  transaction_will_be_added_to_sales_and_contact: "ٹرانزیکشن سیلز اور رابطے میں شامل کر دی جائے گی۔",
  upload_attachment: "اٹیچمنٹ اپ لوڈ کریں",
  collect_payment_via_QR_or_bank_transfer: "QR یا بینک ٹرانسفر کے ذریعے ادائیگی وصول کریں۔ 100% مفت",
  view_qr: "دیکھیں QR",
  one_click_sale_faster_transaction: "ایک کلک میں سیل، تیز ٹرانزیکشنز",
  speed_up_sales_reduce_wait_times:
    "سیلز کو تیز کریں، انتظار کا وقت کم کریں، اور مزید رابطوں کو خدمات فراہم کریں۔ روزمرہ کی فوری سیلز کے لیے بہترین۔",
  add_quick_sale: "کوئیک سیل شامل کریں",
  export: "ایکسپورٹ کریں",
  mark_as_paid: "ادا شدہ کے طور پر نشان زد کریں",
  receipt: "رسید",
  quick_expense: "کوئیک خرچہ",
  add_quick_expense: "کوئیک خرچہ شامل کریں",
  lost_in_expenses_stay_organized: "اپنے اخراجات میں الجھن کا شکار ہیں؟ منظم رہیں",
  record_expense_as_soon_as: "کچھ نہ بھولنے کے لیے اخراجات وقوع پذیر ہوتے ہی ریکارڈ کریں۔",
  record_new_quick_sale: "نئی کوئیک سیل ریکارڈ کریں",
  download_bill: "بل ڈاؤن لوڈ کریں",
  collect: "وصول کریں",
  category_pl_tracking: "کیٹیگری (P&L ٹریکنگ)",
  select_sales_category: "سیلز کیٹیگری منتخب کریں",
  scan_or_share_QR_to_collect_payment: "اسکین یا شیئر کریں QR ادائیگی وصول کرنے کے لیے",
  get_qr: "حاصل کریں QR",
  add_line_item: "لائن آئٹم شامل کریں",
  make_payment_with_bank_transfer: "بینک ٹرانسفر کے ذریعے ادائیگیاں کریں۔ 100% مفت۔",
  paid_on: "ادائیگی کی تاریخ",
  unit_price: "یونٹ قیمت",
  start_creating_your_first_sale_invoice: "آسان مراحل کے ساتھ اپنی پہلی سیل انوائس بنانا شروع کریں",
  memo: "میمو",
  add_memo_here: "یہاں میمو شامل کریں",
  back: "واپس",
  remaining_amount: "باقی رقم",
  received_amount: "موصول شدہ رقم",
  PO_number: "نمبر PO",
  select_a_contact: "رابطہ منتخب کریں",
  bank_account_details: "بینک اکاؤنٹ کی تفصیلات",
  secure_100_free: "100% محفوظ۔ 100% مفت۔",
  ref_no: "ریفرنس نمبر",
  are_you_sure_you_want_to_delete_invoice: "کیا آپ واقعی اس انوائس کو حذف کرنا چاہتے ہیں؟",
  are_you_sure_you_want_to_delete_transaction: "کیا آپ واقعی اس ٹرانزیکشن کو حذف کرنا چاہتے ہیں؟",
  start_your_account_by_adding_contact: "رابطہ شامل کر کے اپنے اکاؤنٹس کا آغاز کریں",
  account_help_you_track: "اکاؤنٹس آپ کو یہ ٹریک کرنے میں مدد دیتے ہیں کہ آپ کا کس پر ادھار ہے اور آپ نے کسے ادائیگی کرنی ہے۔",
  do_you_want_to_delete_associated_invoice: "کیا آپ اس رابطے سے منسلک انوائسز کو حذف کرنا چاہتے ہیں؟",
  add_transaction: "ٹرانزیکشن شامل کریں",
  track_the_matter_of_you_took_money_or_gave_money: "اس رابطے کو دی گئی یا اس سے لی گئی رقم کا بیلنس ٹریک کریں۔",
  payment_received: "ادائیگی موصول ہوئی",
  no_transactions_matching_those_filters: "ان فلٹرز سے مطابقت رکھنے والا کوئی ٹرانزیکشن نہیں",
  try_adjusting_filters: "فلٹرز تبدیل کر کے دیکھیں یا",
  reset_small: "ری سیٹ",
  you_wont_be_able_to_change_it_later: "آپ اسے بعد میں تبدیل نہیں کر سکیں گے۔",
  account_settled: "اکاؤنٹ نمٹا دیا گیا",
  create_purchase_order: "پرچیز آرڈر بنائیں",
  purchase_order: "پرچیز آرڈر",
  start_creating_your_fist_purchase_order_with_easy_steps: "آسان مراحل کے ساتھ اپنا پہلا پرچیز آرڈر بنانا شروع کریں",
  download_po: "ڈاؤن لوڈ کریں PO",
  PO_no: "نمبر PO",
  edit_purchase_order: "پرچیز آرڈر میں ترمیم کریں",
  add_notes_here: "یہاں نوٹس شامل کریں",
  notes: "نوٹس",
  reference_number: "ریفرنس نمبر",
  search_by_reference_number: "ریفرنس نمبر کے ذریعے تلاش کریں",
  accept_payments_into_your_bank_account: "اپنے بینک اکاؤنٹ میں ادائیگیاں وصول کریں",
  add_signature_on_invoice: "انوائس پر دستخط شامل کریں",
  get_your_bank_details: "اپنی بینک تفصیلات حاصل کریں",
  overdue: "میعاد گزشتہ",
  outstanding: "واجب الادا",
  type_signature: "دستخط ٹائپ کریں",
  activate_wallet: "والٹ فعال کریں",
  wholesale: "ہول سیل",
  batchAndExpiry: "بیچ اور معیاد ختم ہونے کی تاریخ",
  no_customers_yet: "ابھی تک کوئی کسٹمر نہیں",
  you_have_not_added_any_customer: "آپ نے ابھی تک کوئی کسٹمر شامل نہیں کیا۔ آپ کو ملنے والی رقم ٹریک کرنے کے لیے کسٹمرز شامل کریں۔",
  no_suppliers_yet: "ابھی تک کوئی سپلائر نہیں",
  add_suppliers_to_track_payments: "آپ کو کی جانے والی ادائیگیوں کو ٹریک کرنے کے لیے سپلائرز شامل کریں۔",
  no_transactions_for_others_yet: "ابھی تک دوسروں کی طرف سے کوئی ٹرانزیکشن نہیں",
  when_someone_record_a_transaction_using_your_contact_details: "جب کوئی آپ کی رابطہ تفصیلات استعمال کر کے ٹرانزیکشن ریکارڈ کرے گا، تو یہ خودکار طور پر یہاں ظاہر ہو جائے گا۔",
  items_imported: "آئٹمز درآمد کیے گئے",
  create_search_term_as_new_contact: "'{name}' کو نئے رابطے کے طور پر بنائیں",
  inventory_management: "انوینٹری کا انتظام",
  create_items_in_easy_steps_and_manage_inventory: "آسان مراحل میں آئٹم بنائیں اور انوینٹری کا انتظام کریں۔",
  sell_price: "فروخت قیمت",
  current_qty: "موجودہ مقدار",
  stock_in_qty: "اسٹاک ان مقدار",
  stock_out_qty: "اسٹاک آؤٹ مقدار",
  units_sold: "فروخت شدہ یونٹس",
  total_cost: "کل لاگت",
  see_more: "مزید دیکھیں",
  no_stock_history_yet: "ابھی تک اسٹاک کی کوئی تاریخ نہیں",
  stock_changes_will_appear_here_one_you_start_adding: "جیسے ہی آپ آئٹمز شامل یا اپ ڈیٹ کرنا شروع کریں گے، اسٹاک کی تبدیلیاں یہاں ظاہر ہونے لگیں گی۔",
  transaction_added_by_this_contact_will_appear_here_automatically: "اس رابطے کی طرف سے شامل کردہ ٹرانزیکشنز خودکار طور پر یہاں ظاہر ہوں گی۔",
  quick_sale: "کوئیک سیل",
  sale_invoice: "سیل انوائس",
  all_your_sales_in_one_place: "آپ کی تمام سیلز ایک ہی جگہ",
  manage_all_your_quick_sale_invoices_and_pos_transactions: "اپنی تمام کوئیک سیلز، انوائسز اور پوس ٹرانزیکشنز کو ایک ہی فہرست میں مینج کریں۔",
  businessoverview: "بزنس کا جائزہ",
  add_expense: "خرچہ شامل کریں",
  Add_salesexpenses_to_see_your_PL_and_grow_your_profits: "دیکھنے اور منافع بڑھانے کے لیے سیلز اور اخراجات شامل کریں۔ P&L اپنا",
  viewPAndL: "دیکھیں P&L",
  add_stock: "اسٹاک شامل کریں",
  sale_has_been_successfully_updated: "سیل کامیابی سے اپ ڈیٹ ہو گئی۔",
  profit_Loss: "منافع اور نقصان",
  cash_flow: "کیش فلو",
  total_cost_value: "کل لاگت کی مالیت",
  cash_Bank: "کیش اور بینک",
  total_item_in_stock: "اسٹاک میں کل آئٹمز",
  low_stock_items: "کم اسٹاک آئٹمز",
  receivables: "وصولیاں",
  payables: "قابل ادائیگیاں",
  see_details: "تفصیلات دیکھیں",
  too_many_walk_ins_keep_them_smooth_with_pos: "بہت زیادہ گاہک آ رہے ہیں؟ پوس سے انہیں آسانی سے سنبھالیں",
  start_pos: "پوس شروع کریں",
  profit_Loss_statement: "منافع اور نقصان کا بیان",
  cost_of_sales: "لاگت فروخت",
  gross_profit: "مجموعی منافع",
  categories: "کیٹیگریز",
  see_less: "کم دیکھیں",
  recent_transactions: "حالیہ ٹرانزیکشنز",
  gross_cash_inflow: "مجموعی کیش آمد",
  gross_cash_outflow: "مجموعی کیش اخراج",
  net_cash_change: "خالص کیش تبدیلی",
  change_category: "کیٹیگری تبدیل کریں",
  sales_category: "سیلز کیٹیگری",
  category_updated: "کیٹیگری اپ ڈیٹ ہو گئی",
  organize_your_expenses: "اپنے اخراجات کو منظم کریں",
  organize_your_sales: "اپنی سیلز کو منظم کریں",
  manage_your_Saddar_store_inventory_and_look_after_the_payments: "اپنے صدر اسٹور کی انوینٹری کا انتظام کریں اور ادائیگیوں کا خیال رکھیں۔",
  contact_attached_successfully: "رابطہ کامیابی سے منسلک ہو گیا",
  debit: "ڈیبٹ",
  no_ledger_matching_those_filters: "ان فلٹرز سے مطابقت رکھنے والا کوئی لیجر نہیں",
  clear_all_items: "تمام آئٹمز صاف کریں",
  add_to_sale: "سیل میں شامل کریں",
  search_by_customer_name_or_sale_id: "کسٹمر کے نام یا آرڈر نمبر سے تلاش کریں",
  order_number: "آرڈر نمبر",
  Variation: "ویری ایشن",
  create_item_in_easy_steps_and_manage_stock: "آسان مراحل میں آئٹم بنائیں اور اسٹاک کا انتظام کریں۔",
  mark_in_stock: "اسٹاک میں موجود نشان زد کریں",
  mark_out_of_stock: "اسٹاک ختم نشان زد کریں",
  change_language: "زبان تبدیل کریں",
  select_language: "زبان منتخب کریں",
  change_appearance: "ظاہری شکل تبدیل کریں",
  select_theme: "تھیم منتخب کریں",
  light_mode: "لائٹ موڈ",
  dark_mode: "ڈارک موڈ",
  delete_business: "بزنس حذف کریں",
  edit_profile: "پروفائل میں ترمیم کریں",
  confirmation: "تصدیق",
  no_order_matching_those_filters: "ان فلٹرز سے مطابقت رکھنے والا کوئی آرڈر نہیں",
  pin: "پن",
  it_ensure_that_no_one_else_can_access: "یہ یقینی بناتا ہے کہ آپ کے اکاؤنٹ تک کوئی اور رسائی حاصل نہ کر سکے",
  create_your_new_pin: "نیا پن بنائیں",
  confirm_your_new_pin: "پن کی تصدیق کریں",
  enter_current_pin: "موجودہ پن درج کریں",
  please_enter_your_4_digits_PIN_to_contine: "جاری رکھنے کے لیے براہ کرم اپنا 4 ہندسوں کا پن درج کریں",
  your_accounts_first_line_of_defence_make_sure_its_unique: "آپ کے اکاؤنٹ کی حفاظت کی پہلی لائن۔ اسے منفرد اور اندازہ لگانا مشکل رکھیں۔",
  pin_updated_successfully: "پن کامیابی سے اپ ڈیٹ ہو گیا",
  profile_updated: "پروفائل اپ ڈیٹ ہو گئی",
  business_created: "بزنس بن گیا",
  create_business: "کاروبار بنائیں",
  variant_image: "ویری اینٹ تصویر",
  view: "دیکھیں",
  setup_your_printer: "اپنا پرنٹر سیٹ اپ کریں",
  download_applications: "ایپلیکیشنز ڈاؤن لوڈ کریں",
  printer_selection: "پرنٹر کا انتخاب",
  test_printer: "پرنٹر ٹیسٹ کریں",
  to_setup_printer_download_java: "ڈاؤن لوڈ اور انسٹال کریں Java پرنٹر سیٹ اپ کرنے کے لیے،",
  download_java: "ڈاؤن لوڈ کریں Java",
  watch_video_for_help: "مدد کے لیے ویڈیو دیکھیں",
  need_help_contact: "مدد چاہیے؟ +92 341 1141000",
  test_selected_printer: "منتخب پرنٹر ٹیسٹ کریں",
  printer_setup_successfully: "پرنٹر کامیابی سے سیٹ اپ ہو گیا",
  proceed: "جاری رکھیں",
  select_printer: "پرنٹر منتخب کریں",
  printers: "پرنٹرز",
  add_another_printer: "ایک اور پرنٹر شامل کریں",
  printer_name: "پرنٹر کا نام",
  connected: "منسلک",
  not_connected: "غیر منسلک",
  connect: "منسلک کریں",
  disconnect: "منقطع کریں",
  is_java_application_successfully_installed: "ایپلیکیشن کامیابی سے انسٹال ہو گئی ہے؟ Java کیا",
  is_printer_software_successfully_installed: "کیا پرنٹر سافٹ ویئر کامیابی سے انسٹال ہو گیا ہے؟",
  is_printer_software_drivers_successfully_installed: "کیا پرنٹر سافٹ ویئر ڈرائیورز کامیابی سے انسٹال ہو گئے ہیں؟",
  is_printer_test_successful: "کیا پرنٹر ٹیسٹ کامیاب رہا؟",
  please_select_a_printer: "براہ کرم ایک پرنٹر منتخب کریں",
  failed_to_connect_printer_please_try_again: "پرنٹر منسلک کرنے میں ناکامی ہوئی۔ براہ کرم دوبارہ کوشش کریں۔",
  download_and_install_printer_software: "پرنٹر سافٹ ویئر ڈاؤن لوڈ اور انسٹال کریں",
  download_and_install_drivers: "ڈرائیورز ڈاؤن لوڈ اور انسٹال کریں",
  download_software: "سافٹ ویئر ڈاؤن لوڈ کریں",
  download_drivers: "ڈرائیورز ڈاؤن لوڈ کریں",
  test_print: "ٹیسٹ پرنٹ",
  need_help: "مدد چاہیے؟",
  upload: "اپ لوڈ کریں",
  your_data_backup_is_up_to_date: "آپ کے ڈیٹا کا بیک اپ اپ ڈیٹ ہے",
  your_data_backup_is_not_up_to_date: "آپ کے ڈیٹا کا بیک اپ اپ ڈیٹ نہیں ہے",
  error: "خرابی",
  enter_your_business_details: "بزنس کی تفصیلات درج کریں",
  enter_your_business_name: "اپنے بزنس کا نام درج کریں",
  create_and_send_invoices: "انوائسز بنائیں اور بھیجیں",
  create_send_and_track_invoices_Get_paid_faster: "انوائسز بنائیں، بھیجیں اور ٹریک کریں۔ تیزی سے ادائیگی حاصل کریں۔",
  manage_your_accounts: "اپنے اکاؤنٹس کا انتظام کریں",
  track_money_in_and_out_Faster_collections_100reliable: "آنے اور جانے والی رقم ٹریک کریں۔ تیز تر وصولیاں۔ 100% قابل اعتماد۔",
  collect_send_and_earn_money: "رقم وصول کریں، بھیجیں اور کمائیں",
  your_trusted_wallet_100_secure_completely_free: "آپ کا قابل اعتماد والٹ۔ 100% محفوظ۔ بالکل مفت۔",
  stock_quantity: "اسٹاک کی مقدار",
  skip: "نظر انداز کریں",
  what_would_you_like_to_start: "آپ کیسے شروع کرنا چاہیں گے؟",
  scan_download_app: "اسکین کریں اور ایپ ڈاؤن لوڈ کریں",
  select_unit_type: "یونٹ کی قسم منتخب کریں",
  sr_no: "نمبر شمار",
  backup_your_data: "اپنے ڈیٹا کا بیک اپ لیں",
  no_option: "کوئی آپشن نہیں",
  is_your_printer_not_in_the_list: "کیا آپ کا پرنٹر فہرست میں موجود نہیں ہے؟ Java، پرنٹر سافٹ ویئر اور پرنٹر ڈرائیور انسٹال کریں، پھر اس پر کلک کریں",
  log_out: "لاگ آؤٹ",
  loss: "نقصان",
  net_loss: "خالص نقصان",
  uncategorized: "غیر کیٹیگرائزڈ",
  no_uncategorized_transactions: "کوئی غیر کیٹیگرائزڈ ٹرانزیکشن نہیں",
  all_sales_and_expenses_are_categorized: "تمام اخراجات اور سیلز کیٹیگرائز ہو چکے ہیں۔ چیزوں کو منظم رکھنے پر شاباش!",
  create_an_account: "اکاؤنٹ بنائیں",
  login_to_rupin: "میں لاگ ان کریں RUPIN",
  log_in: "لاگ ان کریں",
  welcome_to: "خوش آمدید",
  change_phone_number: "فون نمبر تبدیل کریں",
  advance_paid: "پیشگی ادا شدہ",
  you_are_currently_offline: "آپ فی الحال آف لائن ہیں",
  please_check_your_internet_connection_and_try_again: "براہ کرم اپنا انٹرنیٹ کنکشن چیک کریں اور دوبارہ کوشش کریں۔",
  send_code: "کوڈ بھیجیں",
  verify_captcha: "کیپچا کی تصدیق کریں",
  too_many_incorrect_attempts: "غلط پن کی بہت زیادہ کوششیں",
  pin_entry_has_been_temporarily_locked_after_3_incorrect_attempts: "آپ کی حفاظت کے لیے، 3 غلط کوششوں کے بعد پن درج کرنا عارضی طور پر بلاک کر دیا گیا ہے۔",
  Youve_reached_the_8_transactions_limit: "کو محفوظ طریقے سے استعمال جاری رکھنے کے لیے اپنے فون نمبر کی تصدیق کریں۔ RUPIN آپ 8 ٹرانزیکشنز کی حد تک پہنچ گئے ہیں۔",
  You_reached_your_limit: "آپ اپنی حد تک پہنچ گئے ہیں",
  payment_received_added: "موصول شدہ ادائیگی شامل کر دی گئی",
  unified_view_of_quick_sale_invoice_and_pos: "کوئیک سیل، انوائس اور پوس کا مشترکہ منظر",
  account_locked: "اکاؤنٹ بلاک ہے",
  expense_category: "خرچے کی کیٹیگری",
  select_expense_category: "خرچے کی کیٹیگری منتخب کریں",
  select_due_date: "ادائیگی کی آخری تاریخ منتخب کریں",
  start_typing_to_create_one: "بنانے کے لیے ٹائپ کرنا شروع کریں",
  select_purchase_category: "خریداری کی کیٹیگری منتخب کریں",
  add_signature_on_purchase_order: "پرچیز آرڈر پر دستخط شامل کریں",
  purchase_no: "پرچیز نمبر",
  unsupported_file_format: "غیر معاون فائل فارمیٹ",
  this_customer_entry_will_be_transferred_to_the_supplier_section: "اس کسٹمر کی انٹری سپلائر سیکشن میں منتقل کر دی جائے گی۔",
  this_supplier_entry_will_be_transferred_to_the_customer_section: "اس سپلائر کی انٹری کسٹمر سیکشن میں منتقل کر دی جائے گی۔",
  we_need_your_current_pin_to_proceed: "آگے بڑھنے کے لیے ہمیں آپ کا موجودہ پن درکار ہے۔",
  profits: "منافع",
  profit_Loss_statement: "منافع اور نقصان کا بیان",
  net_cash: "خالص کیش",
  account_temporarily_locked: "اکاؤنٹ عارضی طور پر بلاک ہے",
  invoice_created_with_rupin: "انوائس بنائی گئی بذریعہ RUPIN",
  po_created_with_rupin: "پرچیز آرڈر بنایا گیا بذریعہ RUPIN",
  go_to_listing: "فہرست پر جائیں",
  invoice_details: "انوائس کی تفصیلات",
  purchase_order_details: "پرچیز آرڈر کی تفصیلات",
  record_new_quick_expense: "نیا کوئیک خرچہ ریکارڈ کریں",
  account_temporarily_locked_OTP_desc: "کوششوں کے بعد یہ اکاؤنٹ عارضی طور پر بلاک کر دیا گیا ہے۔ دوبارہ رسائی کے لیے، براہ کرم ہم سے رابطہ کریں OTP آپ کی حفاظت کے لیے، متعدد غلط",
  account_temporarily_locked_PIN_desc: "آپ کی حفاظت کے لیے، متعدد غلط پن کوششوں کے بعد یہ اکاؤنٹ عارضی طور پر بلاک کر دیا گیا ہے۔ دوبارہ رسائی کے لیے، ادھار بک ایپ کے ذریعے اپنی شناخت کی تصدیق کریں۔",
  order_saved_into_draft_sales: "آرڈر ڈرافٹ سیلز میں محفوظ کر لیا گیا",
  add_contact_and_items_to_send_money: "رقم بھیجنے کے لیے رابطہ اور آئٹمز شامل کریں",
  amount_required_to_send_money: "رقم بھیجنے کے لیے رقم درج کرنا ضروری ہے",
  go_to_home: "ہوم پر جائیں",
  the_page_you_are_looking_for_may_be_moved_or_deleted: "جو صفحہ آپ تلاش کر رہے ہیں وہ منتقل یا ڈیلیٹ ہو چکا ہے۔",
  item_image: "آئٹم کی تصویر",
  money: "رقم",
  report_download_is_not_available_yet: "رپورٹ ڈاؤن لوڈ ابھی دستیاب نہیں ہے۔",
  something_went_wrong: "کچھ غلط ہو گیا",
  PIN_is_required: "پن درج کرنا ضروری ہے۔",
  you_cannot_leave_this_page_without_creating_a_PIN: "آپ پن بنائے بغیر یہ صفحہ نہیں چھوڑ سکتے۔",
  update_item_price: "آئٹم کی قیمت اپ ڈیٹ کریں",
  udhaar_book_is_now_rupin: "ہے۔ Rupin اب Udhaar Book",
  migration_upgrade_subtitle: "ہم نے اپ گریڈ کر لیا ہے۔ آپ کا اکاؤنٹ بالکل ویسا ہی رہے گا۔",
  migration_account_safe: "آپ کا اکاؤنٹ محفوظ ہے",
  migration_data_secure: "تمام ڈیٹا محفوظ ہے",
  migration_transaction_intact: "ٹرانزیکشن ہسٹری برقرار ہے",
  migration_business_records_unchanged: "بزنس ریکارڈ تبدیل نہیں ہوا",
  continue_to_rupin: "پر جاری رکھیں Rupin",
  rupin_migration_banner_message:
    "ہے۔ سب کچھ محفوظ ہے، نئے فیچرز آ رہے ہیں، بالکل مفت۔ Rupin اب Udhaar Book",
  no_vouchers: "کوئی واؤچر نہیں",
  no_bill_category: "کوئی بل کیٹیگری نہیں",
  no_vouchers_available: "کوئی واؤچر دستیاب نہیں",
  there_are_no_vouchers_available_at_the_moment: "اس وقت کوئی واؤچر دستیاب نہیں ہے۔ واؤچر دستیاب ہوتے ہی یہاں ظاہر ہوں گے۔",
  are_you_sure_you_want_to_logout_all_data_will_be_lost: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟ تمام ڈیٹا ضائع ہو جائے گا۔",
  view_statement: "اسٹیٹمنٹ دیکھیں",
  incoming_this_month: "اس مہینے آنے والی رقم",
  outgoing_this_month: "اس مہینے جانے والی رقم",
  view_account_limit: "اکاؤنٹ لمٹ دیکھیں",
  pay_bills: "بل ادا کریں",
  account_limit: "اکاؤنٹ لمٹ",
  increase_limit: "لمٹ بڑھائیں",
  total_limit: "کل لمٹ",
  remaining: "باقی",
  used: "استعمال شدہ",
  resets_on: "ری سیٹ ہونے کی تاریخ",
  upload_electricity_or_gas_bill_to_increase_limit: "لمٹ بڑھانے کے لیے بجلی یا گیس کا بل اپ لوڈ کریں",
  upload_bill: "بل اپ لوڈ کریں",
  ntn_number: "نمبر NTN",
  enter_ntn_number: "نمبر درج کریں NTN",
  ntn_number_length: "نمبر 7 سے 13 ہندسوں کے درمیان ہونا چاہیے NTN",
  something_went_wrong_please_try_again: "کچھ غلط ہو گیا، دوبارہ کوشش کریں",
  limit_increase_is_in_process: "لمٹ بڑھانے کا عمل جاری ہے",
  limit_increase_is_in_process_subtitle: "مطلوبہ تفصیلات جمع کروانے کا شکریہ، ہم آپ سے رابطہ کریں گے۔",
  share_qr: "کیو آر شیئر کریں",
  get_paid_faster: "تیزی سے ادائیگی حاصل کریں",
  get_paid_faster_subtitle: "ڈیجیٹل انوائسز کے ذریعے ادائیگیاں وصول کرنا شروع کریں",
  pay_bills: "بل ادا کریں",
  enter_iban_account_raastid_name_or_phone: "راست آئی ڈی، آئی بین، اکاؤنٹ نمبر، نام یا فون نمبر درج کریں",
  select_start_bank: "بینک منتخب کریں",
  no_banks_found: "کوئی بینک نہیں ملا",
  print_qr: "کیو آر پرنٹ کریں",
  download_qr: "کیو آر ڈاؤن لوڈ کریں",
  limit_increase_request_in_process_need_help: "لمٹ بڑھانے کی درخواست پر کارروائی جاری ہے۔ مدد درکار ہے؟  ہم سے چیٹ کریں",
  refund: "ریفنڈ",
  select_bill_category: "بل کیٹیگری منتخب کریں",
  consumer_number: "کنزیومر نمبر",
  scan_barcode: "بار کوڈ اسکین کریں",
  results: "نتائج",
  last_paid: "آخری ادائیگی",
  select_bill: "بل منتخب کریں",
  search_bill_by_name: "نام سے بل تلاش کریں",
  no_bills_found: "کوئی بل نہیں ملا",
  due: "آخری تاریخ",
  you_will_earn: "آپ کمائیں گے",
  points: "پوائنٹس",
  bill_paid_with: "بل ادا کیا گیا بذریعہ",
  rupin: "RUPIN",
  bill_paid_with_rupin: "بل ادا کیا گیا بذریعہ RUPIN",
  easyload_done_with: "ایزی لوڈ کیا گیا بذریعہ",
  easyload_done_with_rupin: "ایزی لوڈ کیا گیا بذریعہ RUPIN",
  voucher_sent_with: "واؤچر بھیجا گیا بذریعہ",
  voucher_sent_with_rupin: "واؤچر بھیجا گیا بذریعہ RUPIN",
  confirm_payment: "Confirm payment",
  failed_to_copy: "کاپی نہیں ہو سکا",
  money_sent_with: "رقم بھیجی گئی بذریعہ",
  money_received: "رقم موصول ہوئی",
  money_sent: "رقم بھیجی گئی",
  bundle_recharge: "ایزی لوڈ پیکج",
  mins: "منٹ",
  other_net_mins: "دیگر نیٹ منٹس",
  all_net_sms: "SMS آل نیٹ",
  money_sent_to: "رقم بھیجی گئی بنام",
  money_sent_with_rupin: "کے ذریعے بھیجی گئی RUPIN رقم",
  voucher_company: "واؤچر کمپنی",
  select_voucher_company: "واؤچر کمپنی منتخب کریں",
  search_voucher_by_name: "نام سے واؤچر تلاش کریں",
  no_voucher_found: "کوئی واؤچر نہیں ملا",
  recent: "حالیہ",
  no_results_enter_complete_account_or_iban: "کوئی نتیجہ نہیں، مکمل اکاؤنٹ نمبر یا آئی بین درج کریں",
  top_up_account_to_complete_transaction: "اس لین دین کو مکمل کرنے کے لیے اپنے اکاؤنٹ میں رقم شامل کریں۔",
  search_bank: "بینک تلاش کریں",
  error_in_send_money: "رقم بھیجنے میں خرابی",
  transaction_failed: "لین دین ناکام",
  your_account_has_been_locked: "آپ کا اکاؤنٹ لاک ہو گیا ہے",
  tid: "TID",
  by: "بذریعہ",
  fee_free: "(مفت)",
  fast_secure_payment_in: "تیز، محفوظ ادائیگی ",
  view_receipt: "رسید دیکھیں",
  copy_receipt: "رسید کاپی کریں",
  network_type: "نیٹ ورک کی قسم",
  could_not_load_qr: "کی تفصیلات لوڈ نہیں ہو سکیں۔ دوبارہ کوشش کریں۔ QR",
  package_name: "پیکج کا نام",
  bank_statement: "بینک اسٹیٹمنٹ",
  last_3_months: "پچھلے 3 مہینے",
  last_6_months: "پچھلے 6 مہینے",
  last_12_months: "پچھلے 12 مہینے",
  request_placed: "درخواست بھیج دی گئی",
  downloading_statement: "اسٹیٹمنٹ ڈاؤن لوڈ ہو رہی ہے...",
  duration: "دورانیہ",
  easypaisa_tab: "ایزی پیسہ",
  jazzcash_tab: "جاز کیش",
  searching: "تلاش جاری ہے",
  weak_pin_choose_something_else: "کمزور پن۔ کوئی اور منتخب کریں",
  first_create_your_pin: "پہلے اپنا پن بنائیں",
  others: "دیگر",
  add_first_transaction_for_name: "{name} کا پہلا حساب لکھیں",
  invoice_sale: "انوائس سیل",
  attachment: "اٹیچمنٹ",
  paid_transactions_cannot_be_edited: "ادا شدہ ٹرانزیکشنز میں ترمیم نہیں کی جا سکتی۔",
  cash_book: "کیش بک",
  enter_product_name: "پروڈکٹ کا نام درج کریں",
  enter_stock: "اسٹاک درج کریں",
  enter_low_stock: "کم اسٹاک درج کریں",
  enter_sell_price: "قیمت درج کریں",
  enter_barcode: "بارکوڈ درج کریں",
  enter_wholesale_price: "ہول سیل قیمت درج کریں",
  enter_value: "قدر درج کریں",
  quick_item_save: "محفوظ کریں",
  quick_item_cancel: "منسوخ کریں",
  bulk_upload_invalid_item_name: "آئٹم کا نام درست نہیں۔ صرف حروف، نمبر، اسپیس، - یا _ استعمال کریں۔",
  bulk_upload_item_name_missing: "CSV ٹیمپلیٹ میں آئٹم کا نام نہیں لکھا گیا۔",
  custom_date_range: "مخصوص تاریخ کی حد",
  custom_statements: "کسٹم اسٹیٹمنٹس",
  statement_generation_started: "آپ کی اسٹیٹمنٹ تیار ہو رہی ہے۔ آپ اسے اسٹیٹمنٹس دیکھیں میں دیکھ سکتے ہیں۔",
  no_available_statements: "کوئی اسٹیٹمنٹ دستیاب نہیں",
  no_available_statements_subtitle: "آپ کے  بینک اسٹیٹمنٹس دستیاب ہوتے ہی یہاں ظاہر ہوں گے",
  in_progress: "جاری ہے",
  cashback_on_easyload: "ایزی لوڈ پر کیش بیک",
  are_you_sure_you_want_to_delete_statement: "کیا آپ واقعی اسٹیٹمنٹ ڈیلیٹ کرنا چاہتے ہیں",
  channel: "چینل",
  avg_order_value: "اوسط آرڈر ویلیو",
  contribution: "حصہ",
  total_collected: "کل وصول شدہ",
  percentage: "فیصد",
  items_sold: "فروخت شدہ آئٹمز",
  gross_sales: "مجموعی سیلز",
  net_sales: "خالص سیلز",
  last_sold: "آخری فروخت",
  current_stock: "موجودہ اسٹاک",
  cost: "لاگت",
  profit_margin: "منافع کا مارجن",
  average_unit_price: "اوسط یونٹ قیمت",
  average_expense: "اوسط خرچہ",
  last_purchased: "آخری خریداری",
  cost_of_stock_sold: "فروخت شدہ اسٹاک کی لاگت",
  gross_loss: "مجموعی نقصان",
  total_discount: "کل ڈسکاؤنٹ",
  orders_with_discount: "ڈسکاؤنٹ والے آرڈرز",
  average_discount_per_order: "فی آرڈر اوسط ڈسکاؤنٹ",
  total_tax_collected: "کل وصول شدہ ٹیکس",
  taxable_sales: "قابلِ ٹیکس سیلز",
  tax_free_sales: "ٹیکس فری سیلز",
  multiple_tax_rates: "متعدد ٹیکس ریٹس",
  tax_rate: "ٹیکس ریٹ",
  tax_collected: "وصول شدہ ٹیکس",
  activate_account: "اکاؤنٹ ایکٹیویٹ کریں",
  activate_now: "ابھی ایکٹیویٹ کریں",
  add_money_from_any_bank_free: "کسی بھی بینک سے رقم شامل کریں۔ 100 مفت۔",
  add_money_from_easypaisa: "سے رقم شامل کریں Easypaisa",
  easypaisa_step_see_all: "پر کلک کریں 'See all'",
  easypaisa_step_fee_collection: "منتخب کریں 'Fee collection'",
  easypaisa_step_search_rupin: "تلاش کریں اور منتخب کریں 'Rupin'",
  easypaisa_step_enter_consumer_id: "درج کریں ID کنزیومر",
  instruction_for_adding_money: "رقم شامل کرنے کی ہدایات",
  getQR: "حاصل کریں QR",
  enter_amount: "رقم درج کریں",
  processing_limit_increase_contact_you: "لمٹ میں اضافے پر کارروائی جاری ہے۔ ہم آپ سے رابطہ کریں گے",
  view_yearly_data: "سالانہ ڈیٹا دیکھیں",
  no_data_yet: "ابھی تک کوئی ڈیٹا نہیں",
  it_looks_like_you_dont_have_any_data_yet: "لگتا ہے آپ نے ابھی تک کوئی ٹرانزیکشن نہیں کی۔",
  start_new_sale: "نئی سیل شروع کریں",
  sales_summary: "سیلز کا خلاصہ",
  discount_summary: "ڈسکاؤنٹ کا خلاصہ",
  expense_by_category: "کیٹیگری کے حساب سے اخراجات",
  low_selling_items: "کم فروخت ہونے والے آئٹمز",
  sales_by_category: "کیٹیگری کے حساب سے سیلز",
  sales_by_payment_method: "ادائیگی کے طریقے کے حساب سے سیلز",
  tax_summary: "ٹیکس کا خلاصہ",
  top_contacts_by_sale: "سیل کے حساب سے ٹاپ رابطے",
  total_sales_by_channel: "چینل کے حساب سے کل سیلز",
  track_every_rupee: "ہر روپے کو ٹریک کریں",
  record_daily_cash_in_and_cash_out: "روزانہ کیش ان اور کیش آؤٹ ریکارڈ کریں۔",
  add_category_to_track_PAndL: "ٹریک کرنے کے لیے کیٹیگری شامل کریں P&L",
  saved_successfully: "کامیابی سے محفوظ ہو گیا",
  unable_to_load_this_entry: "یہ اندراج لوڈ نہیں ہو سکا",
  no_vouchers_available: "کوئی واؤچر دستیاب نہیں",
  there_are_no_vouchers_available_at_the_moment: "اس وقت کوئی واؤچر دستیاب نہیں ہے۔ واؤچر دستیاب ہوتے ہی یہاں ظاہر ہوں گے۔",
  are_you_sure_you_want_to_logout_all_data_will_be_lost: "کیا آپ واقعی لاگ آؤٹ کرنا چاہتے ہیں؟ تمام ڈیٹا ضائع ہو جائے گا۔",
  confirm_payment: "ادائیگی کی تصدیق",
  incorrect_reference_number: "غلط ریفرنس نمبر",
  bill_image_will_appear_here: "بل کی تصویر یہاں ظاہر ہوگی",
  reference_no: "ریفرنس نمبر",
  account_no: "اکاؤنٹ نمبر",
  customer_id: "کسٹمر آئی ڈی",
  instantly_check_your_bill: "فوری طور پر اپنا بل چیک کریں",
  enter_bill_details_below: "اپنا تازہ ترین بل دیکھنے، ادا کرنے اور کیش بیک کمانے کے لیے نیچے بل کی تفصیلات درج کریں",
  search_bill: "بل تلاش کریں",
  powered_by_nadra: "بذریعہ نادرا",
  licensed_by_sbp_in_principle: "ایس بی پی سے لائسنس یافتہ (اصولی طور پر)",
  trusted_by_5_3_million_users: "5.3 ملین سے زائد صارفین کا اعتماد",
  select_biller: "بلر منتخب کریں",
  your: "آپ کا",
  check_pay_bills_with_rupin: "روپین کے ساتھ بل چیک اور ادا کریں",
  easyLoad: "ایزی لوڈ",
  leaderboard_desc: "زیادہ ریچارج کریں اور زیادہ پیسے کمائیں",
  stocks_deleted_success: "اسٹاک کامیابی سے ڈیلیٹ ہوگیا",
  last_trx_date: "آخری ٹرانزیکشن تاریخ",
  due_today: "آج واجب الادا",
  total_balance_due: "کل واجب الادا رقم",
  copy_details: "تفصیلات کاپی کریں",
  collect_from: "وصول کریں از",
  application_ID: "ID درخواست",
  account_detailsbank_transfer: "یا بینک ٹرانسفر کے ذریعے ادائیگیاں وصول کریں۔ 100% مفت QR",
  show_qr: "دکھائیں QR",
  copy_qr_image: "کیو آر تصویر کاپی کریں",
  image_copied: "تصویر کاپی ہو گئی",
  you_dont_have_any_pending_collections: "آپ کے پاس کوئی باقی ادائیگی نہیں ہے",
  visibility: "مرئیت",
  published: "شائع شدہ",
  by_others: "دیگر کی طرف سے",
  method: "طریقہ",
  newest: "تازہ ترین",
  oldest: "پرانا ترین",
  amount_high_to_low: "رقم (زیادہ سے کم)",
  amount_low_to_high: "رقم (کم سے زیادہ)",
  search: "تلاش کریں",
  name_z_a: "(Z-A) نام",
  quantity_high_to_low: "مقدار (زیادہ سے کم)",
  quantity_low_to_high: "مقدار (کم سے زیادہ)",
  end: "اختتام",
  keyword: "لفظ",
  seller_central: "سیلر سینٹرل",
  pincode_menu_label: "پن کوڈ",
  printer: "پرنٹر",
  search_by: "کے ذریعے تلاش کریں",
  something_went_wrong_fetching_transactions: "ٹرانزیکشنز حاصل کرتے وقت کچھ غلط ہوگیا",
  download_url_not_available: "دستیاب نہیں ہے URL ڈاؤن لوڈ",
  pdf_downloaded_successfully: "ڈاؤن لوڈ ہوگئی PDF",
  failed_to_download_file: "فائل ڈاؤن لوڈ نہیں ہوسکی",
  sent: "بھیج دیا گیا",
  transfer: "ٹرانسفر",
  withdraw: "نکلوائیں",
  bill_payment_text: "بل ادائیگی",
  voucher_payment_text: "واؤچر ادائیگی",
  rupin_cashback: "روپن کیش بیک",
  sms_plan: "پلان SMS",
  order_hash: "آرڈر #",
  please_add_a_phone_number_to_continue: "جاری رکھنے کے لیے فون نمبر شامل کریں",
  bill_fetching_failed: "بل حاصل نہیں ہوسکا",
  error_fetching_bill_transaction: "بل ٹرانزیکشن حاصل کرنے میں خرابی",
  not_paid_overdue: "ادا نہیں ہوا (موعد گزر گئی)",
  month: "مہینہ",
  consumer_id: "ID کنزیومر",
  bills_will_appear_here_once_available: "دستیاب ہوتے ہی بل یہاں نظر آئیں گے",
  bill_not_found: "بل نہیں ملا",
  error_fetching_bill: "بل حاصل کرنے میں خرابی",
  bill_payment_failed: "بل ادائیگی ناکام ہوگئی",
  error_in_bill_payment: "بل ادائیگی میں خرابی",
  please_add_phone_number_to_continue: "جاری رکھنے کے لیے فون نمبر شامل کریں",
  search_by_name_or_phone: "نام یا فون نمبر سے تلاش کریں",
  no_of_transactions: "ٹرانزیکشنز کی تعداد",
  try_adjusting_your_filters_or: "فلٹرز تبدیل کریں یا ",
  transactions_will_appear_here_once_available: "دستیاب ہوتے ہی ٹرانزیکشنز یہاں نظر آئیں گی",
  cashback: "کیش بیک",
  error_in_recharge: "ری چارج میں خرابی",
  free: "مفت",
  on_net_mins: "آن نیٹ منٹس",
  gbs_data: "ڈیٹا GBs",
  all_in_one_weekly: "آل اِن ون ویکلی",
  error_in_easyload_and_package: "ایزی لوڈ اور پیکج میں خرابی",
  default_processing_time: "2.6 سیکنڈ",
  open_your_bank_app_easypaisa_or_jazzcash: "اپنی بینک ایپ، ایزی پیسہ یا جاز کیش کھولیں",
  tap_send_or_transfer: "'بھیجیں' یا 'ٹرانسفر' پر ٹیپ کریں",
  search_rupin: "روپن تلاش کریں",
  enter_rupins_account_number_or_iban: "روپن کا اکاؤنٹ نمبر یا آئی بین درج کریں",
  easypaisa_app_send_money: "ایزی پیسہ ایپ (پیسے بھیجیں)",
  open_easypaisa_app: "ایزی پیسہ ایپ کھولیں",
  tap_on_send_money: "'پیسے بھیجیں' پر ٹیپ کریں",
  select_bank_transfer: "'بینک ٹرانسفر' منتخب کریں",
  select_bank_rupin: "'روپن' بینک منتخب کریں",
  easypaisa_app_collection: "ایزی پیسہ ایپ (کلیکشن)",
  tap_on_see_all: "'سب دیکھیں' پر ٹیپ کریں",
  tap_on_fee_collection: "'فیس کلیکشن' پر ٹیپ کریں",
  search_and_select_udhaar_app: "\"ادھار ایپ\" تلاش کر کے منتخب کریں",
  enter_consumer_id: "کنزیومر آئی ڈی درج کریں",
  open_jazzcash_app: "جاز کیش ایپ کھولیں",
  tap_on_money_transfer: "'منی ٹرانسفر' پر ٹیپ کریں",
  tap_on_bank_transfer: "'بینک ٹرانسفر' پر ٹیپ کریں",
  cash_bank: "کیش/بینک",
  voucher_purchase_failed: "واؤچر کی خریداری ناکام ہوگئی",
  error_in_buy_voucher: "واؤچر خریدنے میں خرابی",
  voucher_transaction_failed: "واؤچر ٹرانزیکشن ناکام ہوگئی",
  error_fetching_voucher_transaction: "واؤچر ٹرانزیکشن حاصل کرنے میں خرابی",
  to_lowercase: "کو",
  cashback_label: "کیش بیک",
  bill_payment_label: "بل ادائیگی",
  consumer_name: "کنزیومر کا نام",
  consumer_name_caps: "کنزیومر کا نام",
  no_of_bills: "بلوں کی تعداد",
  try_adjusting_your_filters: "فلٹرز تبدیل کریں یا ",
  attach_label: "منسلک کریں",
  to_this_transaction_confirm: "اس ٹرانزیکشن سے منسلک کریں؟",
  attach_contact_confirm: "{name} کو اس ٹرانزیکشن سے منسلک کریں؟",
  contact_linked_successfully: "کانٹیکٹ منسلک ہوگیا",
  failed_to_link_contact: "کانٹیکٹ منسلک نہیں ہوسکا",
  transaction_not_available: "ٹرانزیکشن دستیاب نہیں ہے",
  error_fetching_transaction: "ٹرانزیکشن حاصل کرنے میں خرابی",
  account_locked_contact_support: "آپ کا اکاؤنٹ مقفل کردیا گیا ہے، براہ کرم سپورٹ سے رابطہ کریں",
  previous_slide: "پچھلی سلائیڈ",
  next_slide: "اگلی سلائیڈ",
  wallet_onboarding_b_slide3_alt: "وصولی Rupin QR",
  wallet_onboarding_b_slide2_alt: "معاون بینک",
  wallet_onboarding_b_slide1_alt: "والٹ Rupin",

  minimum_amount: "کم از کم رقم",
  maximum_amount: "زیادہ سے زیادہ رقم",
  search_by_contact: "کانٹیکٹ سے تلاش کریں",
  search_by_contact_or_order_no: "کانٹیکٹ یا آرڈر نمبر سے تلاش کریں",
  search_by_contact_or_invoice_no: "کانٹیکٹ یا انوائس نمبر سے تلاش کریں",
  invalid_number: "غلط نمبر",
  cannot_be_negative: "منفی نہیں ہو سکتا",
  cannot_be_negative_or_zero: "منفی یا صفر نہیں ہو سکتا",
  max_should_be_greater_than_min: "زیادہ سے زیادہ، کم از کم سے بڑا ہونا چاہیے",
  thirty_days: "30 دن",
  half_yearly: "6 ماہ",

  fill_in_your_data: "اپنا ڈیٹا درج کریں",
  upload_the_file: "فائل اپ لوڈ کریں",
  csv_xls_files_supported: "(.csv اور .xls فائلیں سپورٹ کی جاتی ہیں)",
  invalid_file_format_csv_xls: "فائل اپ لوڈ کریں۔ .xlsx غلط فائل فارمیٹ۔ براہ کرم .csv، .xls، یا",
  file_uploaded: "فائل اپ لوڈ ہو گئی",
  finished: "مکمل",
  entries_imported_successfully: "اندراجات کامیابی سے امپورٹ ہو گئے۔",
  entries_failed: "اندراجات ناکام ہوئے",
  item_discount: "آئٹم ڈسکاؤنٹ",
  remove_item: "آئٹم ہٹائیں",
  transaction_details: "ٹرانزیکشن کی تفصیلات",

  scan_and_pay: "اسکین اور ادائیگی",
  scan_qr: "اسکین کریں QR",
  bank_transfer: "بینک ٹرانسفر",
  transfer_to_this_iban: "پر ٹرانسفر کریں IBAN اس",
  transfer_exact_amount_shown_above: "اوپر دکھائی گئی صحیح رقم ٹرانسفر کریں",
  how_to_pay: "ادائیگی کا طریقہ",
  scan_step_1: "کوڈ اسکین کریں۔ QR اپنی بینکنگ ایپ یا والیٹ کھولیں اور اوپر دیا گیا",
  scan_step_2: "رقم Rs. {amount} کی تصدیق کریں اور ٹرانسفر کریں",
  scan_step_3: "پر کلک کریں۔ Pay",
  bank_step_1: "اپنی بینکنگ ایپ یا والیٹ کھولیں",
  bank_step_2: "اوپر دیے گئے IBAN پر صحیح رقم Rs. {amount} ٹرانسفر کریں",
  bank_step_3: "پر کلک کریں۔ Pay",
  payment_confirmation_sms_note: "پر ادائیگی کی تصدیق اور ٹرانزیکشن آئی ڈی موصول ہوگی SMS آپ کو اپنے",
  verify_payment: "ادائیگی کی تصدیق کریں",
  bill_payment_to: "بل کی ادائیگی بنام",
  payment_mode: "ادائیگی کا طریقہ",
  contact_support: "سپورٹ سے رابطہ کریں",
};
